app.controller('calendarController', ['$scope', '$mdDialog', '$modal', '$filter',
	'AppointmentAPI',
	'Session', 'patientId', 'CurrentPatient', 'PatientAPI', 'PracticeService', 'CALENDAR_SEEN', 'patientName', 'CALENDAR_CNA_DNA', 'selectedAppointment', '$state', 'TIMEZONE_TYPE', 'countryConfig', 'CALENDAR_AVAILABILITY_991', 'CALENDAR_ENHANCEMENT_976','$timeout','CALENDAR_PERSONAL_TEMPLATE_1257','ShareData','AppointmentLiveUpdateService','InvoiceLiveUpdateService','CalendarAvailabilityLiveUpdateService','ExceptionAPI','$q','BillingAPI','PRACTICE_PALETTE',
	function ($scope, $mdDialog, $modal, $filter, AppointmentAPI, Session, patientId, CurrentPatient, PatientAPI, PracticeService, CALENDAR_SEEN, patientName, CALENDAR_CNA_DNA, selectedAppointment, $state, TIMEZONE_TYPE, countryConfig, CALENDAR_AVAILABILITY_991, CALENDAR_ENHANCEMENT_976,$timeout,CALENDAR_PERSONAL_TEMPLATE_1257,ShareData,AppointmentLiveUpdateService,InvoiceLiveUpdateService,CalendarAvailabilityLiveUpdateService,ExceptionAPI,$q,BillingAPI,PRACTICE_PALETTE) {

		// $scope.selectedPatientId = patientId;
		// $scope.patientOptions = [];
		$scope.allAppointments = [];
		// The practice on screen's appointment types. The appointment dialog keeps a list of its own,
		// _appointment_categories, for the practice of the appointment it holds (loadPracticeCategories).
		$scope.appointment_categories = [];
		$scope._appointment_categories = [];
		$scope.ophthalmologists = [];
		$scope.CP = CurrentPatient;
		$scope.PA = PatientAPI;
		$scope.ShareDataService = ShareData;
		$scope.currentSurgeon = null;
		$scope.CALENDAR_SEEN = CALENDAR_SEEN;
		$scope.CALENDAR_CNA_DNA = CALENDAR_CNA_DNA;
		$scope.Session = Session;
		$scope.calendarAvailabilityEnabled = CALENDAR_AVAILABILITY_991;
		$scope.TIMEZONE_TYPE = TIMEZONE_TYPE;
		$scope.categoriesGroup = [];
		$scope.countryConfig = countryConfig;

		$scope.$ctrl = {};

		$scope.$mdDialog = $mdDialog;

		$scope.isPersonalCalendarEnabled = CALENDAR_PERSONAL_TEMPLATE_1257;

		// Colours handed out to clinicians and practices when the calendar is coloured by them rather
		// than by appointment type. Mid-tones, so the white event text stays readable on all of them.
		const CLINICIAN_PALETTE = ["#0035d2", "#00838f", "#8b56a3", "#d87d4a", "#2e7d32", "#ad1457",
			"#2072bb", "#6d4c41", "#00796b", "#5e35b1", "#c2410c", "#455a64"];
		const UNCOLOURED_EVENT = "#5b6b8c";
		// Appointment cards: a soft, solid tint of the type's colour - solid so sessions behind do not show
		// through - with dark text, and the full colour kept for the card's edge.
		const APPOINTMENT_TEXT = "#1f2a44";
		const CARD_TINT = 0.16;

		function cardTint(hex) {
			const match = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
			if (!match) {
				return "#eef1f7";
			}
			return "#" + [match[1], match[2], match[3]]
				.map((part) => Math.round(255 - (255 - parseInt(part, 16)) * CARD_TINT).toString(16).padStart(2, "0"))
				.join("");
		}

		// The views the toolbar offers. "team" is not a FullCalendar view - it is drawn by the
		// team-day-view component over a hidden agendaDay, which still does the navigating and fetching.
		$scope.VIEW_MODES = [
			{ key: "agendaDay", label: "Day" },
			{ key: "team", label: "Team" },
			{ key: "agendaWeek", label: "Week" },
			{ key: "month", label: "Month" },
			{ key: "listWeek", label: "Agenda" },
		];
		$scope.COLOUR_MODES = [
			{ key: "type", label: "Type" },
			{ key: "clinician", label: "Clinician" },
			{ key: "practice", label: "Practice" },
			{ key: "room", label: "Room" },
		];
		$scope.STATUS_GROUPS = [
			{ key: "booked", label: "Booked" },
			{ key: "arrived", label: "Waiting" },
			{ key: "in-progress", label: "With staff" },
			{ key: "done", label: "Seen" },
			{ key: "missed", label: "DNA / CNA" },
		];

		const savedPrefs = ShareData.savedCalendarFilters.viewPrefs || {};
		$scope.view = {
			mode: savedPrefs.mode || "agendaWeek",
			colourBy: savedPrefs.colourBy || "type",
			hideEmptyColumns: savedPrefs.hideEmptyColumns !== false,
			search: "",
			status: savedPrefs.status || null,
			title: "",
		};
		// Which clinicians are on screen when more than one is. currentSurgeon stays the single source of
		// truth for "one clinician" (booking, availability, printing); with currentSurgeon 'all' an empty
		// list means everyone and a non-empty one narrows the view to just those. none is everyone
		// unticked - the Everyone row clicked a second time.
		$scope.clinicianFilter = { ids: [], none: false };
		// Which practices are on screen when several are. Only means anything with "All practices"
		// (currentPractice -1) fetched - an empty list is all of them, a non-empty one narrows the view.
		// none is every practice unticked - "All practices" clicked a second time.
		$scope.practiceFilter = { ids: [], none: false };
		$scope.railClinicians = [];
		$scope.summary = { total: 0, groups: {}, byClinician: {} };
		$scope.teamModel = null;
		$scope.calendarNotice = null;
		$scope.awayToday = {};
		// Which room is on screen, when one is picked in the rail. Rooms belong to one practice, so this is
		// cleared whenever the practice changes.
		$scope.roomFilter = { id: null };
		// A move refused because its room was already in use, held so the notice can offer to make it anyway.
		$scope.roomMove = null;
		// The rooms the booking dialog offers, and who is in them on the dialog's day.
		$scope.modalRooms = [];
		$scope.modalRoomBookings = [];
		$scope.roomServerConflict = null;

		// The booking set aside to register its patient, now that they exist and the calendar is open for
		// them. Taken whenever the calendar opens, so one opened for anything else lets it go.
		// Opened from the surgery waitlist to book one eye's surgery (waitlistCalendarBooking puts it on the scope
		// it opens the calendar with): the calendar opens on that practice and surgeon, and closes with the
		// appointment once it is booked, for the eye's surgery date. Null when opened for anything else.
		const bookingFor = $scope.bookingFor || null;

		const awaiting = ShareData.takeBookingAwaitingPatient();
		let bookingToResume = awaiting && awaiting.patientId && String(awaiting.patientId) === String(patientId) ? awaiting : null;

		function toFullCalendarView(mode) {
			return mode === "team" ? "agendaDay" : mode;
		}

		// Opened to finish a booking - on that booking's day. Opened on one appointment - left to
		// revealAppointmentDay, once it has been fetched. Otherwise back on the range the calendar was
		// closed on (its start, with the remembered view mode, gives the same range); undefined is today.
		function openingDate() {
			if (bookingToResume) {
				return moment(bookingToResume._startDateStr, "DD/MM/YYYY").format("YYYY-MM-DD");
			}
			if (selectedAppointment) {
				return undefined;
			}
			return savedPrefs.date || undefined;
		}

		this.$onInit = function () {
			$scope.patientId = patientId;
			$scope.patientName = patientName;
			$scope.API = AppointmentAPI;
			$scope.eventSources = [];
			$scope.PracticeAPI = PracticeService;
			$scope.selectedAppointment = selectedAppointment;
			$scope.practiceSummaryList = [];
			$scope.currentPractice = { id: null, name: '', timezone: Session.practice.timezone };
			fetchDoctors();
			$scope.accessiblePractices = Session.practiceOptions.map(t=>({id:t.id,name:t.name}));
			subscribeToLiveAppointmentChanges();
			// $scope.fetchCalendarAvailability(Session.practice.id);

			$scope.uiConfig = {
				calendar: {
					editable: true,
					nowIndicator: true,
					selectable: true,
					selectHelper: true,
					// The toolbar is drawn by the template, so it can sit with the clinician and colour controls.
					header: false,
					timezone: "none",
					now: function () { return moment().tz($scope.resolvePracticeTimezoneName()); },
					defaultView: toFullCalendarView($scope.view.mode),
					defaultDate: openingDate(),
					columnHeaderHtml: columnHeaderHtml,
					scrollTime: "08:00:00",
					slotLabelInterval: "00:30:00",
					slotLabelFormat: "h:mm a",
					titleRangeSeparator: " – ",
					listDayFormat: "dddd",
					listDayAltFormat: "D MMMM YYYY",
					eventClick: $scope.alertOnEventClick,
					eventDrop: $scope.alertOnDrop,
					eventResize: $scope.alertOnResize,
					eventDragStart: startCalendarInteraction,
					eventDragStop: endCalendarInteraction,
					eventResizeStart: startCalendarInteraction,
					eventResizeStop: endCalendarInteraction,
					eventRender: $scope.eventRender,
					eventDestroy: eventDestroy,
					// No eventMouseout: the hover card is taken away in bindPopupCleanup instead.
					eventAfterAllRender: eventAfterAllRender,
					dayClick: $scope.dayClick,
					selectConstraint: "businessHours",
					eventConstraint: "businessHours",
					select: $scope.select,
					viewRender: viewRender,
					businessHours: {
						dow: [0, 1, 2, 3, 4, 5, 6],
						start: "7:00",
						end: "22:00",
					},
					slotDuration: "00:10:00",
					minTime: "07:00:00",
					maxTime: "22:15:00",
					allDaySlot: CALENDAR_ENHANCEMENT_976,
					eventLimit: 4,
					eventLimitText: "more",
					height: 'parent',
					views: {
						agendaDay: {
							titleFormat: "dddd D MMMM YYYY",
						},
						agendaWeek: {
							type: "agenda",
							duration: { days: 7 },
							buttonText: "week",
							titleFormat: "D MMM YYYY",
						},
						month: {
							titleFormat: "MMMM YYYY",
						},
						listWeek: {
							titleFormat: "D MMM YYYY",
						},
					},
				},
				calendarView: 'appointment',
			};
		};

		// Day headers as a small weekday over a large date, with today picked out - easier to scan
		// across a week than the old "Mon 06/Oct/26".
		function columnHeaderHtml(date) {
			if ($scope.view.mode === "month") {
				return `<span class="fc-col-weekday">${date.locale("en").format("ddd")}</span>`;
			}
			// The pill saying the clinician is away that day is added by decorateDayHeaders, once the
			// availability has arrived - headers are drawn before it does.
			const today = moment().tz($scope.resolvePracticeTimezoneName()).format("YYYY-MM-DD");
			const isToday = date.format("YYYY-MM-DD") === today;
			return `<span class="fc-col-weekday">${date.locale("en").format("ddd")}</span>`
				+ `<span class="fc-col-date${isToday ? " is-today" : ""}">${date.format("D")}</span>`
				+ `<span class="fc-col-month">${date.locale("en").format("MMM")}</span>`;
		}

		this.$onDestroy = function () {
			removePopup();
			if (viewRenderFetchTimer) {
				$timeout.cancel(viewRenderFetchTimer);
				viewRenderFetchTimer = null;
			}
			$timeout.cancel(fixBackgroundTimer);
		}


		function shouldRenderSavedUser() {
			return Session.user.roles.some((t) => ['PRACTICE_ADMIN','TECHNICIAN','ADMIN'].includes(t));
		}

		// Whatever was on screen when the calendar was last closed is what it opens on - practice, clinician
		// or clinicians, view and status chip - for everyone, not just admins. Only the ordering of the
		// clinician list by how often each is picked stays an admin thing (sortOphthalmologists).
		function renderLastFilters() {
			let saved = $scope.ShareDataService.savedCalendarFilters.practiceCache[Session.practice.id] || {};
			// Booking from the surgery waitlist: the practice picked there, on the entry's surgeon when they take
			// appointments at it, and everyone there when not.
			if (bookingFor) {
				const surgeon = $scope.ophthalmologists.find((t) => t.value == bookingFor.surgeonId
					&& (t.practiceSummaryList || []).some((p) => p.id === bookingFor.practiceId));
				saved = { practiceId: bookingFor.practiceId, userId: surgeon ? surgeon.value : "all" };
			}
			const savedPracticeId = saved.practiceId || Session.practice.id;
			const savedUserId = saved.userId || Session.userId;


			// Everyone at once was the last choice - restore that rather than falling back to the user.
			if (savedUserId === "all" && $scope.ophthalmologists.length > 0) {
				$scope.currentSurgeon = "all";
				// Several ticked rather than everyone - the same clinicians stay ticked.
				$scope.clinicianFilter.ids = (saved.clinicianIds || []).slice();
				$scope.clinicianFilter.none = !!saved.noClinicians;
				$scope.practiceSummaryList = buildPracticeList();
				const restored = $scope.practiceSummaryList.find((t) => t.id === savedPracticeId)
					|| $scope.practiceSummaryList.find((t) => t.id === Session.practice.id)
					|| $scope.practiceSummaryList.find((t) => t.id !== -1);
				if (restored) {
					$scope.currentPractice.id = restored.id;
					$scope.currentPractice.name = restored.name;
					$scope.currentPractice.timezone = restored.timezone;
				}
				return;
			}

			let target = $scope.ophthalmologists.find((t) => t.value == savedUserId);
			if (!target) {
				target = $scope.ophthalmologists.find((t) => t.value == Session.userId);
			}
			if (target) {
				$scope.currentSurgeon = target.value;
				$scope.practiceSummaryList = buildPracticeList();

				// The practice list only holds practices with the calendar feature - the appointment users
				// endpoint drops the rest. The practice being restored is whichever one was last looked at,
				// or simply the one the user is signed in to, and neither is guaranteed to still be among
				// them: the feature can be turned off, and signing in to a practice without a calendar
				// still lands here. Selecting one anyway asked the calendar endpoints about a practice they
				// refuse to answer for.
				const restoredPractice = $scope.practiceSummaryList.find((t) => t.id === savedPracticeId);
				const selectedPractice = restoredPractice || $scope.practiceSummaryList[0];

				if (selectedPractice) {
					// Name and timezone come from the practice actually selected. Taking them from the
					// session described the signed-in practice instead, so picking another one showed its
					// appointments under the wrong name, and at the wrong time of day.
					$scope.currentPractice.id = selectedPractice.id;
					$scope.currentPractice.name = selectedPractice.name;
					$scope.currentPractice.timezone = selectedPractice.timezone;
				}
			} else {
				// Nobody to single out - whoever is signed in does not take appointments themselves, so the
				// calendar opens on every clinician in the practice at once. That still needs a practice to
				// ask about, and the practice dropdown is no help here: it is built from the selected
				// clinician's practices and there is no clinician. The practice being looked at is the one
				// signed in to, and it is worth asking about whenever the calendar covers it - the practice
				// lists above hold only the practices that have the calendar feature.
				$scope.currentSurgeon = "all";

				const signedInPracticeHasCalendar = $scope.ophthalmologists.some((t) =>
					t.practiceSummaryList.some((p) => p.id === Session.practice.id)
				);

				if (signedInPracticeHasCalendar) {
					$scope.currentPractice.id = Session.practice.id;
					$scope.currentPractice.name = Session.practice.name;
					$scope.currentPractice.timezone = Session.practice.timezone;
				}
				$scope.practiceSummaryList = buildPracticeList();
				// The practice last looked at wins, when it is still on offer - "All practices" included.
				const restoredPractice = saved.practiceId
					? $scope.practiceSummaryList.find((t) => t.id === saved.practiceId)
					: null;
				const fallback = restoredPractice
					|| (!signedInPracticeHasCalendar && $scope.practiceSummaryList.find((t) => t.id !== -1));
				if (fallback) {
					$scope.currentPractice.id = fallback.id;
					$scope.currentPractice.name = fallback.name;
					$scope.currentPractice.timezone = fallback.timezone;
				}

				// Someone who takes no appointments of their own is most likely running the front desk,
				// which is what the team view is for - unless they have already picked a view.
				if (!ShareData.savedCalendarFilters.viewPrefs.mode) {
					$scope.setViewMode("team", { remember: false });
				}
			}
		}

		/**
		 * The practices the practice picker offers. One clinician: the practices they have a calendar at.
		 * Everyone: every practice any of the listed clinicians has one at, narrowed to those the signed-in
		 * user belongs to - the appointment query refuses the rest. An "All practices" entry leads when
		 * there is more than one. For the clinician selected, or for `surgeon` when given.
		 */
		function buildPracticeList(surgeon) {
			const forSurgeon = surgeon === undefined ? $scope.currentSurgeon : surgeon;
			let source = [];
			if (forSurgeon !== "all") {
				const target = $scope.ophthalmologists.find((t) => t.value == forSurgeon);
				source = target ? target.practiceSummaryList || [] : [];
			} else {
				const accessible = (Session.practiceOptions || []).map((p) => String(p.id));
				// The practices already on offer stay on offer. The clinicians loaded are only one practice's
				// once a practice has been clicked, so building from them alone dropped every other practice -
				// and "All practices" then loaded only those practices' clinicians.
				($scope.practiceSummaryList || []).forEach((p) => {
					if (p.id !== -1 && accessible.includes(String(p.id)) && !source.some((s) => s.id === p.id)) {
						source.push(p);
					}
				});
				$scope.ophthalmologists.forEach((doc) => {
					(doc.practiceSummaryList || []).forEach((p) => {
						if (accessible.includes(String(p.id)) && !source.some((s) => s.id === p.id)) {
							source.push(p);
						}
					});
				});
				source.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
			}

			if (source.length > 1 && CALENDAR_ENHANCEMENT_976) {
				return [{ id: -1, name: "All practices", timezone: Session.practice.timezone }, ...source];
			}
			return source;
		}

		function sortOphthalmologists(shouldRenderSavedUser) {
			if (shouldRenderSavedUser) {
				const userCache = $scope.ShareDataService.savedCalendarFilters.userCache;
				$scope.ophthalmologists.sort(function (a, b) {
					const left = userCache[a.value]?.weight || 0;
					const right = userCache[b.value]?.weight || 0;
					if (left < right) {
						return 1;
					}
					if (left > right) {
						return -1;
					}
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});
				return;
			}
			$scope.ophthalmologists.sort(function (a, b) {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			});
		}

		/**
		 * The clinicians at each of these practices, for the rail. Drawn straight away from the lists kept
		 * from earlier in the session (ShareData) when every one of them is there - onLists(lists, false) -
		 * and asked for again either way: onLists(lists, true) runs with the answer only if it differs from
		 * what was drawn, or onLists(lists, false) if nothing was. A practice whose request fails keeps its
		 * earlier list, or is null with none to keep.
		 */
		function loadClinicianLists(practiceIds, onLists) {
			const kept = practiceIds.map((id) => ShareData.getCalendarClinicians(id));
			const drawn = kept.every(Boolean);
			if (drawn) {
				// After the caller has returned, as it would be for a request.
				$q.resolve().then(() => onLists(kept, false));
			}
			return $q.all(practiceIds.map((id, index) => $scope.API.getAppointmentUsers(id).then(
				function (resp) {
					const list = resp.data || [];
					ShareData.setCalendarClinicians(id, list);
					return list;
				},
				function (err) {
					console.error(err && err.status);
					return kept[index];
				}
			))).then(function (lists) {
				if (!drawn) {
					onLists(lists, false);
				} else if (!angular.equals(lists, kept)) {
					onLists(lists, true);
				}
			});
		}

		function fetchDoctors() {
			// should render last saved practice id
			const _shouldRenderSavedUser = shouldRenderSavedUser();
			loadClinicianLists([Session.practice.id], function (lists, isRefresh) {
				const list = lists[0];
				if (isRefresh) {
					// Newer than the list drawn - unless another practice's clinicians have replaced it since.
					if ($scope.currentPractice.id === Session.practice.id) {
						$scope.ophthalmologists = list.map(toClinicianOption);
						sortOphthalmologists(_shouldRenderSavedUser);
						renderAppointmentEvents($scope.allAppointments || []);
					}
					return;
				}
				if (list) {
					$scope.ophthalmologists = list.map(toClinicianOption);
					sortOphthalmologists(_shouldRenderSavedUser);
					renderLastFilters();
					restorePracticeFilter();
				}
				fetchUserSettings();
				loadCliniciansForRestoredPractice();
			});
		}

		// The list above is the signed-in practice's clinicians, but the calendar can open on another one -
		// whichever was last looked at - and that practice's clinicians were only fetched once something was
		// clicked, so until then the list showed the wrong practice's people. Load them for the practice the
		// calendar actually opened on.
		function loadCliniciansForRestoredPractice() {
			const practiceId = $scope.currentPractice.id;
			if (practiceId === -1) {
				loadAllPracticeCategories();
				loadClinicianDirectory();
				return;
			}
			if (practiceId === null || practiceId === undefined || practiceId === Session.practice.id) {
				return;
			}
			loadClinicianLists([practiceId], function (lists) {
				if (practiceId !== $scope.currentPractice.id || !lists[0]) {
					return;
				}
				$scope.ophthalmologists = lists[0].map(toClinicianOption);
				sortOphthalmologists(false);
				renderAppointmentEvents($scope.allAppointments || []);
			});
		}
		function removeDuplicatedObj(arr) {
			return arr.filter((value, index, self) => index === self.findIndex((t) => (t.patient_id === value.patient_id)))
		}

		// An appointment's type, from its own practice's list when that has been loaded (the "all
		// practices" view mixes several), else from the practice being viewed.
		function categoryFor(categoryId, practiceId) {
			const group = practiceId !== undefined && $scope.categoriesGroup.find((g) => g.practice === practiceId);
			const list = group ? group.appointment_categories || [] : $scope.appointment_categories;
			return list.find((t) => t.category_id === categoryId);
		}

		// Colours are handed out by ascending id rather than by list position, so a clinician or practice
		// keeps the same colour from one day to the next however the list is sorted or filtered. Worked
		// out once per render, since the rail asks for them on every digest.
		let clinicianColours = {};
		let practiceColours = {};

		function refreshColourMaps() {
			clinicianColours = {};
			knownClinicianIds().forEach((id, index) => (clinicianColours[id] = CLINICIAN_PALETTE[index % CLINICIAN_PALETTE.length]));
			practiceColours = {};
			knownPracticeIds().forEach((id, index) => (practiceColours[id] = PRACTICE_PALETTE[index % PRACTICE_PALETTE.length]));
		}

		function knownClinicianIds() {
			const ids = $scope.ophthalmologists.map((t) => String(t.value));
			($scope.allAppointments || []).forEach((t) => {
				if (!ids.includes(String(t.clinician_id))) {
					ids.push(String(t.clinician_id));
				}
			});
			return ids.sort((a, b) => Number(a) - Number(b));
		}

		function knownPracticeIds() {
			const ids = ($scope.practiceSummaryList || []).filter((t) => t.id !== -1).map((t) => String(t.id));
			($scope.allAppointments || []).forEach((t) => {
				if (!ids.includes(String(t.practice_id))) {
					ids.push(String(t.practice_id));
				}
			});
			return ids.sort((a, b) => Number(a) - Number(b));
		}

		$scope.clinicianColour = function (clinicianId) {
			return clinicianColours[String(clinicianId)] || CLINICIAN_PALETTE[0];
		};

		$scope.practiceColour = function (practiceId) {
			return practiceColours[String(practiceId)] || PRACTICE_PALETTE[0];
		};

		$scope.categoryColour = function (categoryId, practiceId) {
			const category = categoryFor(categoryId, practiceId);
			return category && category.colour ? `#${category.colour}` : UNCOLOURED_EVENT;
		};

		$scope.roomColour = function (roomId, practiceId) {
			const room = roomFor(roomId, practiceId);
			return room && room.colour ? `#${room.colour}` : UNCOLOURED_EVENT;
		};

		function eventColour(item) {
			if ($scope.view.colourBy === "clinician") {
				return $scope.clinicianColour(item.clinician_id);
			}
			if ($scope.view.colourBy === "practice") {
				return $scope.practiceColour(item.practice_id);
			}
			if ($scope.view.colourBy === "room") {
				return $scope.roomColour(item.room_id, item.practice_id);
			}
			return $scope.categoryColour(item.category_id, item.practice_id);
		}

		/* =================================================================== */
		/* Rooms
		/* Each practice's rooms, loaded once per practice. Appointments name their room by id, and an
		/* archived room is still in the list, so an old booking can always show where it was.
		/* =================================================================== */

		const roomsByPractice = {};
		const NO_ROOM = { room_id: "", name: "No room", colour: null, is_active: true };

		function loadRooms(practiceId) {
			if (!practiceId || practiceId === -1) {
				return $q.resolve([]);
			}
			if (roomsByPractice[practiceId]) {
				return $q.resolve(roomsByPractice[practiceId]);
			}
			return PracticeService.getRooms(practiceId).then(
				function (response) {
					roomsByPractice[practiceId] = response.data || [];
					return roomsByPractice[practiceId];
				},
				function (error) {
					console.error("Rooms could not be loaded:", error && error.status);
					return [];
				},
			);
		}

		function roomFor(roomId, practiceId) {
			if (!roomId) {
				return null;
			}
			return (roomsByPractice[practiceId] || []).find((room) => room.room_id === roomId) || null;
		}

		// The rooms the rail offers: the current practice's active ones, plus the one picked if it has since
		// been archived. None in the "all practices" view - a room means nothing across practices.
		$scope.calendarRooms = function () {
			if ($scope.currentPractice.id === -1) {
				return [];
			}
			return (roomsByPractice[$scope.currentPractice.id] || [])
				.filter((room) => room.is_active || room.room_id === $scope.roomFilter.id);
		};

		$scope.roomFilterName = function () {
			const room = roomFor($scope.roomFilter.id, $scope.currentPractice.id);
			return room ? room.name : "";
		};

		$scope.selectRoom = function (roomId) {
			$scope.roomFilter.id = $scope.roomFilter.id === roomId ? null : roomId;
			renderAppointmentEvents($scope.allAppointments || []);
		};

		// The calendar's practice decides which rooms there are. Every practice's are loaded in the "all
		// practices" view, so its appointments can still name their rooms.
		$scope.$watch("currentPractice.id", function (practiceId, previousId) {
			if (practiceId !== previousId) {
				$scope.roomFilter.id = null;
			}
			const practiceIds = practiceId === -1
				? ($scope.practiceSummaryList || []).filter((t) => t.id !== -1).map((t) => t.id)
				: [practiceId];
			$q.all(practiceIds.map(loadRooms)).then(function () {
				// Nothing to redraw until the first appointments have arrived.
				if (($scope.allAppointments || []).length) {
					renderAppointmentEvents($scope.allAppointments);
				}
			});
		});

		// Appointments that share a room at the same time - double-booked knowingly, or by two people at
		// once. Live cancellations don't count: nobody is coming.
		let roomClashes = {};

		function findRoomClashes(data) {
			const clashes = {};
			const byRoom = {};
			data.forEach(function (item) {
				const seen = item.patient_seen || {};
				if (!item.room_id || seen.did_not_attend || seen.could_not_attend) {
					return;
				}
				const key = `${item.practice_id}|${item.room_id}`;
				(byRoom[key] = byRoom[key] || []).push({
					id: item.patient_appointment_id,
					start: moment.utc(item.start_date_utc),
					end: moment.utc(item.start_date_utc).add(item.duration_minutes, "minutes"),
				});
			});
			Object.keys(byRoom).forEach(function (key) {
				const bookings = byRoom[key];
				bookings.forEach(function (a, index) {
					bookings.slice(index + 1).forEach(function (b) {
						if (a.start.isBefore(b.end) && b.start.isBefore(a.end)) {
							clashes[a.id] = true;
							clashes[b.id] = true;
						}
					});
				});
			});
			return clashes;
		}

		function getInvoiceState(invoiceList) {
			if (!invoiceList || invoiceList.length === 0) {
				return null;
			}
			if (invoiceList.some((t) => t.status === "DRAFT")) {
				return "draft";
			} else if (invoiceList.some((t) => t.status === "SUBMITTED")) {
				return "pending";
			} else if (invoiceList.every((t) => t.status === "PAID")) {
				return "paid";
			}
			return null;
		}

		const INVOICE_LABELS = { draft: "Invoice draft", pending: "Invoice awaiting payment", paid: "Invoice paid" };

		const STAFF_ROLES = [
			{ key: "doctor", label: "doctor" },
			{ key: "optometrist", label: "optometrist" },
			{ key: "orthoptist", label: "orthoptist" },
			{ key: "nurse", label: "nurse" },
			{ key: "technician", label: "technician" },
		];

		/**
		 * Where the patient is in their visit, read from the progress ticks. `group` is one of
		 * STATUS_GROUPS and drives the colouring and the summary counts; `label` is the short wording on
		 * the event itself (none while simply booked, so an untouched day stays quiet).
		 */
		function appointmentStatus(seen) {
			if (!seen) {
				return { group: "booked", label: null };
			}
			if (seen.did_not_attend) {
				return { group: "missed", label: seen.rebooked ? "DNA · rebooked" : "DNA" };
			}
			if (seen.could_not_attend) {
				return { group: "missed", label: seen.rebooked ? "CNA · rebooked" : "CNA" };
			}
			if (seen.departed) {
				return { group: "done", label: "Departed" };
			}
			const withStaff = STAFF_ROLES.find((role) => seen[`${role.key}_started`] && !seen[`${role.key}_finished`]);
			if (withStaff) {
				return { group: "in-progress", label: `With ${withStaff.label}` };
			}
			if (seen.doctor_finished) {
				return { group: "done", label: "Seen" };
			}
			if (seen.arrived || STAFF_ROLES.some((role) => seen[`${role.key}_finished`])) {
				return { group: "arrived", label: "Waiting" };
			}
			return { group: "booked", label: null };
		}
		$scope.appointmentStatus = appointmentStatus;

		$scope.isClinicianShown = function (clinicianId) {
			if ($scope.currentSurgeon !== "all") {
				return String($scope.currentSurgeon) === String(clinicianId);
			}
			if ($scope.clinicianFilter.none) {
				return false;
			}
			const ids = $scope.clinicianFilter.ids;
			return ids.length === 0 || ids.some((id) => String(id) === String(clinicianId));
		};

		$scope.isPracticeShown = function (practiceId) {
			// One practice - which can be drawn from the "all practices" list already loaded, so the others'
			// appointments are left out here rather than by the fetch.
			if ($scope.currentPractice.id !== -1) {
				return String($scope.currentPractice.id) === String(practiceId);
			}
			if ($scope.practiceFilter.none) {
				return false;
			}
			const ids = $scope.practiceFilter.ids;
			return ids.length === 0 || ids.some((id) => String(id) === String(practiceId));
		};

		// An appointment is on screen when both its clinician and its practice are ticked, and it is in the
		// room picked, if one is.
		function isAppointmentShown(item) {
			return $scope.isClinicianShown(item.clinician_id) && $scope.isPracticeShown(item.practice_id)
				&& (!$scope.roomFilter.id || item.room_id === $scope.roomFilter.id);
		}

		function matchesSearch(item) {
			const term = ($scope.view.search || "").trim().toLowerCase();
			if (!term) {
				return true;
			}
			const category = categoryFor(item.category_id, item.practice_id);
			return [item.patient_name, item.note, category && category.name]
				.some((value) => value && String(value).toLowerCase().indexOf(term) !== -1);
		}

		// Searching and the status chips dim what does not match rather than hiding it, so the day keeps
		// its shape and the gaps around a match still read as gaps.
		function isDimmed(item, status, clash, roomClash) {
			if (!matchesSearch(item)) {
				return true;
			}
			if ($scope.view.status === "clash") {
				return !clash;
			}
			if ($scope.view.status === "room-clash") {
				return !roomClash;
			}
			return !!$scope.view.status && status.group !== $scope.view.status;
		}

		// The leave an appointment falls in, if its clinician's leave is known: a booking that someone
		// needs to move or cover. Live cancellations (DNA/CNA) are not clashes - nobody is coming.
		function leaveClash(item) {
			const seen = item.patient_seen || {};
			if (seen.did_not_attend || seen.could_not_attend || $scope.currentPractice.id === -1) {
				return null;
			}
			const start = moment.utc(item.start_date_utc).tz(getPracticeTimezoneNameForItem(item));
			const wallStart = moment(start.format("YYYY-MM-DDTHH:mm:ss"));
			const wallEnd = wallStart.clone().add(item.duration_minutes, "minutes");
			return awayDuring(item.clinician_id, wallStart, wallEnd) || null;
		}

		function toCalendarEvent(item) {
			// Choose the correct timezone for this item (per-practice when viewing "All", otherwise the current practice)
			var itemTimezoneName = getPracticeTimezoneNameForItem(item);

			// Convert stored UTC instant → practice wall time of the chosen timezone
			var startInPracticeTz = moment.utc(item.start_date_utc).tz(itemTimezoneName);
			var endInPracticeTz = startInPracticeTz.clone().add(item.duration_minutes, 'minutes');

			const status = appointmentStatus(item.patient_seen);
			const colour = eventColour(item);
			const clash = leaveClash(item);
			const roomClash = !!roomClashes[item.patient_appointment_id];
			const classNames = ["notranslate", "appt", `appt-status-${status.group}`];
			if (clash) {
				classNames.push("appt-clash");
			}
			if (roomClash) {
				classNames.push("appt-room-clash");
			}
			if (isDimmed(item, status, clash, roomClash)) {
				classNames.push("appt-dimmed");
			}

			const event = {
				title: item.patient_name,
				className: classNames,
				id: item.patient_appointment_id,
				invoice: getInvoiceState(item.invoice_list),
				status: status,
				clash: clash,
				roomClash: roomClash,
				room: roomFor(item.room_id, item.practice_id),
				appointment: angular.copy(item),
				// Naive local-like strings so FullCalendar places them exactly at that wall time
				start: startInPracticeTz.format('YYYY-MM-DDTHH:mm:ss'),
				end: endInPracticeTz.format('YYYY-MM-DDTHH:mm:ss'),
				backgroundColor: cardTint(colour),
				borderColor: colour,
				textColor: APPOINTMENT_TEXT,
				accent: colour,
			};
			// A booking still on its way to the server stays put until it has an id to save a move against.
			if (isUnsavedId(item.patient_appointment_id)) {
				event.editable = false;
			}
			return event;
		}

		// In the "all practices" view, a banner per practice per day across the top of the week, so a
		// clinician working at several sites can see where they are each day before reading a single
		// appointment. Every practice with something that day gets one - not just the first.
		function buildPracticeDayEvents(data) {
			const seen = {};
			const result = [];
			data.forEach(function (t) {
				const day = moment.utc(t.start_date_utc).tz(getPracticeTimezoneNameForItem(t)).format("YYYY-MM-DD");
				const key = `${day}|${t.practice_id}`;
				if (seen[key]) {
					return;
				}
				seen[key] = true;
				const practice = $scope.practiceSummaryList.find((x) => x.id === t.practice_id);
				const colour = $scope.practiceColour(t.practice_id);
				result.push({
					title: practice ? practice.name : t.practice_name || "Practice",
					className: ["notranslate", "practice-day"],
					start: day,
					allDay: true,
					editable: false,
					backgroundColor: colour,
					borderColor: colour,
				});
			});
			return result;
		}

		// Counts for the summary chips and the clinician rail. The rail counts ignore the clinician
		// filter - they are what you would get by ticking someone - while the chips count what is shown.
		// Both leave out practices that are unticked.
		function summariseAppointments(data) {
			const summary = { total: 0, groups: {}, byClinician: {}, clashes: 0, roomClashes: 0 };
			$scope.STATUS_GROUPS.forEach((g) => (summary.groups[g.key] = 0));
			data.forEach((item) => {
				if (!$scope.isPracticeShown(item.practice_id)) {
					return;
				}
				summary.byClinician[item.clinician_id] = (summary.byClinician[item.clinician_id] || 0) + 1;
				if (!$scope.isClinicianShown(item.clinician_id)) {
					return;
				}
				if ($scope.roomFilter.id && item.room_id !== $scope.roomFilter.id) {
					return;
				}
				summary.total++;
				summary.groups[appointmentStatus(item.patient_seen).group]++;
				if (leaveClash(item)) {
					summary.clashes++;
				}
				if (roomClashes[item.patient_appointment_id]) {
					summary.roomClashes++;
				}
			});
			if (!summary.clashes && $scope.view.status === "clash") {
				$scope.view.status = null;
			}
			if (!summary.roomClashes && $scope.view.status === "room-clash") {
				$scope.view.status = null;
			}
			$scope.summary = summary;
		}

		// The clinicians the rail lists: everyone the practice offers, plus anyone else who turns up in the
		// appointments fetched (the "all practices" view can bring in clinicians from other practices).
		// With only some practices ticked, just the clinicians who work at one of them.
		function buildRailClinicians() {
			const list = $scope.ophthalmologists
				.filter((t) => $scope.currentPractice.id !== -1
					|| ($scope.practiceFilter.ids.length === 0 && !$scope.practiceFilter.none)
					|| (t.practiceSummaryList || []).some((p) => $scope.isPracticeShown(p.id)))
				.map((t) => ({ id: t.value, name: t.name }));
			($scope.allAppointments || []).forEach((t) => {
				if (!$scope.isPracticeShown(t.practice_id)) {
					return;
				}
				if (!list.some((c) => String(c.id) === String(t.clinician_id))) {
					list.push({ id: t.clinician_id, name: t.clinician_name || "Clinician" });
				}
			});
			$scope.railClinicians = list;
		}

		function renderAppointmentEvents(data) {
			refreshColourMaps();
			// What is loaded is for something else - the appointments for what is now ticked are on their way
			// (or waiting on the practice's appointment types first), and filtering what is here would empty
			// the grid until they land. The rail is brought up to date; the grid, team view and counts stay as
			// they were, under the loading bar.
			if (loadedAppointments && !loadedAppointmentsCover(appointmentRequest())) {
				buildRailClinicians();
				return;
			}
			roomClashes = findRoomClashes(data);
			const appointmentEvents = data.map(toCalendarEvent);
			const shownAppointments = data.filter(isAppointmentShown);
			const practiceDayEvents = $scope.currentPractice.id === -1 ? buildPracticeDayEvents(shownAppointments) : [];

			// $scope.events keeps every fetched appointment, so opening one by id (a live update, the
			// appointment the calendar was opened on) works whichever clinicians are ticked. FullCalendar
			// and the team view are given only the clinicians on screen.
			$scope.events = [].concat(appointmentEvents, practiceDayEvents, buildAvailabilityEvents(appointmentEvents), buildHolidayEvents(), buildPracticeLeaveEvents());
			$scope.visibleEvents = $scope.events.filter((t) => !t.appointment || isAppointmentShown(t.appointment));
			$scope.eventSources = [$scope.visibleEvents];

			summariseAppointments(data);
			buildRailClinicians();
			$scope.typeLegend = buildTypeLegend();
			buildTeamModel();
			drawCalendarEvents();
			resumeBookingForNewPatient();
		}

		// FullCalendar ends a drag or resize with no drop - no eventDrop, nothing saved, no error - when its
		// events are redrawn under it (executeEventUnrender ends every interaction). Live updates redraw
		// whenever anything changes, including the echo of the user's own last move a few seconds later, so
		// a redraw that lands mid-drag waits until the drag is over.
		let calendarInteraction = false;
		let calendarRedrawHeld = false;

		function drawCalendarEvents() {
			if (calendarInteraction) {
				calendarRedrawHeld = true;
				return;
			}
			$scope.eventSources = [$scope.visibleEvents];
			$scope.refreshCalendars();
		}

		function startCalendarInteraction() {
			calendarInteraction = true;
		}

		function endCalendarInteraction() {
			// Later, so eventDrop / eventResize - which FullCalendar calls straight after the stop - go first.
			$timeout(function () {
				calendarInteraction = false;
				// The copy FullCalendar draws under the pointer while dragging is taken away with no mouseleave
				// and no eventDestroy, so a hover card it showed - naming the time it was dragged over - would
				// otherwise stay on screen after a drag that moved nothing.
				removePopup();
				if (calendarRedrawHeld) {
					calendarRedrawHeld = false;
					drawCalendarEvents();
				}
			}, 0);
		}

		// Opens the set-aside booking again, for the patient just registered, once the calendar has loaded
		// its appointments. The booking reloads its own practice's clinicians and types, keeping the ones
		// chosen, so it does not matter which practice the calendar opened on.
		function resumeBookingForNewPatient() {
			if (!bookingToResume || !$scope.allAppointments || $scope.detailsModal) {
				return;
			}
			const booking = bookingToResume;
			bookingToResume = null;

			const start = moment(`${booking._startDateStr} ${booking.selectedTimeSlot}`, "DD/MM/YYYY HH:mm");
			if (!start.isValid()) {
				return;
			}
			openBookingModal(start, start.clone().add(booking.duration_minutes || 15, "minutes"), booking.clinician_id);
			Object.assign($scope.appointment, {
				clinician_id: booking.clinician_id,
				category_id: booking.category_id,
				note: booking.note,
				do_not_send_auto_reminders: booking.do_not_send_auto_reminders,
			});
			if (booking.practice_id) {
				$scope.appointment.practice_id = booking.practice_id;
				// The type was chosen for this practice, so it is kept - and checked against its list.
				$scope.onAppointmentPracticeChange($scope.appointment, true);
			}
		}

		// Appointment types for the rail's key. In the "all practices" view, types from each practice,
		// with same-named ones of the same colour shown once.
		function buildTypeLegend() {
			const lists = $scope.currentPractice.id === -1
				? $scope.categoriesGroup
					.filter((g) => $scope.practiceSummaryList.some((p) => p.id === g.practice) && $scope.isPracticeShown(g.practice))
					.map((g) => g.appointment_categories || [])
				: [$scope.appointment_categories || []];
			const legend = [];
			lists.forEach((list) => list.forEach((t) => {
				if (!legend.some((l) => l.name === t.name && l.colour === t.colour)) {
					legend.push({ name: t.name, colour: t.colour });
				}
			}));
			return legend;
		}

		// One redraw per tick, however many asked for one: it draws $scope.visibleEvents as they are when it runs.
		let calendarRefreshQueued = false;
		// The team view covers FullCalendar, so its redraws wait until it is shown again (setViewMode).
		let calendarStaleBehindTeam = false;

		$scope.refreshCalendars = () => {
			if (calendarRefreshQueued) {
				return;
			}
			calendarRefreshQueued = true;
			$timeout(() => {
				calendarRefreshQueued = false;
				// A drag started since this was asked for - see drawCalendarEvents.
				if (calendarInteraction) {
					calendarRedrawHeld = true;
					return;
				}
				if ($scope.view.mode === "team") {
					calendarStaleBehindTeam = true;
					return;
				}
				calendarStaleBehindTeam = false;
				withCalendarInDigest((calendar) => {
					// The old list's source goes with it. removeEvents only emptied the sources, so every redraw
					// added one more and FullCalendar went on fetching them all on each change of dates.
					calendar.fullCalendar("removeEventSources");
					calendar.fullCalendar("addEventSource", $scope.visibleEvents || []);
				});
			}, 0, false);
		};

		/* =================================================================== */
		/* Team view
		/* =================================================================== */

		/**
		 * One column per clinician for the day on screen. A single clinician gets a single column; a
		 * hand-picked set or "everyone" gets only those with something booked that day while
		 * hideEmptyColumns is on - a practice can have more clinicians than fit across the screen.
		 */
		function buildTeamModel() {
			if ($scope.view.mode !== "team" || !$scope.startDate) {
				$scope.teamModel = null;
				$scope.awayToday = {};
				return;
			}
			const day = moment($scope.startDate).format("YYYY-MM-DD");
			const dayAppointments = ($scope.events || []).filter((t) => t.appointment && String(t.start).indexOf(day) === 0
				&& $scope.isPracticeShown(t.appointment.practice_id));

			// Who is away today, for the column blocks, the headers and the rail.
			ensureTeamAvailability();
			const awayByClinician = {};
			const sessionsByClinician = {};
			$scope.awayToday = {};
			if ($scope.currentPractice.id !== -1) {
				$scope.railClinicians.forEach((c) => {
					const rows = availabilityRowsFor(c.id);
					const { away, sessions } = rows ? availabilityOn(rows, day) : { away: [], sessions: [] };
					// Sessions under whole-day leave are not on offer, so they are not drawn.
					if (sessions.length && !away.some((block) => block.allDay)) {
						sessionsByClinician[c.id] = sessions;
					}
					if (away.length) {
						awayByClinician[c.id] = away;
						$scope.awayToday[c.id] = { range: awayRangeLabel(away), full: away.map(awayLabel).join("; ") };
					}
				});
			}

			let clinicians;
			let shownClinicians = [];
			if ($scope.currentSurgeon !== "all") {
				clinicians = $scope.railClinicians.filter((c) => String(c.id) === String($scope.currentSurgeon));
			} else {
				// Only clinicians actually working that day - someone with nothing booked is a column of
				// empty space, whether or not they have time off. The rail still says who is unavailable.
				shownClinicians = $scope.railClinicians.filter((c) => $scope.isClinicianShown(c.id));
				clinicians = shownClinicians.filter((c) => !$scope.view.hideEmptyColumns
					|| dayAppointments.some((t) => String(t.appointment.clinician_id) === String(c.id)));
			}

			const columns = clinicians.map((c) => {
				const events = dayAppointments
					.filter((t) => String(t.appointment.clinician_id) === String(c.id))
					.map((t) => Object.assign({ clash: leaveClash(t.appointment) }, t))
					.map((t) => ({
						id: t.id,
						title: t.title,
						start: moment(t.start),
						end: moment(t.end),
						colour: t.accent,
						tint: t.backgroundColor,
						status: t.status,
						clash: t.clash,
						roomClash: t.roomClash,
						room: t.room,
						invoice: t.invoice,
						invoiceLabel: t.invoice ? INVOICE_LABELS[t.invoice] : null,
						// Other clinicians' leave arrives after the grid was drawn, so "booked during leave" is
						// judged here rather than read from the grid's classes.
						dimmed: $scope.view.status === "clash"
							? (!t.clash || !matchesSearch(t.appointment))
							: t.className.indexOf("appt-dimmed") !== -1,
						typeName: (categoryFor(t.appointment.category_id, t.appointment.practice_id) || {}).name,
						practiceName: t.appointment.practice_name,
						practiceColour: $scope.practiceColour(t.appointment.practice_id),
						appointment: t.appointment,
					}));
				const away = awayByClinician[c.id] || [];
				const busy = events.map((ev) => ({
					startMin: ev.start.hours() * 60 + ev.start.minutes(),
					endMin: ev.end.isSame(ev.start, "day") ? ev.end.hours() * 60 + ev.end.minutes() : 24 * 60,
				}));
				return {
					id: c.id,
					name: c.name,
					colour: $scope.clinicianColour(c.id),
					count: events.length,
					events: events,
					away: away.map((block) => ({ startMin: block.startMin, endMin: block.endMin, allDay: block.allDay, label: awayLabel(block) })),
					sessions: (sessionsByClinician[c.id] || []).map((block) => ({
						startMin: block.startMin,
						endMin: block.endMin,
						label: sessionLabel(block),
						labelOffset: freeLabelOffset(block, busy),
						tooltip: sessionTooltip(block),
						colour: sessionColour(block),
						tint: tint(sessionColour(block), 0.07),
					})),
					awayAllDay: away.some((block) => block.allDay),
					awayShort: away.length ? awayShortLabel(away) : null,
				};
			});

			const [minH, minM] = $scope.uiConfig.calendar.minTime.split(":").map(Number);
			const [maxH, maxM] = $scope.uiConfig.calendar.maxTime.split(":").map(Number);
			$scope.teamModel = {
				day: day,
				isToday: day === moment().tz($scope.resolvePracticeTimezoneName()).format("YYYY-MM-DD"),
				timezone: $scope.resolvePracticeTimezoneName(),
				startMinutes: minH * 60 + minM,
				endMinutes: maxH * 60 + maxM,
				showPractice: $scope.currentPractice.id === -1,
				holidays: holidaysOn(day).map((t) => t.label),
				columns: columns,
				hiddenCount: $scope.currentSurgeon === "all" ? shownClinicians.length - columns.length : 0,
			};
		}

		// With no patient the booking asks who it is for (the patient picker), and with every practice on
		// screen it asks which practice - so only some practice to work from is needed.
		$scope.canBook = function () {
			return $scope.currentPractice.id !== null && $scope.currentPractice.id !== undefined;
		};

		// A click in the empty part of a clinician's column books that clinician at that time.
		$scope.onTeamSlot = function (clinicianId, startTime, durationMinutes) {
			const day = moment($scope.teamModel.day, "YYYY-MM-DD");
			const [h, m] = startTime.split(":").map(Number);
			// Built from an array, as FullCalendar's own selections are, so it reads as practice wall time.
			const start = moment([day.year(), day.month(), day.date(), h, m]);
			const end = start.clone().add(durationMinutes, "minutes");
			const validationError = getValidationError(start, end);
			if (validationError) {
				showValidationError(validationError);
				return;
			}
			openBookingModal(start, end, clinicianId);
		};

		// An appointment dragged to another time, or into another clinician's column. The time is practice
		// wall time on the day shown, converted in the appointment's own practice's zone as a drop in the
		// other views is. Shown there at once and saved - put back if the server refuses.
		$scope.onTeamMove = function (appointmentId, clinicianId, startTime) {
			const event = ($scope.events || []).find((t) => t.id === appointmentId);
			if (!event || !event.appointment || isUnsavedId(appointmentId)) {
				return;
			}
			const day = moment($scope.teamModel.day, "YYYY-MM-DD");
			const [h, m] = startTime.split(":").map(Number);
			const wallTime = moment([day.year(), day.month(), day.date(), h, m]);
			const startUtcIso = toUtcIsoFromPracticeWallTime(wallTime, getPracticeTimezoneNameForItem(event.appointment));
			if (startUtcIso === "Invalid date") {
				return;
			}
			if (moment(startUtcIso).isBefore(moment.utc().subtract(7, "d"))) {
				showValidationError("Cannot move appointments more than 7 days into the past.");
				return;
			}

			const appointment = { ...event.appointment, start_date_utc: startUtcIso };
			if (String(clinicianId) !== String(event.appointment.clinician_id)) {
				const clinician = $scope.railClinicians.find((c) => String(c.id) === String(clinicianId));
				appointment.clinician_id = clinician ? clinician.id : clinicianId;
				// The rail marks the signed-in user's own name with "(Me)" - not part of the name to save.
				appointment.clinician_name = clinician ? clinician.name.replace(/ \(Me\)$/, "") : appointment.clinician_name;
			}

			const change = showLocalChange(appointment.patient_appointment_id, appointment, appointmentInList(appointment.patient_appointment_id));
			$scope.API.updateAppointment(appointment.patient_id, appointment.patient_appointment_id, appointment, appointment.practice_id)
				.then(
					function (resp) {
						localChangeSaved(change, resp.data);
					},
					function (error) {
						localChangeFailed(change);
						if (offerMoveOverride(error, appointment)) {
							return;
						}
						// Most likely the clinician has no calendar at the appointment's practice.
						showValidationError("That appointment could not be moved there.");
					}
				);
		};

		$scope.onTeamOpen = function (appointmentId) {
			$scope.alertOnEventClick({ id: appointmentId });
		};

		$scope.onTeamPatient = function (appointment) {
			$scope.forwardPatientDashboard(appointment);
		};

		// Settles once the appointment types last asked for have arrived (or failed). Appointments fetched
		// alongside them wait for it before they are drawn, so they are coloured by type from the start -
		// though not for longer than CATEGORIES_WAIT_MS (see withCategories).
		let categoriesReady = $q.resolve();

		const queryCalendarSetting = (isFetchAppointment = false) => {
			$scope.PracticeAPI.isProcessing = true;
			// Cache under the practice that was asked about: the selection can change while this is in flight.
			const requestedPracticeId = $scope.currentPractice.id;
			const categoriesRequest = $scope.PracticeAPI.queryCalendarSetting(requestedPracticeId)
				.then(
					function (resp) {
						const categories = angular.copy(resp.data.appointment_categories);
						$scope.categoriesGroup.push({
							practice: requestedPracticeId,
							appointment_categories: categories,
						});
						if (requestedPracticeId === $scope.currentPractice.id) {
							$scope.appointment_categories = angular.copy(categories);
						}
					},
					function (error) {
						console.error(error && error.status);
					}
				);
			// Its own branch, so a failure in what follows is still reported as it was.
			categoriesReady = categoriesRequest.catch(angular.noop);
			categoriesRequest
				.then(function () {
					$scope.PracticeAPI.isProcessing = false;
					$scope.fetchCalendarAvailability($scope.currentPractice.id);
					if (isFetchAppointment) {
						// Joins the fetch started below when it is still out; otherwise draws what it brought.
						fetchPatientAppointments({ joinInFlight: true });
					}
				});
			if (isFetchAppointment) {
				// Alongside the types rather than after them - the appointment query is the slow one.
				fetchPatientAppointments({ joinInFlight: true });
			}
		};


		function fetchUserSettings() {
			const target = $scope.categoriesGroup.find((t) => t.practice === $scope.currentPractice.id);
			if (target) {
				$scope.appointment_categories = angular.copy(target.appointment_categories);
				fetchPatientAppointments({ joinInFlight: true });
				return;
			}
			queryCalendarSetting(true);
		}

		$scope.calendar_range_start = null;
		$scope.calendar_range_end = null;

		// The "all practices" view fires one appointment query per practice. Each of those runs the
		// Xero invoice decoration on the back end, and practices sharing a Xero organisation share
		// its rate limit - so firing them all at once made the practices throttle each other into
		// timeouts. Capped at 3 in flight; the rest queue behind whichever finishes first.
		const MAX_CONCURRENT_PRACTICE_QUERIES = 3;

		// $q throughout, not native promises: a native .then resolves in a microtask after the digest
		// that settled the underlying $http call, so everything it assigns ($scope.allAppointments, the
		// isProcessing spinner) sits unrendered until something else kicks a digest off.
		function queryPracticesWithLimit(surgeon, practiceIds) {
			const results = new Array(practiceIds.length);
			let next = 0;

			function worker() {
				if (next >= practiceIds.length) {
					return $q.resolve();
				}
				const index = next++;
				return $scope.API.queryPatientAppointment(surgeon, $scope.calendar_range_start, $scope.calendar_range_end, practiceIds[index])
					.then(function (resp) {
						results[index] = resp;
					}, function () {
						// One practice failing (a Xero timeout, say) used to stop this worker and reject the
						// lot, blanking every practice. The rest are still shown, and the notice says so.
						results[index] = { data: [] };
						showValidationError("Some practices' appointments could not be loaded. Try again shortly.");
					})
					.then(worker);
			}

			const workers = [];
			for (let i = 0; i < Math.min(MAX_CONCURRENT_PRACTICE_QUERIES, practiceIds.length); i++) {
				workers.push(worker());
			}
			return $q.all(workers).then(function () {
				return results;
			});
		}

		// Every practice's appointments in one request: the back end checks the user and reads each practice's
		// appointments and invoices once, rather than once per request. Falls back to a request per practice
		// while a back end without the combined endpoint is still deployed - remove queryPracticesWithLimit
		// once it is everywhere.
		function queryAllPractices(surgeon, practiceIds) {
			if (practiceIds.length === 0) {
				return $q.resolve([]);
			}
			return $scope.API.queryPracticesAppointments(surgeon, $scope.calendar_range_start, $scope.calendar_range_end, practiceIds)
				.then(
					(resp) => resp.data || [],
					(error) => {
						if (error && (error.status === 404 || error.status === 405)) {
							return queryPracticesWithLimit(surgeon, practiceIds)
								.then((values) => values.reduce((all, v) => all.concat((v && v.data) || []), []));
						}
						return $q.reject(error);
					}
				);
		}

		// Increments per fetch, so a response landing after a newer fetch has started (the ranges
		// changed under it, or the debounce let two through around another trigger) is dropped rather
		// than drawn over the newer view's appointments.
		let fetchSequence = 0;

		// What $scope.allAppointments was fetched for - the practices, the clinician ('' for everyone) and
		// the range - and when. Picking or ticking clinicians and practices inside that filters what is
		// already here rather than fetching again: the appointment query is the slow one, as every
		// appointment has its Xero invoice details added under a rate limit.
		let loadedAppointments = null;
		// Fetches still out. A filter change never renders from a list that is about to be replaced.
		let appointmentFetchesInFlight = 0;
		// How long a loaded list is reused without asking again. Older than this it is still drawn at once
		// and refreshed underneath. Live updates keep the signed-in practice current in between.
		const APPOINTMENT_REUSE_MS = 2 * 60 * 1000;

		function appointmentRequest() {
			const practiceId = $scope.currentPractice.id;
			return {
				practiceId: practiceId,
				practiceIds: practiceId === -1
					? $scope.practiceSummaryList.filter((t) => t.id !== -1).map((t) => t.id)
					: [practiceId],
				surgeon: $scope.currentSurgeon === "all" ? "" : $scope.currentSurgeon,
				start: $scope.calendar_range_start,
				end: $scope.calendar_range_end,
			};
		}

		// Nothing to show for what is ticked - no practice to ask about, or the fetch failed. Cleared rather
		// than left up, as what was loaded belongs to the previous selection.
		function forgetLoadedAppointments() {
			loadedAppointments = null;
			$scope.allAppointments = [];
			renderAppointmentEvents($scope.allAppointments);
		}

		function loadedAppointmentsCover(request) {
			const loaded = loadedAppointments;
			return !!loaded && loaded.start === request.start && loaded.end === request.end
				&& (loaded.surgeon === "" || String(loaded.surgeon) === String(request.surgeon))
				&& request.practiceIds.every((id) => loaded.practiceIds.some((t) => String(t) === String(id)));
		}

		// The newest appointment fetch, while it is out - { id, request }.
		let appointmentFetchOut = null;

		function isSameAppointmentRequest(a, b) {
			return a.practiceId === b.practiceId && String(a.surgeon) === String(b.surgeon)
				&& a.start === b.start && a.end === b.end
				&& a.practiceIds.length === b.practiceIds.length
				&& a.practiceIds.every((id, index) => String(id) === String(b.practiceIds[index]));
		}

		// options.fresh: something was just saved, so what is loaded is out of date - always fetch.
		// options.joinInFlight: when the newest fetch still out is for exactly this, leave it to that one rather
		// than start again. As the calendar opens, the first range drawn and the appointment types arriving
		// both ask for the same appointments. Not for anything after a save - a fetch already out can predate it.
		function _fetchPatientAppointments(options) {
			// No practice to ask about - the surgeon has none with a calendar. Asking anyway falls back to
			// the signed-in practice, which is the one that has no calendar in the first place.
			if ($scope.currentPractice.id === null || $scope.currentPractice.id === undefined) {
				$scope.loaded = true;
				forgetLoadedAppointments();
				return;
			}

			let request = appointmentRequest();
			if (options && options.joinInFlight && !options.fresh && appointmentFetchOut
				&& isSameAppointmentRequest(appointmentFetchOut.request, request)) {
				return;
			}

			loadHolidays();
			loadPracticeLeave();

			let quiet = false;
			if (!(options && options.fresh) && !$scope.selectedAppointment && appointmentFetchesInFlight === 0
				&& loadedAppointmentsCover(request)) {
				$scope.loaded = true;
				renderAppointmentEvents($scope.allAppointments);
				if (Date.now() - loadedAppointments.at < APPOINTMENT_REUSE_MS) {
					return;
				}
				// Already drawn - refresh the same wider list without the spinner, rather than narrowing it
				// to what is ticked now and fetching again on the next click.
				request = loadedAppointments;
				quiet = true;
			}

			const surgeon = request.surgeon;
			const requestId = ++fetchSequence;
			appointmentFetchesInFlight++;
			const settled = () => {
				appointmentFetchesInFlight--;
			};
			const loadedFor = Object.assign({}, request, { at: Date.now() });
			appointmentFetchOut = { id: requestId, request: request };
			// In a finally, so a fetch whose drawing throws is still let go - every later joinInFlight fetch for
			// the same appointments would otherwise be skipped.
			const letGo = () => {
				if (appointmentFetchOut && appointmentFetchOut.id === requestId) {
					appointmentFetchOut = null;
				}
			};

			if (request.practiceId !== -1) {
				$scope.API.isProcessing = !quiet;
				$scope.API.queryPatientAppointment(surgeon, request.start, request.end, request.practiceId)
					.then(withCategories)
					.then(
						function (resp) {
							if (requestId !== fetchSequence) {
								return;
							}
							loadedAppointments = loadedFor;
							// $scope.patientOptions = removeDuplicatedObj(resp.data.map(t=>({patient_id:t.patient_id, patient_name: t.patient_name})));
							$scope.allAppointments = withLocalChanges(angular.copy(resp.data), loadedFor.at, request);
							renderAppointmentEvents($scope.allAppointments);
							openSelectedAppointment();
						},
						function (error) {
							// A refresh of what is on screen can fail and leave it up; a different selection's cannot.
							if (requestId === fetchSequence && !loadedAppointmentsCover(appointmentRequest())) {
								forgetLoadedAppointments();
							}
						}
					)
					.then(function () {
						settled();
						// A newer fetch owns the spinner and loaded flag now - leave them to it.
						if (requestId === fetchSequence) {
							$scope.API.isProcessing = false;
							$scope.loaded = true;
						}
					})
					.finally(letGo);
			} else {
				$scope.API.isProcessing = !quiet;
				queryAllPractices(surgeon, request.practiceIds)
					.then(withCategories)
					.then(
						function (appointments) {
							if (requestId !== fetchSequence) {
								return;
							}
							loadedAppointments = loadedFor;
							$scope.allAppointments = withLocalChanges(appointments, loadedFor.at, request);
							renderAppointmentEvents($scope.allAppointments);
							openSelectedAppointment();
						},
						function () {
							if (requestId === fetchSequence) {
								showValidationError("The appointments could not be loaded. Try again shortly.");
								if (!loadedAppointmentsCover(appointmentRequest())) {
									forgetLoadedAppointments();
								}
							}
						}
					)
					.then(() => {
						settled();
						if (requestId === fetchSequence) {
							$scope.API.isProcessing = false;
							$scope.loaded = true;
						}
					})
					.finally(letGo);
			}
		}

		// The longest appointments wait for their types before they are drawn. Past it they are drawn without
		// their colours, as they were before they waited at all, and are coloured once the types arrive.
		const CATEGORIES_WAIT_MS = 3000;

		// Passes a fetch's result on once the appointment types asked for alongside are here too - see categoriesReady.
		function withCategories(result) {
			const giveUp = $timeout(angular.noop, CATEGORIES_WAIT_MS, false);
			return $q.race([categoriesReady, giveUp]).then(function () {
				$timeout.cancel(giveUp);
				return result;
			});
		}

		// Opened on one appointment: move the calendar to its day, then fetch the whole view around it -
		// the fetch that found it covered only the day either side.
		function revealAppointmentDay(appointment) {
			const day = moment.utc(appointment.start_date_utc).tz(getPracticeTimezoneNameById(appointment.practice_id)).format("YYYY-MM-DD");
			$timeout(function () {
				withCalendarInDigest((calendar) => {
					calendar.fullCalendar("gotoDate", day);
					viewRender(calendar.fullCalendar("getView"));
				});
			}, 0, false);
		}

		// Opened on one appointment (selectedAppointment): once it has been fetched, it is opened and its day shown.
		// Not among those fetched - another clinician's, or at another practice - it is looked for once more,
		// among everyone at its own practice. Not there either (cancelled since, say), the calendar says so
		// and goes back to the range on screen.
		let selectedAppointmentLookedForElsewhere = false;

		function openSelectedAppointment() {
			const appointment = $scope.selectedAppointment;
			if (!appointment) {
				return;
			}
			if ($scope.allAppointments.some((t) => t.patient_appointment_id === appointment.patient_appointment_id)) {
				$scope.alertOnEventClick({ id: appointment.patient_appointment_id });
				revealAppointmentDay(appointment);
				$scope.selectedAppointment = null;
				return;
			}
			if (!selectedAppointmentLookedForElsewhere && lookForSelectedAppointmentElsewhere(appointment)) {
				return;
			}
			$scope.selectedAppointment = null;
			showValidationError("That appointment could not be found in the calendar. It may have been cancelled or moved.");
			// The fetch that missed it covered only the days either side of it.
			withCalendar((calendar) => viewRender(calendar.fullCalendar("getView")));
		}

		// Switches to the appointment's practice, and to everyone there when it is another clinician's, and
		// fetches again. False when that would change nothing, or the practice is not one the calendar offers.
		function lookForSelectedAppointmentElsewhere(appointment) {
			const otherClinician = $scope.currentSurgeon !== "all" && String($scope.currentSurgeon) !== String(appointment.clinician_id);
			const otherPractice = !appointmentRequest().practiceIds.some((id) => String(id) === String(appointment.practice_id));
			if (!otherClinician && !otherPractice) {
				return false;
			}
			const offered = buildPracticeList(otherClinician ? "all" : undefined);
			const practice = offered.find((p) => p.id !== -1 && String(p.id) === String(appointment.practice_id));
			// The practice on screen (or "All practices") stays when it covers the appointment and is still offered.
			const stay = !otherPractice && offered.some((p) => p.id === $scope.currentPractice.id);
			if (!stay && !practice) {
				return false;
			}
			selectedAppointmentLookedForElsewhere = true;
			if (otherClinician) {
				// As the rail's "Everyone" does - see showEveryone.
				$scope.clinicianFilter.ids = [];
				$scope.clinicianFilter.none = false;
				rememberClinicianFilter();
				$scope.currentSurgeon = "all";
				$scope.ShareDataService.setSavedCalendarUser(Session.practice.id, "all");
			}
			$scope.practiceSummaryList = buildPracticeList();
			if (!stay) {
				// As picking the practice in the rail does - see selectPractice.
				$scope.practiceFilter.ids = [];
				$scope.practiceFilter.none = false;
				rememberPracticeFilter();
				$scope.currentPractice.id = practice.id;
			}
			$scope.onPracticeChange();
			return true;
		}

		function fetchPatientAppointments(options) {
			if ($scope.eventSources == null) {
				$scope.loaded = false;
			}

			if ($scope.calendar_range_start && $scope.calendar_range_end && $scope.currentSurgeon) {

			} else {
				return;
			}

			// $scope.loaded = false;
			// const today = new Date();
			// const startDate = new Date(today.getFullYear(),today.getMonth()-1, today.getDate());
			// let surgeon = $scope.currentSurgeon === 'all' ? '' : $scope.currentSurgeon;

			if ($scope.selectedAppointment) {
				const start_date_utc = $filter("date")($scope.selectedAppointment.start_date_utc, "yyyy-MM-dd");
				$scope.calendar_range_start = moment(start_date_utc).add(-1, "d").utc().toISOString();
				$scope.calendar_range_end = moment(start_date_utc).add(1, "d").utc().toISOString();
			}

			_fetchPatientAppointments(options);
		}

		// After a save - what is loaded no longer matches the server, so it is fetched whatever is ticked.
		function refetchAppointments() {
			fetchPatientAppointments({ fresh: true });
		}

		/* =================================================================== */
		/* Appointment changes, shown at once
		/* A booking, move, edit or delete is drawn straight away and then sent. The server's answer
		/* replaces the drawn copy; a refusal puts back what was there. Each change is also laid over any
		/* appointment list fetched before the server had it, which would otherwise bring the old one back.
		/* =================================================================== */

		// { id, replacedId, appointment (null when deleted), previous (null when new), settledAt }, oldest first.
		let localChanges = [];
		let newAppointmentSequence = 0;
		// Kept from the drawn copy when the server's answer comes back: the save endpoints do not add them.
		const KEPT_ON_SAVE = ["invoice_list", "invoices_unavailable", "practice_name"];
		// Sent with a save but never part of an appointment the server holds.
		const UNSAVED_FIELDS = ["_startDateStr", "selectedTimeSlot", "allow_room_double_booking"];

		// A booking not yet answered by the server. It has no id of its own to open or move it by.
		function isUnsavedId(appointmentId) {
			return String(appointmentId).indexOf("unsaved-") === 0;
		}

		function appointmentInList(appointmentId) {
			const found = ($scope.allAppointments || []).find((t) => String(t.patient_appointment_id) === String(appointmentId));
			return found ? angular.copy(found) : null;
		}

		// Whether a fetch for this request would have returned the appointment - so a change moving it out
		// of the range, practice or clinician fetched takes it off rather than leaving it in the counts.
		function requestCovers(request, appointment) {
			if (!request) {
				return true;
			}
			if (!request.practiceIds.some((id) => String(id) === String(appointment.practice_id))) {
				return false;
			}
			if (request.surgeon !== "" && request.surgeon !== null && request.surgeon !== undefined
				&& String(request.surgeon) !== String(appointment.clinician_id)) {
				return false;
			}
			const start = moment.utc(appointment.start_date_utc);
			return !start.isBefore(moment.utc(request.start)) && !start.isAfter(moment.utc(request.end));
		}

		// Puts the change into the list in place, where the appointment was: every copy under either id taken
		// out, then the changed one put back, when there is one and the list's request covers it.
		function applyLocalChange(list, change, request) {
			const ids = [change.id, change.replacedId].filter((id) => id !== null && id !== undefined).map(String);
			let at = -1;
			for (let i = list.length - 1; i >= 0; i--) {
				if (ids.includes(String(list[i].patient_appointment_id))) {
					list.splice(i, 1);
					at = i;
				}
			}
			if (change.appointment && requestCovers(request, change.appointment)) {
				list.splice(at === -1 || at > list.length ? list.length : at, 0, angular.copy(change.appointment));
			}
		}

		// Draws a change at once. previous is the appointment as it was (null for a new one), to put back if
		// the server refuses.
		function showLocalChange(appointmentId, appointment, previous) {
			const drawn = appointment ? angular.copy(appointment) : null;
			if (drawn) {
				// The booking dialog's own fields, and a double-booking confirmed for this one save - kept, it would
				// go out again unasked the next time the appointment was saved from the dialog.
				UNSAVED_FIELDS.forEach((key) => delete drawn[key]);
			}
			const change = { id: appointmentId, replacedId: null, appointment: drawn, previous: previous, settledAt: null };
			localChanges.push(change);
			$scope.allAppointments = $scope.allAppointments || [];
			applyLocalChange($scope.allAppointments, change, loadedAppointments);
			renderAppointmentEvents($scope.allAppointments);
			return change;
		}

		// The server has it. Its copy replaces the drawn one - a new booking gets its id - keeping the fields
		// the save endpoints leave out, and anything they send back empty.
		function localChangeSaved(change, saved) {
			change.settledAt = Date.now();
			if (!change.appointment) {
				return;
			}
			if (!saved || !saved.patient_appointment_id) {
				// Nothing to go on - fetch what the server has instead.
				localChanges = localChanges.filter((t) => t !== change);
				refetchAppointments();
				return;
			}
			const merged = angular.copy(change.appointment);
			Object.keys(saved).forEach((key) => {
				if (!KEPT_ON_SAVE.includes(key) && !UNSAVED_FIELDS.includes(key) && saved[key] !== null && saved[key] !== undefined) {
					merged[key] = saved[key];
				}
			});
			if (String(merged.patient_appointment_id) !== String(change.id)) {
				change.replacedId = change.id;
				change.id = merged.patient_appointment_id;
			}
			change.appointment = merged;
			applyLocalChange($scope.allAppointments, change, loadedAppointments);
			renderAppointmentEvents($scope.allAppointments);
		}

		// The server refused it: what was there goes back - unless a later change to the same appointment is
		// still to be answered, which then stands or falls on its own. That one would fall back to this refused
		// state, which the server never had, so it is given this one's to fall back to instead.
		function localChangeFailed(change) {
			const at = localChanges.indexOf(change);
			const sameAppointment = (t) => [t.id, t.replacedId].some((id) => id !== null && String(id) === String(change.id));
			const later = at === -1 ? null : localChanges.slice(at + 1).find(sameAppointment);
			localChanges = localChanges.filter((t) => t !== change);
			if (later) {
				// Saved already, it is what the server has, and stays.
				if (!later.settledAt) {
					later.previous = change.previous;
				}
				return;
			}
			applyLocalChange($scope.allAppointments, { id: change.id, replacedId: change.replacedId, appointment: change.previous }, loadedAppointments);
			renderAppointmentEvents($scope.allAppointments);
		}

		// A freshly fetched list, with the changes it may predate laid over it: any not yet answered, and any
		// answered after the fetch set out. Changes answered before it set out are in it, and are let go.
		function withLocalChanges(list, fetchedAt, request) {
			localChanges = localChanges.filter((t) => !t.settledAt || t.settledAt > fetchedAt);
			localChanges.forEach((change) => applyLocalChange(list, change, request));
			return list;
		}

		// After a live update patched the list: the changes still waiting on the server go back over it.
		function reapplyUnsavedChanges() {
			if (!$scope.allAppointments) {
				return;
			}
			localChanges.filter((t) => !t.settledAt).forEach((change) => applyLocalChange($scope.allAppointments, change, loadedAppointments));
		}

		// Names drawn with the appointment before the server sends its own: the clinician and practice it is now
		// with. The rail marks the signed-in user's own name with "(Me)" - not part of the name.
		function withDisplayNames(appointment) {
			const clinician = ($scope._ophthalmologists || []).concat($scope.ophthalmologists || [])
				.find((t) => String(t.value) === String(appointment.clinician_id));
			if (clinician) {
				appointment.clinician_name = clinician.name.replace(/ \(Me\)$/, "");
			}
			const practice = ($scope.practiceSummaryList || []).concat(Session.practiceOptions || [])
				.find((p) => p.id !== -1 && String(p.id) === String(appointment.practice_id));
			if (practice) {
				appointment.practice_name = practice.name;
			}
			return appointment;
		}

		// Another user's appointment edits, applied to this open calendar as they happen. Only the one
		// changed appointment is fetched, and only when it falls inside what this calendar is showing -
		// see AppointmentLiveUpdateService.
		function subscribeToLiveAppointmentChanges() {
			AppointmentLiveUpdateService.subscribe($scope, {
				appointments: function () {
					return $scope.allAppointments;
				},
				isInView: function (change) {
					// Judged against what is loaded, not what is ticked - the loaded list can be wider than
					// the view (see loadedAppointments) and has to stay current for when it is widened again.
					// Events arrive on the session practice's channel only, so a list fetched for some other
					// single practice cannot be updated from them. The "all practices" list includes the
					// session practice, so it can.
					const loaded = loadedAppointments;
					if (!loaded || !loaded.practiceIds.some((id) => String(id) === String(Session.practice.id))) {
						return false;
					}

					const surgeon = loaded.surgeon === "" ? null : loaded.surgeon;
					return AppointmentLiveUpdateService.isWithinCalendarWindow(
						change,
						loaded.start,
						loaded.end,
						surgeon
					);
				},
				onChanged: function () {
					// The echo of a change made here can land before the change's own answer, and an earlier
					// one's after a later change - the changes still waiting go back on top.
					reapplyUnsavedChanges();
					renderAppointmentEvents($scope.allAppointments);
				},
				// The detail dialog holds its own copy of one appointment, so re-rendering the grid
				// does not reach it. Refresh it when that appointment changes, and close it when that
				// appointment is gone - there is nothing left to show, and a save would recreate it.
				onPatched: function (appointment) {
					if (!isDetailsModalOpenFor(appointment.patient_appointment_id)) {
						return;
					}
					// Re-reading the dialog's copy would discard what the user has typed into it. With
					// unsaved edits it is left alone and the change is announced instead; saving then
					// writes over the other change, which is what the user is asking for.
					if (detailsModalHasUnsavedEdits()) {
						$scope.$ctrl.liveChangeNotice = "This appointment was just changed by someone else. "
							+ "Your unsaved edits are kept; saving will replace their change.";
						return;
					}
					prepareAppointmentDetails(appointment.patient_appointment_id);
				},
				onRemoved: function (appointmentId) {
					if (isDetailsModalOpenFor(appointmentId)) {
						$scope.detailsModal.hide();
					}
				},
			});

			// Invoice changes reach this calendar too - the invoice icon on an appointment and the
			// total in its hover are drawn from the summaries attached to it.
			InvoiceLiveUpdateService.subscribeAppointmentInvoices($scope, {
				appointments: function () {
					return $scope.allAppointments;
				},
				onChanged: function () {
					renderAppointmentEvents($scope.allAppointments);
				},
			});

			// So does a change to the shown clinician's availability, which draws the background
			// shading behind the appointments. Unlike the two above this reloads rather than patches -
			// see CalendarAvailabilityLiveUpdateService for why.
			CalendarAvailabilityLiveUpdateService.subscribe($scope, {
				isInView: function (change) {
					// Mirror every guard fetchCalendarAvailability() applies, so the only events that
					// reach the reload are ones that would change something on screen.
					if (!$scope.calendarAvailabilityEnabled || !$scope.currentPractice) {
						return false;
					}

					// Availability belongs to one practice, and events only arrive on the session
					// practice's channel. The "all practices" view (-1) draws no availability at all.
					const practiceId = $scope.currentPractice.id;
					if (practiceId === null || practiceId === undefined || practiceId === -1) {
						return false;
					}
					if (practiceId !== Session.practice.id) {
						return false;
					}

					// One clinician's availability is shown at a time, and none in the "all" view.
					if ($scope.currentSurgeon === 'all') {
						return false;
					}
					const surgeon = $scope.currentSurgeon ? $scope.currentSurgeon : Session.userId;
					return CalendarAvailabilityLiveUpdateService.isForUser(change, surgeon);
				},
				reload: function () {
					$scope.fetchCalendarAvailability($scope.currentPractice.id, { background: true });
				},
			});
		}

		/**
		 * Whether the appointment detail dialog is on screen showing the given appointment. The dialog
		 * handle is kept after hide(), so its own $isShown flag is what says whether it is open.
		 */
		// Whether the open detail dialog holds edits not yet saved: the fields its form binds, against the
		// snapshot taken when it opened. The time slot and date shown are derived from that snapshot.
		function detailsModalHasUnsavedEdits() {
			const current = $scope.appointment;
			const saved = $scope.appointment_clone;
			if (!current || !saved) {
				return false;
			}
			const fields = ["note", "category_id", "clinician_id", "duration_minutes", "practice_id",
				"do_not_send_auto_reminders", "patient_seen"];
			if (fields.some((field) => !angular.equals(current[field], saved[field]))) {
				return true;
			}
			const savedMoment = moment.utc(saved.start_date_utc).tz(getPracticeTimezoneNameById(saved.practice_id));
			return current.selectedTimeSlot !== savedMoment.format("HH:mm")
				|| current._startDateStr !== savedMoment.format("DD/MM/YYYY");
		}

		function isDetailsModalOpenFor(appointmentId) {
			return !!(
				$scope.detailsModal &&
				$scope.detailsModal.$isShown &&
				$scope.appointment &&
				appointmentId !== null &&
				appointmentId !== undefined &&
				String($scope.appointment.patient_appointment_id) === String(appointmentId)
			);
		}

		/**
		 * Puts the given appointment's grid row into the scope the detail dialog is bound to, with the
		 * derived fields the dialog edits. Shared by the click that opens the dialog and by the live
		 * update that refreshes it while open, so both show the appointment the same way.
		 *
		 * @return whether a row for that appointment was found in the rendered events
		 */
		function prepareAppointmentDetails(appointmentId) {
			const event = $scope.events.find((t) => !t.allDay && String(t.id) === String(appointmentId));
			if (!event) {
				return false;
			}
			// The dialog edits a copy: the grid's row changes only when a save goes through. Closed any other
			// way - Escape, or the patient's dashboard - the dialog used to leave its unsaved edits on the row,
			// where a drag of that appointment, or the consult timer, saved them; a change of practice went
			// out with no type, and the server kept the old practice's.
			$scope.appointment = angular.copy(event.appointment);
			$scope.appointment_clone = angular.copy(event.appointment);
			$scope.$ctrl.liveChangeNotice = null;
			$scope.$ctrl.confirmDelete = false;
			// An existing appointment's patient is fixed - the search is only for a new booking made without one.
			$scope.pickingPatient = false;

			// Display the appointment in its own practice's timezone (which may differ
			// from the calendar's current practice, e.g. in the "all practices" view).
			const practiceTimezoneName = getPracticeTimezoneNameById($scope.appointment.practice_id);
			const appointmentMoment = moment.utc($scope.appointment.start_date_utc).tz(practiceTimezoneName);

			$scope.appointment._startDateStr = appointmentMoment.format("DD/MM/YYYY");

			const businessStart = $scope.uiConfig.calendar.businessHours.start.split(':');
			const businessEnd = $scope.uiConfig.calendar.businessHours.end.split(':');
			const businessStartMoment = appointmentMoment.clone().hour(businessStart[0]).minute(businessStart[1]);
			const businessEndMoment = appointmentMoment.clone().hour(businessEnd[0]).minute(businessEnd[1]);

			const minTime = moment.min(businessStartMoment, appointmentMoment);
			const maxTime = moment.max(businessEndMoment, appointmentMoment);

			generateTimeSlots(minTime, maxTime);
			$scope.appointment.selectedTimeSlot = appointmentMoment.format('HH:mm');


			fetchAppointmentAudit($scope.appointment.patient_appointment_id);
			fetchSetting(appointmentPracticeId());
			loadInvoiceDetails($scope.appointment);
			// A cooldown may already be part-way through from an earlier send.
			scheduleManualReminderCooldownExpiry();
			$scope.practiceName = queryPracticeName();

			const local = appointmentMoment;
            const moment_start = moment(local);
			const moment_end = moment(local).add($scope.appointment.duration_minutes, 'minutes');
			$scope.$ctrl.showAlert = unavailabilityWarning($scope.appointment.clinician_id, $scope.appointment.clinician_name, moment_start, moment_end);
			resetPracticeLeaveState();
			// Seed the clinician dropdown from the calendar's current practice. If this
			// appointment belongs to a different practice (e.g. the "all practices"
			// view), reload it for its own practice so the dropdown shows the correct
			// options.
			$scope._ophthalmologists = angular.copy($scope.ophthalmologists);
			if ($scope.appointment.practice_id !== $scope.currentPractice.id) {
				loadPracticeClinicians($scope.appointment);
			}
			// The types always come from the appointment's own practice, never from whichever list the dialog
			// showed last. One that isn't that practice's is cleared, so the dialog asks for one.
			loadPracticeCategories($scope.appointment);

			return true;
		}

		$scope.alertOnEventClick = function (data, jsEvent, view) {
			const event = $scope.events.find(t => t.id === data.id);
			// The appointment to open may not be among those fetched (the "all practices" path calls this
			// without checking). A booking still on its way to the server opens once it has its id.
			if (!event || event.allDay || isUnsavedId(event.id)) {
				return;
			}
			if (!prepareAppointmentDetails(event.id)) {
				return;
			}

			$scope.detailsModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.appointment-detail.tpl.html",
				show: true,
				backdrop: "static",
				title: "Appointment",
			});
			return false;
		};

		$scope.alertOnDrop = function (calEvent, delta, revertFunc, jsEvent, ui, view) {
			var startMoment = moment.isMoment(calEvent.start) ? calEvent.start : moment(calEvent.start);
			// A booking still on its way to the server has no id to save a move against.
			if (!startMoment.isValid() || isUnsavedId(calEvent.appointment.patient_appointment_id)) {
				return revertFunc();
			}

			// Back to UTC in the zone the event was placed in (its own practice's, in the "All" view).
			var startUtcIso = toUtcIsoFromPracticeWallTime(startMoment, getPracticeTimezoneNameForItem(calEvent.appointment));
			if (startUtcIso === 'Invalid date') {
				return revertFunc();
			}

			// Said, as the team view says it - snapping back without a word read as the move being broken.
			if (moment(startUtcIso).isBefore(moment.utc().subtract(7, 'd'))) {
				showValidationError("Cannot move appointments more than 7 days into the past.");
				return revertFunc();
			}

			var newDurationInMinutes = calEvent.end
				? moment.duration((moment.isMoment(calEvent.end) ? calEvent.end : moment(calEvent.end)).diff(startMoment)).asMinutes()
				: calEvent.appointment.duration_minutes;

			var appointment = {
				...calEvent.appointment,
				start_date_utc: startUtcIso,
				duration_minutes: newDurationInMinutes
			};

			if (refuseMoveIntoPracticeLeave(appointment, revertFunc)) {
				return;
			}

			saveMovedAppointment(appointment);
		};

		$scope.alertOnResize = function (event, delta, revertFunc, jsEvent, ui, view) {
			if (isUnsavedId(event.appointment.patient_appointment_id)) {
				return revertFunc();
			}
			// Calculate the new duration directly from the event's new start and end times.
			const newDurationInMinutes = moment.duration(event.end.diff(event.start)).asMinutes();

			// Create the updated appointment object with the new, accurate duration.
			const appointment = { ...event.appointment, duration_minutes: newDurationInMinutes };

			if (refuseMoveIntoPracticeLeave(appointment, revertFunc)) {
				return;
			}

			saveMovedAppointment(appointment);
		};

		// A drop or resize in the grid: kept where it was put, and saved. A refusal puts it back - redrawn from the
		// list rather than with FullCalendar's revertFunc, since the move has been drawn from the list by then -
		// and offers the override when the refusal was a clash. Anything else says it could not be moved.
		function saveMovedAppointment(appointment) {
			const change = showLocalChange(appointment.patient_appointment_id, appointment, appointmentInList(appointment.patient_appointment_id));
			$scope.API.updateAppointment(appointment.patient_id, appointment.patient_appointment_id, appointment, appointment.practice_id).then(
				function (resp) {
					localChangeSaved(change, resp.data);
				},
				function (error) {
					localChangeFailed(change);
					if (!offerMoveOverride(error, appointment)) {
						showValidationError("That appointment could not be moved there.");
					}
				}
			);
		}

		// A drop into practice leave goes back where it was, and the notice says why with a "Book anyway" that makes
		// the move over the leave - so it is never made by accident, but is one click when it is meant.
		function refuseMoveIntoPracticeLeave(appointment, revertFunc) {
			const block = practiceLeaveAt(appointment.practice_id, moment.utc(appointment.start_date_utc), appointment.duration_minutes);
			if (!block) {
				return false;
			}
			revertFunc();
			offerPracticeLeaveOverride(`Practice closed: ${practiceLeaveLabel(block, appointment.practice_id)}.`, appointment);
			return true;
		}

		// The codes the API puts on a 409, saying which clash refused the save.
		const ROOM_DOUBLE_BOOKED = "ROOM_DOUBLE_BOOKED";
		const PRACTICE_LEAVE_CLASH = "PRACTICE_LEAVE_CLASH";

		// A move refused with a 409 says in its code why: a room already in use at that time, or practice leave.
		// Either way it is put back where it was and offered as a one-click override. An override already given is
		// carried along, so a move that clashes with both can be confirmed one after the other.
		// Returns whether the error was one of those.
		function offerMoveOverride(error, appointment, overridePracticeLeave) {
			const message = ExceptionAPI.serverMessage(error);
			const code = ExceptionAPI.serverCode(error);
			if (code === ROOM_DOUBLE_BOOKED) {
				$scope.dismissCalendarNotice();
				$scope.roomMove = {
					appointment: appointment,
					overridePracticeLeave: !!overridePracticeLeave,
					message: message || "That room is already booked at that time.",
				};
				return true;
			}
			if (code === PRACTICE_LEAVE_CLASH) {
				offerPracticeLeaveOverride(message || "The practice is closed at that time.", appointment);
				return true;
			}
			return false;
		}

		function offerPracticeLeaveOverride(message, appointment) {
			$scope.roomMove = null;
			$scope.calendarNotice = message;
			$scope.practiceLeaveMove = appointment;
		}

		// TODO(#1451): once the permissions rework (refactor/user_permissions) lands, only offer "Book anyway" to
		// users with the practice leave override permission (e.g. SCHEDULE_PRACTICE_LEAVE_OVERRIDE).
		$scope.moveOverPracticeLeave = function () {
			const appointment = $scope.practiceLeaveMove;
			$scope.dismissCalendarNotice();
			if (!appointment) {
				return;
			}
			saveMoveWithOverrides(appointment, true);
		};

		$scope.confirmRoomMove = function () {
			const move = $scope.roomMove;
			$scope.roomMove = null;
			if (!move) {
				return;
			}
			const appointment = Object.assign({}, move.appointment, { allow_room_double_booking: true });
			saveMoveWithOverrides(appointment, move.overridePracticeLeave);
		};

		$scope.cancelRoomMove = function () {
			$scope.roomMove = null;
		};

		// Saves a move the user has chosen to make over a clash. If it then meets the other kind of clash, that is
		// offered in turn, keeping this override.
		function saveMoveWithOverrides(appointment, overridePracticeLeave) {
			const change = showLocalChange(appointment.patient_appointment_id, appointment, appointmentInList(appointment.patient_appointment_id));
			$scope.API.updateAppointment(appointment.patient_id, appointment.patient_appointment_id, appointment, appointment.practice_id, overridePracticeLeave)
				.then(
					function (resp) {
						localChangeSaved(change, resp.data);
					},
					function (error) {
						localChangeFailed(change);
						if (!offerMoveOverride(error, appointment, overridePracticeLeave)) {
							showValidationError("That appointment could not be moved there.");
						}
					}
				);
		}
		function selectPatient(patient, appointment) {
			$scope.CP.setPatient(patient, appointment);

			if (!$scope.CP.patientIsMine) {
				// Launch the new standalone transfer modal
				$scope.isFromCalendar = true;
				$modal({
					controller: "patientTransferController",
					templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
					show: true,
					backdrop: "static",
					resolve: {
						patientId: function () {
							return patient.id;
						},
						onSuccess: function () {
							return function (updatedPatient) {
								$scope.CP.setPatient(updatedPatient, appointment);
								$scope.hide(); // Hide the underlying calendar dialog
								$state.go("patient-dashboard");
							};
						},
						onCancel: function () {
							return function () {
								// Clear the unauthorized patient if they cancel the transfer
								$scope.CP.clearPatient();
							};
						}
					}
				});
			} else {
				$scope.hide();
				$state.go("patient-dashboard");
			}
		}

		$scope.forwardPatientDashboard = function (appointment) {
			$scope.PA.getPatient(appointment.patient_id).then(function (resp) {
				selectPatient(resp.data, appointment);
			}, function (error) {
				// Clear any wording a more specific failure left on the shared modal scope.
				$scope.alertMessage = null;
				$scope.alertDetail = null;
				$scope.serverErrorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
					show: true,
					title: "CatTrax has encountered an error",
				});
			});
		}

		function removePopup() {
			var popups = document.querySelectorAll(".popover");
			if (popups) {
				for (var i = 0; i < popups.length; i++) {
					var popup = popups[i];
					var popupElement = angular.element(popup);
					popupElement.scope().$parent.isOpen = false;
					popupElement.remove();
				}
			}
		}

		// When a progress step was ticked, in the appointment's own practice's time.
		$scope.getProgressTimestamp = function (key) {
			if ($scope.appointment.patient_seen && $scope.appointment.patient_seen[key]) {
				const timeUtc = $scope.appointment.patient_seen[`${key}_timestamp`];
				if (!timeUtc) {
					return '';
				}
				const practiceTz = getPracticeTimezoneNameById($scope.appointment.practice_id);
				return moment.utc(timeUtc).tz(practiceTz).locale('en').format('D MMM, h:mm a');
			}
			return '';
		}

		/* Invoices in the appointment modal. The server attaches invoice_list only when the practice's
		   billing is connected, so no list means nothing is known - not that there is no invoice. */

		// Each invoice's billing items, fetched when the appointment is opened - the summaries the calendar
		// holds carry totals only. Keyed by invoice id: { loading, failed, invoice }.
		$scope.invoiceDetails = {};
		function loadInvoiceDetails(appointment) {
			$scope.invoiceDetails = {};
			(appointment.invoice_list || []).forEach(function (summary) {
				const invoiceId = summary.invoice_id;
				if (!invoiceId) {
					return;
				}
				$scope.invoiceDetails[invoiceId] = { loading: true };
				BillingAPI.getInvoice(appointment.patient_id, invoiceId, appointment.practice_id).then(
					function (resp) {
						// Another appointment may have been opened while this was in flight.
						if ($scope.appointment !== appointment) {
							return;
						}
						$scope.invoiceDetails[invoiceId] = { invoice: resp.data };
					},
					function () {
						if ($scope.appointment === appointment) {
							$scope.invoiceDetails[invoiceId] = { failed: true };
						}
					}
				);
			});
		}

		$scope.lineItemAmount = function (item) {
			if (item.line_amount !== null && item.line_amount !== undefined) {
				return item.line_amount;
			}
			const gross = (Number(item.unit_amount) || 0) * (Number(item.quantity) || 0);
			return gross - gross * (Number(item.discount_rate) || 0) / 100;
		};

		$scope.isInvoiceInfoAvailable = function (appointment) {
			return !!appointment && angular.isArray(appointment.invoice_list);
		};

		$scope.isInvoiceOverdue = function (invoice) {
			return invoice.status === "SUBMITTED" && !!invoice.due_date
				&& moment(invoice.due_date).isBefore(moment(), "day");
		};

		// Drives the pill's colour: draft, awaiting, overdue, paid or cancelled.
		$scope.invoiceStatusKey = function (invoice) {
			if ($scope.isInvoiceOverdue(invoice)) {
				return "overdue";
			}
			return { DRAFT: "draft", SUBMITTED: "awaiting", PAID: "paid", CANCELLED: "cancelled" }[invoice.status] || "draft";
		};

		$scope.invoiceStatusLabel = function (invoice) {
			return {
				draft: "Draft",
				awaiting: "Awaiting payment",
				overdue: "Overdue",
				paid: "Paid",
				cancelled: "Cancelled",
			}[$scope.invoiceStatusKey(invoice)];
		};

		$scope.invoiceDates = function (invoice) {
			const parts = [];
			if (invoice.date && moment(invoice.date).isValid()) {
				parts.push(`Raised ${moment(invoice.date).locale("en").format("D MMM")}`);
			}
			if (invoice.due_date && moment(invoice.due_date).isValid() && ["DRAFT", "SUBMITTED"].includes(invoice.status)) {
				parts.push(`due ${moment(invoice.due_date).locale("en").format("D MMM")}`);
			}
			return parts.join(" · ");
		};

		// Still to be paid: drafts and invoices awaiting payment - by what is actually due once an invoice's
		// detail has loaded (it may be part paid), by its total until then.
		$scope.invoiceOutstanding = function (appointment) {
			return (appointment && appointment.invoice_list || [])
				.filter((t) => t.status === "DRAFT" || t.status === "SUBMITTED")
				.reduce((sum, t) => {
					const detail = $scope.invoiceDetails[t.invoice_id];
					const due = detail && detail.invoice && detail.invoice.amount_due;
					return sum + (due !== undefined && due !== null ? Number(due) : (Number(t.total) || 0));
				}, 0);
		};

		$scope.isInvoiceAllPaid = function (appointment) {
			const list = (appointment && appointment.invoice_list || []).filter((t) => t.status !== "CANCELLED");
			return list.length > 0 && list.every((t) => t.status === "PAID");
		};

		/* Choosing the patient in a booking made without one: the existing patient search (surname,
		   phone, email or NHI). Any patient it finds can be booked - a patient belonging to another
		   practice only needs transferring to open their dashboard, which forwardPatientDashboard does. */

		$scope.pickingPatient = false;
		$scope.patientSearch = { results: [], searched: false, loading: false };
		$scope.patientPicker = { query: "", open: false, active: -1 };
		let patientSearchSequence = 0;
		let patientListCloseTimer = null;

		$scope.searchPatients = function (term) {
			const searchTerm = (term || "").trim();
			const requestId = ++patientSearchSequence;
			if (searchTerm.length < 2) {
				$scope.patientSearch = { results: [], searched: false, loading: false };
				return;
			}
			$scope.patientSearch.loading = true;
			return PatientAPI.search("", "", searchTerm, "").then(
				function (resp) {
					if (requestId !== patientSearchSequence || !$scope.appointment) {
						return;
					}
					const practiceId = $scope.appointment.practice_id;
					$scope.patientPicker.active = -1;
					// Until a practice is chosen there is nothing to compare a patient's practice with.
					$scope.patientSearch = {
						searched: true,
						loading: false,
						results: (resp.data || []).map((p) => ({
							id: p.id,
							name: [p.firstName, p.lastName].filter(Boolean).join(" "),
							dob: p.dateOfBirth && moment(p.dateOfBirth).isValid() ? moment(p.dateOfBirth).locale("en").format("D MMM YYYY") : "",
							// Named when it is not the booking's practice - worth knowing, not a bar to booking.
							otherPractice: practiceId && p.practice && p.practice.id !== practiceId ? p.practice.name || "Another practice" : null,
							// An imported patient can be booked; the booking moves with them if they turn out to be a duplicate.
							needsReview: !!p.needs_review,
						})),
					};
				},
				function () {
					if (requestId === patientSearchSequence) {
						$scope.patientSearch = { results: [], searched: true, loading: false };
					}
				}
			);
		};

		$scope.isPatientListOpen = function () {
			return $scope.patientPicker.open && ($scope.patientPicker.query || "").trim().length >= 2
				&& ($scope.patientSearch.loading || $scope.patientSearch.searched);
		};

		// Typing again is a new search: whoever was chosen no longer matches what the field says.
		$scope.onPatientQueryChange = function () {
			$scope.appointment.patient_id = null;
			$scope.appointment.patient_name = null;
			$scope.patientPicker.open = true;
			$scope.searchPatients($scope.patientPicker.query);
		};

		$scope.onPatientKeydown = function (event) {
			const results = $scope.patientSearch.results;
			if (event.key === "ArrowDown" || event.key === "ArrowUp") {
				event.preventDefault();
				if (!results.length) {
					return;
				}
				$scope.patientPicker.open = true;
				const step = event.key === "ArrowDown" ? 1 : -1;
				$scope.patientPicker.active = ($scope.patientPicker.active + step + results.length) % results.length;
			} else if (event.key === "Enter") {
				// Never submits the booking from here - Enter chooses the highlighted patient, if any.
				event.preventDefault();
				if ($scope.isPatientListOpen() && results[$scope.patientPicker.active]) {
					$scope.choosePatient(results[$scope.patientPicker.active]);
				}
			} else if (event.key === "Escape") {
				if ($scope.isPatientListOpen()) {
					event.preventDefault();
					$scope.patientPicker.open = false;
					patientEscapeClosedList = true;
				}
			}
		};

		// The modal closes on Escape's keyup; when Escape only closed the list, that keyup stops here.
		let patientEscapeClosedList = false;
		$scope.onPatientKeyup = function (event) {
			if (event.key === "Escape" && patientEscapeClosedList) {
				event.stopPropagation();
			}
			patientEscapeClosedList = false;
		};

		// After a moment, so a click on a result (handled on mousedown) is not lost to the blur.
		$scope.closePatientList = function () {
			$timeout.cancel(patientListCloseTimer);
			patientListCloseTimer = $timeout(function () {
				$scope.patientPicker.open = false;
			}, 150);
		};

		// Register someone the search does not find, the way the search screen's "Patient not listed" does -
		// a new patient on the patient dashboard. Always a blank form: nothing typed here, nor any earlier
		// search's query or results, is carried into it. The half-made booking is set aside, and once the
		// patient is saved the dashboard brings the calendar back with it (resumeBookingForNewPatient).
		$scope.createPatientFromSearch = function () {
			const booking = $scope.appointment;
			if (booking && !booking.patient_appointment_id) {
				ShareData.setBookingAwaitingPatient({
					_startDateStr: booking._startDateStr,
					selectedTimeSlot: booking.selectedTimeSlot,
					duration_minutes: booking.duration_minutes,
					clinician_id: booking.clinician_id,
					practice_id: booking.practice_id,
					category_id: booking.category_id,
					note: booking.note,
					do_not_send_auto_reminders: booking.do_not_send_auto_reminders,
				});
			}
			if ($scope.detailsModal) {
				$scope.detailsModal.hide();
			}
			$scope.CP.clearPatientResult();
			$scope.CP.clearPatient();
			$scope.CP.createNewPatient();
			$scope.hide();
			$state.go("patient-dashboard");
		};

		$scope.clearPatient = function () {
			$scope.patientPicker = { query: "", open: false, active: -1 };
			$scope.patientSearch = { results: [], searched: false, loading: false };
			$scope.appointment.patient_id = null;
			$scope.appointment.patient_name = null;
			patientSearchSequence++;
		};

		$scope.choosePatient = function (patient) {
			if (!patient) {
				$scope.appointment.patient_id = null;
				$scope.appointment.patient_name = null;
				return;
			}
			$scope.appointment.patient_id = patient.id;
			$scope.appointment.patient_name = patient.name;
			// The field shows who was chosen; setting the query here does not search again, since
			// ng-change only fires for typing.
			$scope.patientPicker.query = patient.name;
			$scope.patientPicker.open = false;
			$scope.patientPicker.active = -1;
		};

		// The dashboard is given the appointment as saved, not the dialog's copy: the consult timer there saves
		// the appointment it is given, which would save anything changed here and not saved, such as another
		// practice.
		$scope.openPatientFromAppointment = function (appointment) {
			if ($scope.detailsModal) {
				$scope.detailsModal.hide();
			}
			$scope.forwardPatientDashboard(appointmentInList(appointment.patient_appointment_id) || $scope.appointment_clone || appointment);
		};

		// The popovers below are built with html: true, so anything user-entered (patient name, note,
		// availability name) has to be escaped before it goes in.
		function escapeHtml(value) {
			return String(value === null || value === undefined ? '' : value)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;');
		}

		function renderInvoiceDetail(invoiceList, note) {
			let result = note ? escapeHtml(note) : '';
			if (invoiceList) {
				invoiceList.forEach(t => { result += `<p>$${escapeHtml(t.total)} - ${escapeHtml(t.status)}</p>` })
			}
			return `<div>${result}</div>`;
		}

		function showTooltip(event, $el) {
			if (event.unavailable == 'false' || event.unavailable == 'true') {
				removePopup();
				$el.popover({
					title: `${event.unavailable == 'true' ? 'NOT AVAILABLE' : 'AVAILABLE'}`,
					content: $(renderInvoiceDetail('', event.custom_availability_name)),
					trigger: "hover",
					placement: "top",
					container: "body",
					html: true,
				});
			}
		}

		const isInRange = (target, start, end) => {
			return moment(target).isSameOrAfter(start) && moment(target).isSameOrBefore(end);
		}

		const localDateToUTC = (eventObj_start) => {
			//input: 2026-03-15T00:00:00Z
			//output: 2026-03-14T11:00:00Z
			// Clone: local()/utc() mutate in place, and callers pass the selection's own start moment,
			// which is then used to fill the booking form's date and time.
			return eventObj_start.clone().local().utc()
		}


		/* Render Tooltip */
		$scope.eventRender = function (eventObj, $el, view) {
			// $el.attr({
			// 	"uib-tooltip": eventObj.appointment.note,
			// 	'tooltip-append-to-body': true
			// });
			// $compile($el)($scope);

			// Leave and sessions (buildAvailabilityEvents). Labelled, so time away says why it is away.
			if (eventObj.availabilityBlock) {
				const label = $(`<span class="bg-label"></span>`).text(eventObj.title || "");
				if (eventObj.availabilityBlock === "away") {
					label.prepend('<i class="fa fa-ban"></i> ');
				} else {
					// A light wash of the type's own colour with a solid edge, named in its first free stretch
					// (freeLabelOffset) so no appointment is drawn over the name.
					$el.css({
						"background-color": tint(eventObj.sessionColour, 0.07),
						"box-shadow": `inset 3px 0 0 ${eventObj.sessionColour}`,
					});
					if (eventObj.labelOffsetPct === null) {
						return;
					}
					label.addClass("bg-label-session").attr("title", eventObj.tooltip)
						.css("top", `calc(${eventObj.labelOffsetPct}% + 3px)`)
						.prepend($('<i class="bg-swatch"></i>').css("background-color", eventObj.sessionColour));
				}
				$el.append(label);
				return;
			}
			if (eventObj.practiceLeave) {
				// In a month cell a lunch break would shade the whole day; only whole days are shown there.
				if (view.name === "month" && !eventObj.practiceLeave.all_day) {
					return false;
				}
				const label = $(`<span class="bg-label practice-leave-label"></span>`).text(eventObj.title || "")
					.attr("title", `Practice closed: ${eventObj.tooltip}`)
					.prepend('<i class="fa fa-calendar-times-o"></i> ');
				$el.append(label);
				$el.popover({
					title: "PRACTICE CLOSED",
					content: $("<span></span>").text(eventObj.tooltip),
					trigger: "hover",
					placement: "top",
					container: "body",
					html: true,
				});
				return;
			}
			if (eventObj.practiceLeaveBanner) {
				if (view.name === "listWeek") {
					$el.find(".fc-list-item-title").empty().append($(`<div class="appt-list-cell"><span class="practice-leave-list-title"><i class="fa fa-calendar-times-o"></i> Practice closed: ${escapeHtml(eventObj.title)}</span></div>`));
				} else {
					$el.find(".fc-title").prepend('<i class="fa fa-calendar-times-o"></i> ');
				}
				return;
			}
			if (eventObj.holidayBanner) {
				if (view.name === "listWeek") {
					$el.find(".fc-list-item-title").empty().append($(`<div class="appt-list-cell"><span class="holiday-list-title"><i class="fa fa-flag"></i> ${escapeHtml(eventObj.title)}</span></div>`));
				} else {
					$el.find(".fc-title").prepend('<i class="fa fa-flag"></i> ');
				}
				return;
			}
			if (eventObj.listOnly) {
				if (view.name !== "listWeek") {
					return false;
				}
				$el.find(".fc-list-item-title").empty().append($(`<div class="appt-list-cell"><span class="leave-list-title"><i class="fa fa-ban"></i> ${escapeHtml(eventObj.title)}</span></div>`));
				return;
			}
			if (eventObj.leaveBanner) {
				if (view.name === "listWeek") {
					$el.find(".fc-list-item-title").empty().append($(`<div class="appt-list-cell"><span class="leave-list-title"><i class="fa fa-ban"></i> ${escapeHtml(eventObj.title)}</span></div>`));
				} else {
					$el.find(".fc-title").prepend('<i class="fa fa-ban"></i> ');
				}
				return;
			}

			//eventObj.start is local date time, e.g: 2026-03-21T00:00:00
			if (['listWeek', 'month'].includes(view.name) && eventObj.allDay) {
				return false;
			}
			if (eventObj.ranges) {
				const frequency = eventObj.week_number_recurrence;
				const start = eventObj.ranges[0].start;
				if (frequency > 0 && moment(eventObj.start).add(1, 'day').diff(start, "weeks") % frequency !== 0) {
					return false;
				}

				if (eventObj.end_date_utc && moment(eventObj.end_date_utc).isSameOrBefore(eventObj.start)) {
					return false;
				}

				if ((eventObj.exception_dates || []).some((t) => t.exception_date_utc === eventObj.start.toDate().toISOString())) {
					return false;
				}

				showTooltip(eventObj, $el);
				return (
					eventObj.ranges.filter(function (range) {
						return isInRange(localDateToUTC(eventObj.start),range.start,range.end);
					}).length > 0
				);
			}
			if (!eventObj.appointment) {
				showTooltip(eventObj, $el);
				return;
			}

			const appointment = eventObj.appointment;
			const status = eventObj.status || appointmentStatus(appointment.patient_seen);
			const isList = view.name === "listWeek";
			const title = isList ? $el.find(".fc-list-item-title") : $el.find(".fc-title");

			const badges = [];
			if (eventObj.roomClash) {
				badges.push(`<span class="appt-pill appt-pill-clash" title="Another appointment is in this room at the same time"><i class="fa fa-door-closed"></i> Room</span>`);
			}
			if (eventObj.clash) {
				badges.push(`<span class="appt-pill appt-pill-clash" title="${escapeHtml(awayLabel(eventObj.clash))}"><i class="fa fa-ban"></i> Leave</span>`);
			}
			if (status.label) {
				badges.push(`<span class="appt-pill appt-pill-${status.group}">${escapeHtml(status.label)}</span>`);
			}
			if (eventObj.invoice) {
				badges.push(`<span class="appt-invoice appt-invoice-${eventObj.invoice}" title="${INVOICE_LABELS[eventObj.invoice]}">$</span>`);
			}

			if (isList) {
				// The agenda has room to say what the grid only colours: the type, who it is with and where.
				const category = categoryFor(appointment.category_id, appointment.practice_id);
				const meta = [];
				if (category) {
					meta.push(`<span class="appt-meta-item"><i class="appt-swatch" style="background-color:${$scope.categoryColour(appointment.category_id, appointment.practice_id)}"></i>${escapeHtml(category.name)}</span>`);
				}
				if ($scope.currentSurgeon === "all") {
					meta.push(`<span class="appt-meta-item"><i class="appt-swatch round" style="background-color:${$scope.clinicianColour(appointment.clinician_id)}"></i>${escapeHtml(appointment.clinician_name)}</span>`);
				}
				if ($scope.currentPractice.id === -1) {
					meta.push(`<span class="appt-meta-item"><i class="appt-swatch round" style="background-color:${$scope.practiceColour(appointment.practice_id)}"></i>${escapeHtml(appointment.practice_name)}</span>`);
				}
				if (eventObj.room) {
					meta.push(`<span class="appt-meta-item"><i class="fa fa-door-open"></i>${escapeHtml(eventObj.room.name)}</span>`);
				}
				// Kept inside the title cell: the day headings span exactly FullCalendar's three columns.
				// The agenda's dot is the event's background - here the pale card tint - so it is given the
				// full colour back.
				$el.find(".fc-event-dot").css("background-color", eventObj.accent);
				title.empty().append($(
					`<div class="appt-list-cell">`
					+ `<a href class="appt-patient-link">${escapeHtml(eventObj.title)}</a>`
					+ `<span class="appt-list-meta">${meta.join("")}</span>`
					+ `<span class="appt-list-badges">${badges.join("")}</span>`
					+ `</div>`
				));
			} else if (badges.length > 0) {
				$el.addClass("has-badges").find(".fc-content").append(`<div class="appt-badges">${badges.join("")}</div>`);
			}

			// The patient's name opens their dashboard; anywhere else on the event opens the appointment.
			// On the grid the title is a full-width block, so the link is the name's own text inside it -
			// not the whole line, which reached to the card's far edge.
			if (!isList) {
				title.empty().append($('<span class="appt-patient-link"></span>').text(eventObj.title || ""));
				// A month's cells have no room for a second line.
				if (eventObj.room && view.name !== "month") {
					$el.find(".fc-content").append($('<div class="appt-room"></div>').text(eventObj.room.name)
						.prepend($('<i class="appt-swatch round"></i>').css("background-color", `#${eventObj.room.colour}`)));
				}
			}
			const patientLink = $el.find(".appt-patient-link");
			patientLink.click(function (event) {
				event.preventDefault();
				event.stopPropagation();
				$scope.forwardPatientDashboard(appointment);
			});

			removePopup();
			$el.popover({
				title: escapeHtml(eventObj.title),
				// Built when the card is shown, rather than for every appointment on every redraw.
				content: function () {
					return $(renderAppointmentPopover(eventObj, status));
				},
				trigger: 'hover',
				placement: 'auto top',
				container: 'body',
				html: true
			});
		};

		// An appointment's hover card goes when its card does. The card is shown in <body>, so when FullCalendar
		// redraws or changes view under the pointer - no mouseleave fires - it was left behind, sitting over
		// whichever appointment took that spot and giving another booking's date and time.
		function eventDestroy(eventObj, $el) {
			$el.popover("destroy");
		}

		// Hover card: everything needed to answer a phone call about this booking without opening it.
		function renderAppointmentPopover(eventObj, status) {
			const appointment = eventObj.appointment;
			const start = moment(eventObj.start);
			const end = eventObj.end ? moment(eventObj.end) : start.clone().add(appointment.duration_minutes, "minutes");
			const category = categoryFor(appointment.category_id, appointment.practice_id);
			const rows = [
				["When", `${start.locale("en").format("ddd D MMM, h:mm a")} – ${end.locale("en").format("h:mm a")}`],
				["Type", category ? category.name : null],
				["Clinician", appointment.clinician_name],
				["Practice", appointment.practice_name],
				["Room", eventObj.room ? eventObj.room.name : null],
				["Status", status.label],
			].filter((row) => row[1]);

			let html = `<div class="appt-popover">`;
			rows.forEach((row) => {
				html += `<div class="appt-popover-row"><span class="appt-popover-label">${row[0]}</span><span>${escapeHtml(row[1])}</span></div>`;
			});
			if (appointment.note) {
				html += `<div class="appt-popover-note">${escapeHtml(appointment.note)}</div>`;
			}
			(appointment.invoice_list || []).forEach((t) => {
				html += `<div class="appt-popover-invoice">$${escapeHtml(t.total)} &middot; ${escapeHtml(t.status)}</div>`;
			});
			return html + `</div>`;
		}

		$scope.dayClick = function (info) {
			// alert('clicked ' + info.dateStr);
		};

		$scope.onCategoryChange = function () {
			if (!$scope.appointment.category_id) {
				return;
			}
			const obj = $scope._appointment_categories.find(t => t.category_id === $scope.appointment.category_id);
			if (obj) {
				// Types set up before lengths were held to steps of 5 can carry any length - round theirs.
				$scope.appointment.duration_minutes = Math.max(10, Math.round(Number(obj.duration) / 5) * 5);
			}
		}

		$scope.selectAllow = function (selectInfo) {
			//TODO const event = $scope.availableEvents[0];
			if (moment(event.end).isBefore(selectInfo.start)) {
				return true;
			} else if (moment(event.start).isAfter(selectInfo.end)) {
				return true;
			}
			return false;
		}

		$scope.select = function (_range_start, _range_end) {
			// Run Validations
			const validationError = getValidationError(_range_start, _range_end);

			if (validationError) {
				withCalendar((calendar) => calendar.fullCalendar("unselect"));
				showValidationError(validationError);
				return false;
			}

			// With several clinicians on screen the grid cannot say whose time was picked, so the booking
			// form asks - unless only one of them is ticked.
			let clinicianId = null;
			if ($scope.currentSurgeon !== "all") {
				clinicianId = $scope.currentSurgeon;
			} else if ($scope.clinicianFilter.ids.length === 1) {
				clinicianId = $scope.clinicianFilter.ids[0];
			}
			openBookingModal(_range_start, _range_end, clinicianId);
		};

		function openBookingModal(start, end, clinicianId) {
			$scope.calendarNotice = null;
			const durationMinutes = moment.duration(end.diff(start)).asMinutes();
			const clinician = $scope.ophthalmologists.find(t => t.value == clinicianId);

			// Business Hours Logic
			const { start: bStart, end: bEnd } = $scope.uiConfig.calendar.businessHours;
			const [startH, startM] = bStart.split(':');
			const [endH, endM] = bEnd.split(':');

			$scope.minTime = start.clone().hour(startH).minute(startM);
			$scope.maxTime = start.clone().hour(endH).minute(endM);

			generateTimeSlots($scope.minTime, $scope.maxTime);

			// Object Assignment & Modal Launch
			$scope.appointmentAuditList = [];
			$scope.$ctrl.showAlert = unavailabilityWarning(clinicianId, clinician && clinician.name, start, end);
			resetPracticeLeaveState();
			$scope.$ctrl.liveChangeNotice = null;
			$scope.$ctrl.confirmDelete = false;
			$scope.appointment = {
				// No patient when the calendar was opened without one: the booking's patient picker asks.
				patient_name: $scope.patientId ? $scope.patientName : null,
				_startDateStr: start.format("DD/MM/YYYY"),
				patient_id: $scope.patientId || null,
				clinician_id: clinician ? clinician.value : null,
				clinician_name: clinician ? clinician.name : null,
				duration_minutes: durationMinutes,
				selectedTimeSlot: start.format('HH:mm'),
				// "All practices" cannot say which practice the time was picked for, so the booking asks.
				practice_id: $scope.currentPractice.id === -1 ? null : $scope.currentPractice.id,
			};
			$scope.appointment_clone = null;
			$scope.pickingPatient = !$scope.patientId;
			$scope.patientSearch = { results: [], searched: false, loading: false };
			$scope.patientPicker = { query: "", open: false, active: -1 };

			$scope._ophthalmologists = angular.copy($scope.ophthalmologists);
			// Each practice has its own appointment types: the booking's practice's are offered, and none until
			// a practice is chosen in the "all practices" view (onAppointmentPracticeChange loads that one's).
			loadPracticeCategories($scope.appointment);

			$scope.practiceName = queryPracticeName();
			$scope.detailsModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.appointment-detail.tpl.html",
				show: true,
				backdrop: "static",
				title: "New appointment",
			});

			// Booked without a patient: who it is for is the first thing to fill in, so the search is ready to
			// type into. After the modal's own show, which moves focus to the modal itself.
			if ($scope.pickingPatient) {
				const stopListening = $scope.$on("modal.show", function () {
					stopListening();
					$timeout(function () {
						const search = document.getElementById("appointment-patient");
						if (search) {
							search.focus();
						}
					}, 50);
				});
			}
		}

		const checkUnavailability = (calendarStart, calendarEnd) => {
			const result = $scope.blockEvents.some((event) => {
				// Every transformed block event carries a recurrence_type, one-offs included ('ONE_OFF'), and
				// one-offs have no week_number_recurrence - so the weekly branch's `% frequency` was NaN for
				// them and they never counted as unavailable. They are checked by date range below.
				if (event.recurrence_type && event.recurrence_type !== 'ONE_OFF') {
					if (event.ranges) {

						// Check if the day of the week matches.
						if (event.dow && event.dow.length > 0) {
							if (!event.dow.includes(calendarStart.day())) {
								return false;
							}
						}

						const frequency = event.week_number_recurrence;
						const start = event.ranges[0].start;
						if (moment(calendarStart).add(1, "day").diff(start, "weeks") % frequency !== 0) {
							return false;
						}

						if (event.start === "00:00:00") {
							// whole day event
							const diff = moment(calendarStart).diff(start, "days");
							const isNegtive = moment(calendarStart).diff(start, "days", true) < 0;
							return diff % 7 === 0 && !isNegtive;
						}

						const isSelectedDay =
							event.ranges.filter(function (range) {
								const isSameDay = calendarEnd.isSame(range.start, "day");
								return calendarStart.isBefore(range.end) && (isSameDay || calendarEnd.isAfter(range.start));
							}).length > 0;
						if (!isSelectedDay) {
							return false;
						}

						const [h, m] = event.start.split(":").map(Number);
						const newStart = moment(calendarStart).hour(h).minute(m).second(0);
						const [h1, m1] = event.end.split(":").map(Number);
						const newEnd = moment(calendarStart).hour(h1).minute(m1).second(0);
						return (
							calendarStart.isBetween(newStart, newEnd, null, "[)") ||
							calendarEnd.isBetween(newStart, newEnd, null, "()") ||
							newStart.isBetween(calendarStart, calendarEnd, null, "()")
						);
					} else {
						return false;
					}
				} else {
					if (!event.ranges || !event.ranges[0]) {
						return false;
					}
					if (!isInRange(localDateToUTC(calendarStart), event.ranges[0].start, event.ranges[0].end)) {
						return false;
					}
					// A one-off recorded against hours of the day (its end_date_utc is the end of that day) only
					// blocks those hours; one with no time, or starting at midnight, is the whole day.
					if (!event.start || !event.end || event.start === "00:00:00") {
						return true;
					}
					const [h, m] = event.start.split(":").map(Number);
					const blockStart = moment(calendarStart).hour(h).minute(m).second(0);
					const [h1, m1] = event.end.split(":").map(Number);
					const blockEnd = moment(calendarStart).hour(h1).minute(m1).second(0);
					return (
						calendarStart.isBetween(blockStart, blockEnd, null, "[)") ||
						calendarEnd.isBetween(blockStart, blockEnd, null, "()") ||
						blockStart.isBetween(calendarStart, calendarEnd, null, "()")
					);
				}
			});
			return result;
		};

		/**
		 * The warning for booking into someone's time away, naming them and why. Uses the leave worked out
		 * per clinician where it has been loaded, and the old check against the one clinician being
		 * viewed otherwise. Booking is still allowed - cover and emergencies happen.
		 */
		function unavailabilityWarning(clinicianId, clinicianName, start, end) {
			const away = clinicianId ? awayDuring(clinicianId, start, end) : null;
			const who = clinicianName ? clinicianName.replace(" (Me)", "") : "The clinician";
			if (away) {
				return `${who} is away at this time (${awayLabel(away)}). You can still book if you need to.`;
			}
			if (away === undefined && String(clinicianId) === String($scope.currentSurgeon) && checkUnavailability(start, end)) {
				return 'The clinician is unavailable during this time slot.';
			}
			return null;
		}

		function showValidationError(message) {
			$scope.calendarNotice = message;
			$scope.practiceLeaveMove = null;
		}

		/**
		 * Helper to isolate validation logic
		 */
		function getValidationError(start, end) {
			if (!Array.isArray(start._i)) {
				return 'Invalid selection range. Please try clicking and dragging again.';
			}

			if (start.isBefore(moment().subtract(7, 'd'))) {
				return 'Cannot schedule appointments more than 7 days in the past.';
			}

			if (!$scope.currentSurgeon) {
				return 'Please select a clinician to schedule.';
			}

			return null; // All clear
		}

		// The dialog edits a copy (prepareAppointmentDetails), so there is nothing on the grid to put back.
		$scope.closeDetailsModal = function () {
			$scope.detailsModal.hide();
		}

		function queryPracticeName() {
			const target = $scope.practiceSummaryList.find(t => t.id === $scope.currentPractice.id);
			if (target) {
				return target.name;
			}
			return $scope.Session.practice.name;
		}

		$scope.didFixBackground = false;
		let fixBackgroundTimer = null;
		// A pill on the day header of each day the clinician is away - visible even when the time away is
		// scrolled out of view.
		function decorateDayHeaders(view) {
			view.el.find("th.fc-day-header .fc-col-away, th.fc-day-header .fc-col-sessions, th.fc-day-header .fc-col-holiday").remove();
			view.el.find("th.fc-day-header.is-away").removeClass("is-away");
			view.el.find("th.fc-day-header.is-holiday").removeClass("is-holiday");
			// Public holidays are the practice's, so they show whoever is selected.
			if (["agendaWeek", "agendaDay"].includes(view.name)) {
				view.el.find("th.fc-day-header[data-date]").each(function () {
					const holidays = holidaysOn($(this).attr("data-date"));
					if (holidays.length) {
						const labels = holidays.map((t) => t.label).join("; ");
						$(this).addClass("is-holiday").append($(`<span class="fc-col-holiday"><i class="fa fa-flag"></i> </span>`)
							.attr("title", labels).append(document.createTextNode(labels)));
					}
				});
			}
			if (!["agendaWeek", "agendaDay"].includes(view.name) || $scope.currentSurgeon === "all"
				|| $scope.currentPractice.id === -1 || !$scope.availabilityRowsLoaded) {
				return;
			}
			view.el.find("th.fc-day-header[data-date]").each(function () {
				const { away, sessions } = availabilityOn($scope.availabilityRows, $(this).attr("data-date"));
				if (away.length) {
					$(this).append($(`<span class="fc-col-away"><i class="fa fa-ban"></i> </span>`)
						.attr("title", away.map(awayLabel).join("; "))
						.append(document.createTextNode(awayShortLabel(away))));
					$(this).addClass("is-away");
				}
				// What the clinician is on for that day, by type - the hover says when and how often.
				if (sessions.length && !away.some((block) => block.allDay)) {
					const list = $('<span class="fc-col-sessions"></span>');
					sessions.slice(0, 2).forEach((block) => {
						list.append($('<span class="fc-col-session"></span>')
							.attr("title", sessionTooltip(block))
							.append($('<i class="bg-swatch"></i>').css("background-color", sessionColour(block)))
							.append(document.createTextNode(sessionLabel(block))));
					});
					if (sessions.length > 2) {
						list.append($('<span class="fc-col-session more"></span>')
							.attr("title", sessions.slice(2).map(sessionTooltip).join("; "))
							.text(`+${sessions.length - 2} more`));
					}
					$(this).append(list);
				}
			});
		}

		function eventAfterAllRender(view) {
			decorateDayHeaders(view);
			if (!$scope.didFixBackground) {
				// This callback fires after all events are drawn, but the DOM may still not be stable. A small delay fixes it -
				// a second after the last of the draws as the calendar opens, once. In a digest - see
				// withCalendarInDigest; from a bare setTimeout it ran a digest of the whole app for every event.
				$timeout.cancel(fixBackgroundTimer);
				fixBackgroundTimer = $timeout(function () {
					fixBackgroundTimer = null;
					// Before the redraw, which comes back through here.
					$scope.didFixBackground = true;
					// Not under a drag - see drawCalendarEvents.
					if (calendarInteraction) {
						calendarRedrawHeld = true;
					} else {
						withCalendarInDigest((calendar) => calendar.fullCalendar("rerenderEvents"));
					}
				}, 1000, false);
			}
			
			if (view.name !== "listWeek") {
				return;
			}
			view.el.find('.fc-list-heading .fc-widget-header').each(function () {
				const selectedDate = $(this).parent().attr('data-date');
				// The same icons as the welcome page's appointment list.
				const downloads = $(
					'<span class="fc-list-heading-alt appointment-list-downloads">' +
						'<a href class="appointment-list-download-csv" title="Download CSV"><i class="fa-solid fa-file-csv"></i></a>' +
						'<a href class="appointment-list-download-pdf" title="Download PDF"><img src="app/build/img/download.svg" alt="Download PDF"></a>' +
					'</span>'
				);
				downloads.find('.appointment-list-download-csv').click(function (event) {
					event.preventDefault();
					event.stopPropagation();
					downloadAppointmentList(selectedDate, "csv");
				});
				downloads.find('.appointment-list-download-pdf').click(function (event) {
					event.preventDefault();
					event.stopPropagation();
					downloadAppointmentList(selectedDate, "pdf");
				});
				$(this).append(downloads);
			})
		}

		// The team view's dashed "+ Book 9:30 am" marker, on the day and week grids too: it follows the
		// pointer, snapped to the slot a click would book. Worked out from FullCalendar's own slot rows and
		// day cells, and bound outside Angular - a digest per mouse move would be wasted on it. Rebound on
		// every viewRender, as FullCalendar can redraw the grid underneath it.
		function attachBookingGhost(view) {
			const grid = view.el.find(".fc-time-grid");
			grid.off(".bookingGhost").find(".fc-book-ghost").remove();
			if (view.name !== "agendaDay" && view.name !== "agendaWeek") {
				return;
			}
			const ghost = $('<div class="fc-book-ghost"><i class="fa fa-plus"></i> Book <span class="fc-book-ghost-time"></span></div>')
				.appendTo(grid);

			function within(el, event) {
				const rect = el.getBoundingClientRect();
				return event.clientX >= rect.left && event.clientX < rect.right
					&& event.clientY >= rect.top && event.clientY < rect.bottom;
			}

			grid.on("mousemove.bookingGhost", function (event) {
				// Not over an appointment, and not while something is being dragged or a range selected.
				if (!$scope.canBook() || event.buttons || $(event.target).closest(".fc-event, .fc-more").length) {
					ghost.hide();
					return;
				}
				const day = grid.find(".fc-bg td.fc-day").toArray().find((el) => {
					const rect = el.getBoundingClientRect();
					return event.clientX >= rect.left && event.clientX < rect.right;
				});
				const slot = grid.find(".fc-slats tr[data-time]").toArray().find((el) => within(el, event));
				if (!day || !slot) {
					ghost.hide();
					return;
				}
				const gridRect = grid[0].getBoundingClientRect();
				const dayRect = day.getBoundingClientRect();
				const slotRect = slot.getBoundingClientRect();
				ghost.css({
					display: "flex",
					top: slotRect.top - gridRect.top + "px",
					left: dayRect.left - gridRect.left + 3 + "px",
					width: dayRect.width - 6 + "px",
					height: slotRect.height + "px",
				});
				ghost.find(".fc-book-ghost-time").text(moment($(slot).attr("data-time"), "HH:mm:ss").locale("en").format("h:mm a"));
			});
			grid.on("mouseleave.bookingGhost mousedown.bookingGhost", function () {
				ghost.hide();
			});
		}

		// Takes the hover card away as the pointer leaves an appointment, as FullCalendar's eventMouseout did -
		// on the same elements (its segSelector for the grids and the agenda). Bound outside Angular, as
		// ui-calendar ran eventMouseout in a digest of the whole app on every mouse-out, and nothing here
		// needs one. Rebound on every viewRender, as for the booking ghost.
		function bindPopupCleanup(view) {
			view.el.off(".popupCleanup").on("mouseleave.popupCleanup", ".fc-event-container > *, .fc-list-item", removePopup);
		}

		// A navigation click fires viewRender once per step, and each fetch is expensive on the back
		// end (the appointment list is decorated with Xero invoice data, which is rate-limited). The
		// fetch is debounced so flicking through several weeks costs one request for the settled view,
		// not one per step.
		let viewRenderFetchTimer = null;
		let firstRangeRendered = false;
		function viewRender(view, element) {
			ownCalendar = view.calendar.el;
			$scope.startDate = view.start.format();
			$scope.view.title = view.title;
			$scope.visibleRange = {
				start: view.intervalStart.format("YYYY-MM-DD"),
				end: view.intervalEnd.format("YYYY-MM-DD"),
			};
			// Every day drawn, including a month's leading and trailing days - leave is laid out over these.
			$scope.renderedRange = {
				start: view.start.format("YYYY-MM-DD"),
				end: view.end.format("YYYY-MM-DD"),
			};
			// So the calendar reopens on this range - see openingDate.
			if (ShareData.savedCalendarFilters.viewPrefs.date !== $scope.visibleRange.start) {
				ShareData.setCalendarViewPrefs({ date: $scope.visibleRange.start });
			}
			syncMiniMonth(view.intervalStart);
			buildTeamModel();
			attachBookingGhost(view);
			bindPopupCleanup(view);

			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();

			// The view's dates are wall dates with no zone (timezone: "none"), so they are read as dates in
			// the practice's zone. Converting them from the browser's zone instead moved the range a day early
			// whenever the browser was ahead of the practice (an NZ browser on an AU practice), dropping the
			// last day on screen from the fetch.
			const practiceStart = moment.tz(view.start.format("YYYY-MM-DD"), practiceTimezoneName);
			const practiceEnd = moment.tz(view.end.format("YYYY-MM-DD"), practiceTimezoneName);

			$scope.calendar_range_start = practiceStart.clone().utc().toISOString();
			$scope.calendar_range_end = practiceEnd.clone().utc().toISOString();

			if (viewRenderFetchTimer) {
				$timeout.cancel(viewRenderFetchTimer);
			}
			// The range the calendar opens on is fetched at once - there is nothing to debounce yet.
			if (!firstRangeRendered) {
				firstRangeRendered = true;
				fetchPatientAppointments({ joinInFlight: true });
				return;
			}
			viewRenderFetchTimer = $timeout(function () {
				viewRenderFetchTimer = null;
				fetchPatientAppointments({ joinInFlight: true });
			}, 300);
		}

		// var date = new Date();
		// var d = date.getDate();
		// var m = date.getMonth();
		// var y = date.getFullYear();

		/* event source that contains custom events on the scope */
		// $scope.events = [
		// 	{ title: "All Day Event", start: new Date(y, m, 1) },
		// 	{ title: "Long Event", start: new Date(y, m, d - 5), end: new Date(y, m, d - 2) },
		// 	{ id: 999, title: "Repeating Event", start: new Date(y, m, d - 3, 16, 0), allDay: false },
		// 	{ id: 999, title: "Repeating Event", start: new Date(y, m, d + 4, 16, 0), allDay: false },
		// 	{ title: "Birthday Party", start: new Date(y, m, d + 1, 19, 0), end: new Date(y, m, d + 1, 22, 30), allDay: false },
		// 	{ title: "Click for Google", start: new Date(y, m, 28), end: new Date(y, m, 29), url: "http://google.com/" },
		// ];
		// $scope.eventSources = [$scope.events];

		$scope.hide = function () {
			$mdDialog.hide();
		};

		$scope.cancel = function () {
			$mdDialog.cancel();
		};

		$scope.answer = function (answer) {
			$mdDialog.hide(answer);
		};

		// Taken off the calendar and the dialog closed at once; put back, with a notice, if the server refuses.
		$scope.deleteAppointment = function (obj) {
			const change = showLocalChange(obj.patient_appointment_id, null, appointmentInList(obj.patient_appointment_id));
			if ($scope.detailsModal) {
				$scope.detailsModal.hide();
			}
			$scope.API.deleteAppointment(obj.patient_id,
				obj.patient_appointment_id, obj.practice_id)
				.then(
					function () {
						localChangeSaved(change);
					},
					function () {
						localChangeFailed(change);
						showValidationError("That appointment could not be deleted.");
					}
				);
		};

		$scope.onPatientSeenChange = function (item) {
			if ($scope.appointment.patient_seen[item]) {
				$scope.appointment.patient_seen[`${item}_timestamp`] = new Date().toISOString();
			} else {
				$scope.appointment.patient_seen[`${item}_timestamp`] = null;
			}

			if (!$scope.appointment.patient_seen.could_not_attend && !$scope.appointment.patient_seen.did_not_attend) {
				$scope.appointment.patient_seen.rebooked_timestamp = null;
				$scope.appointment.patient_seen.rebooked = false;
			}
		}

		// dd/MM/yyyy => yyyy-MM-dd
		const convertDateFormat = (original) => {
			const [day, month, year] = original.split("/");
			return `${year}-${month}-${day}`;
		};

		// The read-only summary in the appointment details modal is derived from the
		// date/time currently selected in the form, so it populates for every way the
		// modal is opened and stays correct when either field is changed.
		$scope.formatAppointmentStart = function (appointment, format) {
			if (!appointment || !appointment._startDateStr || !appointment.selectedTimeSlot) {
				return "";
			}
			const start = moment(
				`${convertDateFormat(appointment._startDateStr)}T${appointment.selectedTimeSlot}`
			);
			return start.isValid() ? start.locale("en").format(format) : "";
		};

		// The API writes `date_created` as a Pacific/Auckland wall-clock timestamp with
		// no offset, so it has to be read back in that zone before being re-displayed in
		// the practice's own timezone.
		$scope.formatAppointmentBookedAt = function (appointment) {
			if (!appointment || !appointment.date_created) {
				return "";
			}
			const bookedAt = moment.tz(appointment.date_created, "Pacific/Auckland").tz(getPracticeTimezoneNameById(appointment.practice_id));
			return bookedAt.isValid() ? bookedAt.locale("en").format("DD/MM/YYYY h:mm A") : "";
		};

		/* =================================================================== */
		/* Rooms in the booking dialog
		/* =================================================================== */

		// Reloaded whenever the dialog's practice or day changes - opening it, or editing either field.
		let modalRoomRequest = null;
		$scope.$watch(
			() => $scope.appointment && `${$scope.appointment.practice_id}|${$scope.appointment._startDateStr}`,
			function () {
				loadModalRoomBookings($scope.appointment);
			}
		);

		// A double-booking is confirmed for one room at one time - changing either asks again.
		$scope.$watch(
			() => $scope.appointment && [$scope.appointment.room_id, $scope.appointment._startDateStr,
				$scope.appointment.selectedTimeSlot, $scope.appointment.duration_minutes].join("|"),
			function (now, before) {
				if (now !== before && $scope.appointment) {
					$scope.appointment.allow_room_double_booking = false;
					$scope.roomServerConflict = null;
				}
			}
		);

		function loadModalRoomBookings(appointment) {
			$scope.modalRooms = [];
			$scope.modalRoomBookings = [];
			if (!appointment || !appointment.practice_id || !appointment._startDateStr) {
				modalRoomRequest = null;
				return;
			}
			const practiceId = appointment.practice_id;
			const request = `${practiceId}|${appointment._startDateStr}`;
			modalRoomRequest = request;
			const dayStart = moment.tz(convertDateFormat(appointment._startDateStr), getPracticeTimezoneNameById(practiceId)).startOf("day");

			loadRooms(practiceId).then(function (rooms) {
				if (modalRoomRequest !== request) {
					return;
				}
				// An archived room is only offered to the appointment already in it.
				const offered = rooms.filter((room) => room.is_active || room.room_id === appointment.room_id);
				$scope.modalRooms = offered.length ? [NO_ROOM].concat(offered) : [];
				if (!offered.length) {
					return;
				}
				return PracticeService.getRoomBookings(practiceId, dayStart.clone().utc().toISOString(), dayStart.clone().add(1, "day").utc().toISOString())
					.then(function (response) {
						if (modalRoomRequest === request) {
							$scope.modalRoomBookings = response.data || [];
						}
					});
			}).catch(function (error) {
				console.error("Room bookings could not be loaded:", error && error.status);
			});
		}

		// The time the dialog's appointment takes, in its practice's timezone.
		function dialogAppointmentWindow(appointment) {
			if (!appointment || !appointment.practice_id || !appointment._startDateStr || !appointment.selectedTimeSlot || !appointment.duration_minutes) {
				return null;
			}
			const start = moment.tz(`${convertDateFormat(appointment._startDateStr)}T${appointment.selectedTimeSlot}`, getPracticeTimezoneNameById(appointment.practice_id));
			return { start: start, end: start.clone().add(appointment.duration_minutes, "minutes") };
		}

		// The other appointment in this room at the dialog's time, if any.
		$scope.roomBookingFor = function (roomId) {
			const appointment = $scope.appointment;
			const window = dialogAppointmentWindow(appointment);
			if (!roomId || !window) {
				return null;
			}
			return $scope.modalRoomBookings.find(function (booking) {
				const start = moment.utc(booking.start_date_utc);
				return booking.room_id === roomId
					&& booking.patient_appointment_id !== appointment.patient_appointment_id
					&& start.isBefore(window.end)
					&& window.start.isBefore(start.clone().add(booking.duration_minutes, "minutes"));
			}) || null;
		};

		$scope.roomBookingLabel = function (booking) {
			if (!booking) {
				return "";
			}
			const timezoneName = getPracticeTimezoneNameById($scope.appointment.practice_id);
			const start = moment.utc(booking.start_date_utc).tz(timezoneName);
			const end = start.clone().add(booking.duration_minutes, "minutes");
			const times = `${start.locale("en").format("h:mm")}–${end.locale("en").format("h:mm a")}`;
			return booking.clinician_name ? `${times} · ${booking.clinician_name}` : times;
		};

		$scope.dialogRoomName = function () {
			const room = roomFor($scope.appointment && $scope.appointment.room_id, $scope.appointment && $scope.appointment.practice_id);
			return room ? room.name : "This room";
		};

		// What the server checks the room again for: a new appointment, or a change of room, practice, time or
		// length. Editing only the note of an appointment that was knowingly double-booked doesn't ask again.
		function isRoomBookingChanged(appointment) {
			const saved = $scope.appointment_clone;
			if (!appointment.patient_appointment_id || !saved) {
				return true;
			}
			if (appointment.room_id !== saved.room_id || appointment.practice_id !== saved.practice_id
				|| Number(appointment.duration_minutes) !== Number(saved.duration_minutes)) {
				return true;
			}
			const savedStart = moment.utc(saved.start_date_utc).tz(getPracticeTimezoneNameById(saved.practice_id));
			return appointment.selectedTimeSlot !== savedStart.format("HH:mm")
				|| appointment._startDateStr !== savedStart.format("DD/MM/YYYY");
		}

		// Whether the room picked is in use: the other booking, or the server's own refusal when someone
		// booked the room after the dialog loaded its bookings.
		$scope.isRoomBusy = function () {
			const appointment = $scope.appointment;
			if (!appointment || !appointment.room_id) {
				return false;
			}
			return !!($scope.roomServerConflict
				|| (isRoomBookingChanged(appointment) && $scope.roomBookingFor(appointment.room_id)));
		};

		// Free rooms to switch to, offered in the busy-room notice.
		$scope.freeRooms = function () {
			const appointment = $scope.appointment;
			return $scope.modalRooms.filter((room) => room.room_id && room.is_active
				&& room.room_id !== appointment.room_id && !$scope.roomBookingFor(room.room_id));
		};

		$scope.useRoom = function (roomId) {
			$scope.appointment.room_id = roomId;
		};

		$scope.saveAppointment = function (valid) {
			// The patient field is a plain search box, so the form does not know it is required.
			if ($scope.pickingPatient && !$scope.appointment.patient_appointment_id && !$scope.appointment.patient_id) {
				return;
			}
			if (!valid) {
				console.log("invalid form");
				return;
			}
			if ($scope.isBlockedByPracticeLeave()) {
				return;
			}

			$scope.API.isProcessing = true;

			// Work on a clean copy to avoid mutating the UI object.
			const finalAppointment = angular.copy($scope.appointment);

			// 1) Date comes from the selected day (_startDateStr).
			const datePart = finalAppointment._startDateStr;

			// 2) Time comes from the dropdown.
			const timePart = finalAppointment.selectedTimeSlot;

			// 3) Build a zoned moment in the timezone of the appointment's *selected*
			// practice (which may differ from the calendar's practice when the
			// appointment is being moved between practices), so the wall-clock time the
			// user entered is interpreted in the correct timezone.
			const practiceTimezoneName = getPracticeTimezoneNameById(finalAppointment.practice_id);
			const finalMomentInPracticeTz = moment.tz(`${convertDateFormat(datePart)}T${timePart}`, practiceTimezoneName);

			// 4) Persist as a UTC instant.
			finalAppointment.start_date_utc = finalMomentInPracticeTz.utc().toISOString();

			// 5) Remove UI-only fields before sending.
			delete finalAppointment._startDateStr;
			// Only sent to confirm a double-booking; a false one says nothing.
			if (!finalAppointment.allow_room_double_booking) {
				delete finalAppointment.allow_room_double_booking;
			}

			// Only sent when the booking is actually inside the leave and Book anyway is ticked.
			const overridePracticeLeave = !!($scope.$ctrl.overridePracticeLeave && $scope.practiceLeaveClash());
			$scope.$ctrl.saveError = null;

			// The dialog's own copy, to open it again on if the server refuses the save.
			const dialogAppointment = $scope.appointment;

			// Update vs Create
			if (finalAppointment.patient_appointment_id) {
				// On the calendar and the dialog closed at once - see showLocalChange.
				const change = showLocalChange(finalAppointment.patient_appointment_id, withDisplayNames(angular.copy(finalAppointment)),
					appointmentInList(finalAppointment.patient_appointment_id));
				finishSave(null);
				$scope.API.updateAppointment(
					finalAppointment.patient_id,
					finalAppointment.patient_appointment_id,
					finalAppointment,
					finalAppointment.practice_id,
					overridePracticeLeave
				)
					.then(function (resp) {
						localChangeSaved(change, resp.data);
					}, function (error) {
						localChangeFailed(change);
						reopenRefusedSave(error, dialogAppointment);
					});
				return;
			}

			// Booking from the surgery waitlist: once the booking dialog has gone, the calendar closes too, with the
			// appointment for the eye's surgery date - which needs the server's answer, so this one waits for it.
			if (bookingFor) {
				$scope.API.bookAppointment(finalAppointment, finalAppointment.practice_id, overridePracticeLeave)
					.then(function (resp) {
						if (resp.data) {
							const stopListening = $scope.$on("modal.hide", function () {
								stopListening();
								$mdDialog.hide({ bookedAppointment: resp.data });
							});
						} else {
							refetchAppointments();
						}
						finishSave(null);
					}, finishSave);
				return;
			}

			const unsavedId = `unsaved-${++newAppointmentSequence}`;
			const change = showLocalChange(unsavedId, withDisplayNames(angular.extend(angular.copy(finalAppointment), {
				patient_appointment_id: unsavedId,
				invoice_list: [],
			})), null);
			finishSave(null);
			$scope.API.bookAppointment(finalAppointment, finalAppointment.practice_id, overridePracticeLeave)
				.then(function (resp) {
					localChangeSaved(change, resp.data);
				}, function (error) {
					localChangeFailed(change);
					reopenRefusedSave(error, dialogAppointment);
				});
		};

		// A save refused after its dialog had closed. A clash (409) opens the dialog again as it was left, with the
		// reason, so the time or room can be changed - unless another appointment has been opened since, when the
		// calendar says it instead. Anything else is said on the calendar.
		function reopenRefusedSave(error, dialogAppointment) {
			const clash = error && error.status === 409;
			if (clash && $scope.appointment === dialogAppointment && $scope.detailsModal && !$scope.detailsModal.$isShown) {
				$scope.detailsModal.show();
				finishSave(error);
				return;
			}
			showValidationError(clash
				? ExceptionAPI.serverMessage(error) || "That appointment could not be saved at that time."
				: "That appointment could not be saved.");
		}

		// A booking refused with a 409 keeps the dialog open so it can be changed. A room someone booked since the
		// dialog loaded its bookings shows the busy-room notice, with the bookings read again; anything else -
		// practice leave - shows the reason. Other errors close it, as before.
		function finishSave(error) {
			$scope.API.isProcessing = false;
			if (error && error.status === 409) {
				if (ExceptionAPI.serverCode(error) === ROOM_DOUBLE_BOOKED) {
					$scope.roomServerConflict = ExceptionAPI.serverMessage(error) || "That room is already booked at that time.";
					loadModalRoomBookings($scope.appointment);
					return;
				}
				$scope.$ctrl.saveError = ExceptionAPI.serverMessage(error) || "This time can't be booked.";
				return;
			}
			if ($scope.detailsModal) {
				$scope.detailsModal.hide();
			}
		}

		$scope.appointmentAuditList = [];

		$scope.utc2local = function (utc) {
			const practiceTz = $scope.resolvePracticeTimezoneName();
			return moment.utc(utc).tz(practiceTz).format("DD/MM/YYYY HH:mm");
		}

		function fetchAppointmentAudit(appointmentId) {
			$scope.appointmentAuditList = [];
			// Ask the appointment's own practice: in the "all practices" view currentPractice.id is -1,
			// which the server rejects as a practice id.
			const practiceId = $scope.appointment && $scope.appointment.practice_id ? $scope.appointment.practice_id : $scope.currentPractice.id;
			$scope.API.getReminderAudit(appointmentId, practiceId).then(function (response) {
				// Another appointment may have been opened while this was in flight.
				if (!$scope.appointment || String($scope.appointment.patient_appointment_id) !== String(appointmentId)) {
					return;
				}
				$scope.appointmentAuditList = response.data;
				$scope.appointmentAuditList.sort((a, b) => moment.utc(a.reminder_sent_time_UTC).valueOf() - moment.utc(b.reminder_sent_time_UTC).valueOf());
			})
		}

		$scope.sendManualReminder = function (patient_appointment_id, patient_id) {
			$scope.API.isProcessing = true;
			$scope.API.sendReminder(patient_appointment_id, patient_id, $scope.appointment && $scope.appointment.practice_id)
				.then(
					function () {
						// The server stamps previous_manual_reminder_time_UTC on the appointment when it
						// sends. Mirror it locally - on the dialog's copy, its snapshot and the appointment
						// on the calendar - so the 10 minute cooldown starts without having to refetch the
						// appointment, and is still running if it is opened again.
						const sentAtUTC = moment.utc().format("YYYY-MM-DDTHH:mm:ss");
						$scope.appointment.previous_manual_reminder_time_UTC = sentAtUTC;
						if ($scope.appointment_clone) {
							$scope.appointment_clone.previous_manual_reminder_time_UTC = sentAtUTC;
						}
						($scope.allAppointments || []).concat(($scope.events || []).map((t) => t.appointment))
							.filter((t) => t && String(t.patient_appointment_id) === String(patient_appointment_id))
							.forEach((t) => {
								t.previous_manual_reminder_time_UTC = sentAtUTC;
							});
						scheduleManualReminderCooldownExpiry();
						fetchAppointmentAudit(patient_appointment_id);
					},
					function (error) {
						// A reminder usually fails because the patient's email address or mobile number is
						// wrong or missing - something the person looking at the screen can go and fix - so
						// they get told that, with the server's own reason underneath, rather than the
						// generic "unable to process your request" wording.
						$scope.alertMessage = "The reminder could not be sent. Check the patient's email address and mobile number, then try again.";
						$scope.alertDetail = ExceptionAPI.serverMessage(error);
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "Reminder not sent",
						});
					}
				)
				.then(function () {
					$scope.API.isProcessing = false;
				});
		}

		$scope.onSurgeonChange = function () {
			$scope.practiceSummaryList = buildPracticeList();

			const target = $scope.ophthalmologists.find((t) => t.value == $scope.currentSurgeon);
			if (target || $scope.currentSurgeon === "all") {
				if (!$scope.practiceSummaryList.find((t) => t.id === $scope.currentPractice.id)) {
					// A clinician can have no practice with the calendar feature; null makes the fetches stand down.
					// Everyone at once with no practice to offer keeps whatever is selected, as before.
					const first = $scope.practiceSummaryList.find((t) => t.id !== -1);
					if (first) {
						$scope.currentPractice.id = first.id;
					} else if (target) {
						$scope.currentPractice.id = null;
					}
				}
				$scope.ShareDataService.setSavedCalendarUser(Session.practice.id, $scope.currentSurgeon);
			}

			$scope.onPracticeChange();
		}

		function toClinicianOption(doc) {
			return {
				name: doc.firstName + " " + doc.lastName + `${Number(Session.userId) === doc.id ? " (Me)" : ""}`,
				value: doc.id,
				practiceSummaryList: doc.practiceSummaryList,
			};
		}

		// "All practices": each practice has its own appointment types, so colouring by type needs every
		// practice's list - cached in categoriesGroup alongside the ones loaded one practice at a time.
		function loadAllPracticeCategories() {
			const missing = $scope.practiceSummaryList
				.filter((t) => t.id !== -1 && !$scope.categoriesGroup.some((g) => g.practice === t.id))
				.map((t) => t.id);
			$q.all(missing.map((id) => $scope.PracticeAPI.queryCalendarSetting(id).then(function (resp) {
				if (!$scope.categoriesGroup.some((g) => g.practice === id)) {
					$scope.categoriesGroup.push({ practice: id, appointment_categories: angular.copy(resp.data.appointment_categories) });
				}
			}, angular.noop))).then(function () {
				if ($scope.currentPractice.id === -1 && missing.length > 0) {
					renderAppointmentEvents($scope.allAppointments);
				}
			});
		}

		// "All practices": the clinician list is everyone at any of them, not just the last practice
		// looked at, so anyone whose appointments are on screen can be picked out in the rail.
		function loadClinicianDirectory() {
			const requestedPracticeId = $scope.currentPractice.id;
			const practiceIds = $scope.practiceSummaryList.filter((t) => t.id !== -1).map((t) => t.id);
			loadClinicianLists(practiceIds, function (lists) {
				if (requestedPracticeId !== $scope.currentPractice.id) {
					return;
				}
				const merged = [];
				lists.forEach((list) => (list || []).forEach((doc) => {
					if (!merged.some((t) => t.value === doc.id)) {
						merged.push(toClinicianOption(doc));
					}
				}));
				if (merged.length === 0) {
					return;
				}
				$scope.ophthalmologists = merged;
				sortOphthalmologists(false);
				renderAppointmentEvents($scope.allAppointments);
			});
		}

		$scope.onPracticeChange = function () {
			updateCurrentPracticeMeta($scope.currentPractice.id);
			// Before the "All practices" branch returns, so that choice is remembered too.
			$scope.ShareDataService.setSavedCalendarPractice(Session.practice.id, $scope.currentPractice.id);
			prunePracticeFilter();

			// Refresh the timezone before anything fetches: viewRender derives
			// calendar_range_start/end from it, so fetching first asked for the previous
			// practice's window.
			if ($scope.currentPractice.id === -1) {
				availabilitySequence++; // drop any availability fetch still in flight for the previous practice
				$scope.availableEvents = [];
				$scope.blockEvents = [];
				refreshCalendarTimezoneNow();
				fetchPatientAppointments();
				loadAllPracticeCategories();
				// Everyone at any of the practices, whoever is selected - the list should match what is shown.
				loadClinicianDirectory();
				return;
			}
			refreshCalendarTimezoneNow();
			$scope.fetchCalendarAvailability($scope.currentPractice.id);
			fetchUserSettings();

			const requestedPracticeId = $scope.currentPractice.id;
			loadClinicianLists([requestedPracticeId], function (lists) {
				// A later practice change has its own list on the way - don't overwrite it with this one.
				if (requestedPracticeId !== $scope.currentPractice.id || !lists[0]) {
					return;
				}
				$scope.ophthalmologists = lists[0].map(toClinicianOption);
				sortOphthalmologists(false);
				// The rail and the clinician colours are drawn from this list.
				renderAppointmentEvents($scope.allAppointments);
			});

			// fetchDoctors($scope.currentPractice.id);
		};


		function downloadFile(data, filename, mime, bom) {
			// https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
			var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
			var blob = new Blob(blobData, { type: mime || "application/pdf" });
			if (typeof window.navigator.msSaveBlob !== "undefined") {
				// IE workaround for "HTML7007: One or more blob URLs were
				// revoked by closing the blob for which they were created.
				// These URLs will no longer resolve as the data backing
				// the URL has been freed."
				window.navigator.msSaveBlob(blob, filename);
			} else {
				var blobURL = window.URL.createObjectURL(blob);
				var tempLink = document.createElement("a");
				tempLink.style.display = "none";
				tempLink.href = blobURL;
				tempLink.setAttribute("download", filename);

				// Safari thinks _blank anchor are pop ups. We only want to set _blank
				// target if the browser does not support the HTML5 download attribute.
				// This allows you to download files in desktop safari if pop up blocking
				// is enabled.
				if (typeof tempLink.download === "undefined") {
					tempLink.setAttribute("target", "_blank");
				}

				document.body.appendChild(tempLink);
				tempLink.click();
				document.body.removeChild(tempLink);
				window.URL.revokeObjectURL(blobURL);
				$scope.displaySpinner = false;
			}
		}

		function getFileName(extension, label) {
			var theTime = $filter("date")(new Date(), "yyyy-MM-dd@hmma");
			return (
				"CatTrax_appointments_" +
				(label ? label.replace(/[^A-Za-z0-9]+/g, "_") + "_" : "") +
				theTime +
				"." + (extension || "pdf")
			);
		}

		function downloadAppointmentList(selectedDate, format) {
			// $scope.events also holds the availability shading and "all practices" day markers, which
			// have no appointment. The list headings are dated in practice wall time, as the events are
			// placed, so the day is taken in that timezone rather than the browser's. Only the clinicians
			// and practices on screen are included.
			const appointments = $scope.events
				.filter((t) => t.appointment && isAppointmentShown(t.appointment))
				.map((t) => t.appointment)
				.filter((t) => moment.utc(t.start_date_utc).tz(getPracticeTimezoneNameForItem(t)).format('YYYY-MM-DD') === selectedDate);

			// The server takes one clinician's list at one practice - it refuses anyone else's appointments
			// - so with several clinicians (or every practice) on screen each gets a file of their own.
			const lists = [];
			appointments.forEach((t) => {
				const practiceId = $scope.currentPractice.id === -1 ? t.practice_id : $scope.currentPractice.id;
				let list = lists.find((l) => String(l.clinicianId) === String(t.clinician_id) && l.practiceId === practiceId);
				if (!list) {
					list = { clinicianId: t.clinician_id, practiceId: practiceId, items: [] };
					lists.push(list);
				}
				list.items.push({ patient_id: t.patient_id, appointment_id: t.patient_appointment_id });
			});

			if (lists.length === 0) {
				$scope.$applyAsync(() => {
					$scope.calendarNotice = "There are no appointments on that day to download.";
				});
				return;
			}

			lists.forEach((list) => {
				const data = { clinician_id: Number(list.clinicianId), appointment_list_items: list.items };
				const label = lists.length > 1 ? ($scope.clinicianNameFor(list.clinicianId) || "clinician " + list.clinicianId) : null;
				const request = format === "csv"
					? $scope.API.downloadAppointmentListCsv(data, list.practiceId)
					: $scope.API.downloadAppointmentList(data, list.practiceId);
				request.then(
					function (resp) {
						if (format === "csv") {
							downloadFile(resp.data, getFileName("csv", label), "text/csv;charset=utf-8");
						} else {
							downloadFile(resp.data, getFileName("pdf", label), "application/pdf");
						}
					},
					function () {
						$scope.calendarNotice = `The appointment list could not be downloaded${label ? " for " + label : ""}. Please try again.`;
					}
				);
			});
		}

		// True when reminders are off for the appointment's type. Read from the settings at the appointment's
		// own practice: each practice has its own types and its own settings, so the signed-in practice's
		// list has no entry for another practice's type and read as "off" for every one of them.
		$scope.getAppointmentType = function () {
			const settingOptions = reminderSettingsByPractice[appointmentPracticeId()];
			if (settingOptions) {
				const target = settingOptions.find((t) => t.appointment_category_id === $scope.appointment.category_id);
				if (target && (target.email_reminders_enabled || target.sms_reminders_enabled)) {
					return false;
				} else {
					return true;
				}
			}
			return false;
		};

		// Mirrors the server side cooldown, which rejects a manual reminder sent within
		// 10 minutes of the appointment's previous_manual_reminder_time_UTC.
		const MANUAL_REMINDER_COOLDOWN_MS = 1000 * 60 * 10;
		let manualReminderCooldownTimer = null;

		function manualReminderCooldownRemainingMs() {
			const previousReminderUTC = $scope.appointment && $scope.appointment.previous_manual_reminder_time_UTC;

			if (!previousReminderUTC) {
				return 0;
			}

			return Math.max(0, MANUAL_REMINDER_COOLDOWN_MS - (new Date() - moment.utc(previousReminderUTC).toDate()));
		}

		// Wake up once, at the moment the cooldown expires, rather than polling on an
		// interval. The $timeout runs a digest, which re-evaluates ng-disabled and
		// re-enables the button on its own - one digest instead of one per tick.
		function scheduleManualReminderCooldownExpiry() {
			$timeout.cancel(manualReminderCooldownTimer);
			manualReminderCooldownTimer = null;

			const remaining = manualReminderCooldownRemainingMs();
			if (remaining > 0) {
				manualReminderCooldownTimer = $timeout(angular.noop, remaining + 250);
			}
		}

		$scope.isManualReminderDisabled = function () {
			return manualReminderCooldownRemainingMs() > 0;
		};

		$scope.$on("$destroy", function () {
			$timeout.cancel(manualReminderCooldownTimer);
		});

		function appointmentPracticeId() {
			return ($scope.appointment && $scope.appointment.practice_id) || Session.practice.id;
		}

		// Whether the appointment's practice pays for reminders - not the signed-in practice's.
		$scope.isManualReminderShow = function () {
			const practice = (Session.practiceOptions || []).find((p) => String(p.id) === String(appointmentPracticeId()));
			return !!($scope.appointment.patient_appointment_id && Session.hasAppointmentReminders(practice));
		};

		// The signed-in user's reminder settings, by practice id. Fetched for each practice an appointment is
		// opened at, and again on every open so a change made in the settings screen is picked up.
		const reminderSettingsByPractice = {};
		function fetchSetting(practiceId) {
			$scope.API.getAppointmentReminderSetting($scope.Session.user.id, practiceId)
				.then(
					function (response) {
						reminderSettingsByPractice[practiceId] = (response.data && response.data.category_reminder_settings) || [];
					},
					function (error) {
						console.error(error && error.status);
					}
				);
		}

		$scope.availableEvents = [];
		$scope.blockEvents = [];

		const WEEKDAY = ["SUNDAY","MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

		/* =================================================================== */
		/* Leave and sessions, day by day
		/* Worked out from the availability rows as the API sends them, so every view - FullCalendar's
		/* grid, its all-day row and headers, the agenda, the team columns and the booking check - draws
		/* the same thing. Dates are read in local time, as the availability editor writes them.
		/* =================================================================== */

		function minutesOfDay(hhmmss) {
			const parts = (hhmmss || "0:0").split(":").map(Number);
			return parts[0] * 60 + (parts[1] || 0);
		}

		function isWholeDayRow(t) {
			const start = t.start_time_local || "";
			const end = t.end_time_local || "";
			return start.startsWith("00:00") && (end.startsWith("24:00") || end.startsWith("00:00"));
		}

		/** Whether an availability row has an occurrence on the given local date (YYYY-MM-DD). */
		function availabilityOccursOn(t, dateStr) {
			const startStr = t.start_date_utc || t.date_occurrence_utc;
			if (!startStr) {
				return false;
			}
			const day = moment(dateStr, "YYYY-MM-DD");
			const first = moment.utc(startStr).local().startOf("day");
			if (day.isBefore(first, "day")) {
				return false;
			}

			const weeks = parseInt(t.week_number_recurrence || 0, 10);
			if (t.recurrence_type !== "NUMBERED_WEEK" || !(weeks > 0)) {
				// A one-off for part of a day is on its start day only. Its end_date_utc is no guide: one
				// edited or dragged in the availability editor is saved ending 24 hours after it starts,
				// which reaches into the next day - read as a last day, that drew it on two. The editor
				// itself only ever draws these on their start day.
				if (!isWholeDayRow(t)) {
					return day.isSame(first, "day");
				}
				// Whole days: from the start to the day before an end at midnight. Older date-range rows
				// keep their end in exception_dates[0] - for these it is not an exception at all.
				const endStr = t.end_date_utc || (t.exception_dates && t.exception_dates[0] && t.exception_dates[0].exception_date_utc);
				const lastDay = endStr ? moment.utc(endStr).local().subtract(1, "minute") : first;
				return !day.isAfter(lastDay, "day");
			}

			// Repeating: on its weekday, every so many weeks from its first, until its end, less exceptions.
			if (t.day_recurrence ? t.day_recurrence !== WEEKDAY[day.day()] : day.day() !== first.day()) {
				return false;
			}
			if (Math.floor(day.diff(first, "days") / 7) % weeks !== 0) {
				return false;
			}
			if (t.end_date_utc && moment.utc(t.end_date_utc).local().isBefore(day, "day")) {
				return false;
			}
			return !(t.exception_dates || []).some((ex) => moment(ex.exception_date_utc).local().isSame(day, "day"));
		}

		// availabilityOn's answers, by rows list and then by date. Every appointment on a day asks about that day
		// (leaveClash, several times a redraw), and each answer reads every row through moment. A new list of
		// rows - each availability fetch makes one - starts afresh. Nothing changes what is handed out.
		const availabilityByRows = new WeakMap();

		/** The day's leave (`away`) and sessions, each as minutes of the day. */
		function availabilityOn(rows, dateStr) {
			if (!rows) {
				return readAvailabilityOn(rows, dateStr);
			}
			let byDate = availabilityByRows.get(rows);
			if (!byDate) {
				byDate = {};
				availabilityByRows.set(rows, byDate);
			}
			return byDate[dateStr] || (byDate[dateStr] = readAvailabilityOn(rows, dateStr));
		}

		function readAvailabilityOn(rows, dateStr) {
			const result = { away: [], sessions: [] };
			(rows || []).forEach((t) => {
				if (!availabilityOccursOn(t, dateStr)) {
					return;
				}
				const whole = isWholeDayRow(t);
				const block = {
					id: t.availability_id,
					name: t.custom_availability_name,
					allDay: whole,
					startMin: whole ? 0 : minutesOfDay(t.start_time_local),
					endMin: whole ? 24 * 60 : (minutesOfDay(t.end_time_local) || 24 * 60),
					weeks: t.recurrence_type === "NUMBERED_WEEK" ? parseInt(t.week_number_recurrence || 0, 10) : 0,
				};
				(t.availability_type === "UNAVAILABLE" ? result.away : result.sessions).push(block);
			});
			result.away.sort((a, b) => a.startMin - b.startMin);
			result.sessions.sort((a, b) => a.startMin - b.startMin);
			return result;
		}

		function clockLabel(minutes) {
			return moment().startOf("day").add(minutes, "minutes").locale("en").format("h:mm a");
		}

		// "On leave · Conference" for whole days; "Unavailable 1:00 pm – 5:00 pm · Admin" for part of one.
		function awayLabel(block) {
			const reason = block.name && block.name !== "Leave" ? ` · ${block.name}` : "";
			return block.allDay ? `On leave${reason}` : `Unavailable ${clockLabel(block.startMin)} – ${clockLabel(block.endMin)}${reason}`;
		}

		// "1–3 pm", "9:30 am–12 pm" - short enough for a column header.
		function compactRange(startMin, endMin) {
			const fmt = (minutes) => moment().startOf("day").add(minutes, "minutes").locale("en").format("h:mm a").replace(":00", "");
			const start = fmt(startMin);
			const end = fmt(endMin);
			return start.slice(-2) === end.slice(-2) ? `${start.slice(0, -3)}–${end}` : `${start}–${end}`;
		}

		// "On leave" for a whole day, otherwise the hours they are off: "1–3 pm", "1–3 pm +1" for more than
		// one stretch. "Away" on its own read as gone for the day.
		function awayRangeLabel(away) {
			if (away.some((b) => b.allDay)) {
				return "On leave";
			}
			const first = compactRange(away[0].startMin, away[0].endMin);
			return away.length === 1 ? first : `${first} +${away.length - 1}`;
		}

		// "On leave", or "Unavailable 1–3 pm" - for headers, which have the room to say what the hours are.
		function awayShortLabel(away) {
			const range = awayRangeLabel(away);
			return away.some((b) => b.allDay) ? range : `Unavailable ${range}`;
		}

		// "Consult · 8–12 pm" on the session itself.
		function sessionLabel(block) {
			return block.allDay ? `${block.name} · all day` : `${block.name} · ${compactRange(block.startMin, block.endMin)}`;
		}

		// "Consult: available 8:00 am – 12:00 pm, every week" on hover.
		function sessionTooltip(block) {
			const when = block.allDay ? "all day" : `${clockLabel(block.startMin)} – ${clockLabel(block.endMin)}`;
			const repeat = block.weeks === 1 ? ", every week" : (block.weeks > 1 ? `, every ${block.weeks} weeks` : ", this day only");
			return `${block.name}: available ${when}${repeat}`;
		}

		function sessionColour(block) {
			return queryEventColor(block.name) || UNCOLOURED_EVENT;
		}

		function tint(hex, alpha) {
			const match = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
			return match
				? `rgba(${parseInt(match[1], 16)}, ${parseInt(match[2], 16)}, ${parseInt(match[3], 16)}, ${alpha})`
				: `rgba(91, 107, 140, ${alpha})`;
		}

		// Availability rows for the practice being viewed. The one clinician the calendar is on comes from
		// fetchCalendarAvailability; the team view needs everyone's. The availability endpoint answers with
		// every clinician's rows at the practice whichever user it is asked about, so the team view asks once
		// per practice and splits them here - asking once per clinician fetched the same rows N times over.
		$scope.availabilityRows = [];
		const practiceAvailability = {};
		const practiceAvailabilityInFlight = {};
		// A practice's rows split by clinician, for each rows list fetched.
		const rowsByClinician = new WeakMap();

		function availabilityRowsFor(clinicianId) {
			if (String(clinicianId) === String($scope.currentSurgeon) && $scope.availabilityRowsLoaded) {
				return $scope.availabilityRows;
			}
			const rows = practiceAvailability[$scope.currentPractice.id];
			if (!rows) {
				return null;
			}
			// The same list each time for the same rows, so availabilityOn's answers for it are kept too.
			let byClinician = rowsByClinician.get(rows);
			if (!byClinician) {
				byClinician = {};
				rowsByClinician.set(rows, byClinician);
			}
			const key = String(clinicianId);
			return byClinician[key] || (byClinician[key] = rows.filter((t) => String(t.user_id) === key));
		}

		function ensureTeamAvailability() {
			const practiceId = $scope.currentPractice.id;
			if (!$scope.calendarAvailabilityEnabled || $scope.view.mode !== "team"
				|| practiceId === null || practiceId === undefined || practiceId === -1) {
				return;
			}
			if (practiceAvailability[practiceId] || practiceAvailabilityInFlight[practiceId]) {
				return;
			}
			practiceAvailabilityInFlight[practiceId] = true;
			$scope.API.getPracticeAvailability(practiceId, Session.userId)
				.then(function (resp) {
					practiceAvailability[practiceId] = resp.data || [];
					summariseAppointments($scope.allAppointments || []);
					buildTeamModel();
				}, angular.noop)
				.then(function () {
					delete practiceAvailabilityInFlight[practiceId];
				});
		}

		/**
		 * Leave and sessions as FullCalendar events, for the one clinician being viewed:
		 * - striped background blocks over the hours away, and tinted ones under sessions;
		 * - an "On leave" bar in the all-day row (and on the month and agenda) for whole days away;
		 * - an agenda row for part-day absences, which the agenda cannot show as a background.
		 */
		// Where in a session its name can go without an appointment drawn over it: the start of its first
		// free stretch of at least LABEL_MIN_GAP minutes, in minutes from the session's start - or null
		// when it is booked solid, and the tint, its edge and the day header have to say what it is.
		const LABEL_MIN_GAP = 15;
		function freeLabelOffset(block, busy) {
			let cursor = block.startMin;
			const overlapping = busy
				.filter((b) => b.endMin > block.startMin && b.startMin < block.endMin)
				.sort((a, b) => a.startMin - b.startMin);
			for (let i = 0; i < overlapping.length; i++) {
				if (overlapping[i].startMin - cursor >= LABEL_MIN_GAP) {
					return cursor - block.startMin;
				}
				cursor = Math.max(cursor, overlapping[i].endMin);
			}
			return block.endMin - cursor >= LABEL_MIN_GAP ? cursor - block.startMin : null;
		}

		// The clinician's appointments by day, as minutes - what a session's label has to keep clear of.
		function busyByDay(appointmentEvents) {
			const byDay = {};
			(appointmentEvents || []).forEach((t) => {
				if (!t.appointment || String(t.appointment.clinician_id) !== String($scope.currentSurgeon)) {
					return;
				}
				const date = String(t.start).slice(0, 10);
				const start = moment(t.start);
				const end = moment(t.end);
				(byDay[date] = byDay[date] || []).push({
					startMin: start.hours() * 60 + start.minutes(),
					endMin: end.isSame(start, "day") ? end.hours() * 60 + end.minutes() : 24 * 60,
				});
			});
			return byDay;
		}

		function buildAvailabilityEvents(appointmentEvents) {
			if ($scope.currentSurgeon === "all" || $scope.currentPractice.id === -1 || !$scope.renderedRange
				|| !$scope.availabilityRowsLoaded) {
				return [];
			}
			const events = [];
			const busy = busyByDay(appointmentEvents);
			const lastDay = moment($scope.renderedRange.end, "YYYY-MM-DD");
			for (let day = moment($scope.renderedRange.start, "YYYY-MM-DD"); day.isBefore(lastDay); day.add(1, "day")) {
				const date = day.format("YYYY-MM-DD");
				const next = day.clone().add(1, "day").format("YYYY-MM-DD");
				const at = (minutes) => minutes >= 24 * 60 ? `${next}T00:00:00` : `${date}T${clockOf(minutes)}`;
				const { away, sessions } = availabilityOn($scope.availabilityRows, date);

				sessions.forEach((block) => {
					const labelOffset = freeLabelOffset(block, busy[date] || []);
					events.push({
						title: sessionLabel(block),
						labelOffsetPct: labelOffset === null ? null : (labelOffset / (block.endMin - block.startMin)) * 100,
						tooltip: sessionTooltip(block),
						sessionColour: sessionColour(block),
						start: at(block.startMin),
						end: at(block.endMin),
						rendering: "background",
						className: ["avail-band"],
						availabilityBlock: "session",
						editable: false,
					});
				});
				away.forEach((block) => {
					events.push({
						title: awayLabel(block),
						start: at(block.startMin),
						end: at(block.endMin),
						rendering: "background",
						className: ["unavail-block"],
						availabilityBlock: "away",
						editable: false,
					});
					events.push(block.allDay
						? { title: awayLabel(block), start: date, allDay: true, className: ["leave-banner"], leaveBanner: true, editable: false }
						: { title: awayLabel(block), start: at(block.startMin), end: at(block.endMin), className: ["leave-banner", "leave-list-row"], listOnly: true, editable: false });
				});
			}
			return events;
		}

		/* =================================================================== */
		/* Public holidays
		/* The practice's public holidays - national, and in Australia its state's - fetched a year at a
		/* time and kept for as long as the calendar is open.
		/* =================================================================== */

		// "practiceId|year" -> that year's holidays, or the request while it is in flight.
		const holidayYears = {};

		function holidayPracticeIds() {
			if ($scope.currentPractice.id === -1) {
				return $scope.practiceSummaryList.filter((t) => t.id !== -1).map((t) => t.id);
			}
			return $scope.currentPractice.id === null || $scope.currentPractice.id === undefined ? [] : [$scope.currentPractice.id];
		}

		function loadHolidays() {
			if (!$scope.renderedRange) {
				return;
			}
			const firstYear = Number($scope.renderedRange.start.slice(0, 4));
			const lastYear = moment($scope.renderedRange.end, "YYYY-MM-DD").subtract(1, "day").year();
			const requests = [];
			holidayPracticeIds().forEach((practiceId) => {
				for (let year = firstYear; year <= lastYear; year++) {
					const key = `${practiceId}|${year}`;
					if (holidayYears[key]) {
						continue;
					}
					// Fetched when the calendar was open before.
					const kept = ShareData.getCalendarHolidays(key);
					if (kept) {
						holidayYears[key] = kept;
						continue;
					}
					// A failed year is forgotten, so the next fetch asks again; the calendar works without it.
					holidayYears[key] = $scope.PracticeAPI.queryPublicHolidays(practiceId, `${year}-01-01`, `${year}-12-31`).then(
						(resp) => {
							holidayYears[key] = resp.data || [];
							ShareData.setCalendarHolidays(key, holidayYears[key]);
						},
						() => { delete holidayYears[key]; }
					);
					requests.push(holidayYears[key]);
				}
			});
			if (requests.length === 0) {
				// Already loaded - but the practice may have changed, so the mini month's markers may not match.
				if ($scope.miniMonth.anchor) {
					buildMiniMonth($scope.miniMonth.anchor);
				}
				return;
			}
			$q.all(requests).then(function () {
				if ($scope.miniMonth.anchor) {
					buildMiniMonth($scope.miniMonth.anchor);
				}
				renderAppointmentEvents($scope.allAppointments || []);
			});
		}

		/**
		 * The holidays on a day (yyyy-MM-dd) at the practice on screen. With every practice on screen, one
		 * that only some of them observe - another state's - names those practices.
		 */
		function holidaysOn(date) {
			const practiceIds = holidayPracticeIds();
			const found = [];
			practiceIds.forEach((practiceId) => {
				const list = holidayYears[`${practiceId}|${String(date).slice(0, 4)}`];
				if (!Array.isArray(list)) {
					return;
				}
				list.filter((t) => t.date === date).forEach((holiday) => {
					let entry = found.find((t) => t.name === holiday.name);
					if (!entry) {
						entry = { name: holiday.name, practiceIds: [] };
						found.push(entry);
					}
					entry.practiceIds.push(practiceId);
				});
			});
			return found.map((t) => ({
				name: t.name,
				label: t.practiceIds.length < practiceIds.length
					? `${t.name} (${t.practiceIds.map((id) => (($scope.practiceSummaryList.find((p) => p.id === id) || {}).name)).filter(Boolean).join(", ")})`
					: t.name,
			}));
		}
		$scope.holidaysOn = holidaysOn;

		// A banner across each holiday - the all-day row in Day and Week, the day in Month, a row in Agenda.
		function buildHolidayEvents() {
			if (!$scope.renderedRange) {
				return [];
			}
			const events = [];
			const lastDay = moment($scope.renderedRange.end, "YYYY-MM-DD");
			for (let day = moment($scope.renderedRange.start, "YYYY-MM-DD"); day.isBefore(lastDay); day.add(1, "day")) {
				const date = day.format("YYYY-MM-DD");
				holidaysOn(date).forEach((holiday, index) => {
					events.push({
						// An id of its own, so a click finds this all-day event (and ignores it), not some other.
						id: `holiday-${date}-${index}`,
						title: holiday.label,
						start: date,
						allDay: true,
						className: ["holiday-banner"],
						holidayBanner: true,
						editable: false,
					});
				});
			}
			return events;
		}

		/* =================================================================== */
		/* Practice leave
		/* Times the whole practice takes no bookings (Settings > Practice leave), fetched for the range on
		/* screen. Drawn whoever is selected, and checked before a booking is saved - the server refuses a
		/* booking inside it unless "Book anyway" is chosen.
		/* =================================================================== */

		// practiceId -> the leave blocks in the range on screen.
		let practiceLeaveBlocks = {};
		let practiceLeaveSequence = 0;

		// Anyone who can book may book over practice leave, by ticking "Book anyway"; the server audits it.
		// TODO(#1451): once the permissions rework (refactor/user_permissions) lands, offer it only to users with the
		// practice leave override permission (e.g. SCHEDULE_PRACTICE_LEAVE_OVERRIDE).

		function loadPracticeLeave() {
			if (!$scope.calendar_range_start || !$scope.calendar_range_end) {
				return;
			}
			// A day either side: in the "all practices" view the range is worked out in one practice's zone.
			const start = moment.utc($scope.calendar_range_start).subtract(1, "day").toISOString();
			const end = moment.utc($scope.calendar_range_end).add(1, "day").toISOString();
			const requestId = ++practiceLeaveSequence;
			// A practice whose leave cannot be read just shows none; the server still refuses bookings in it.
			$q.all(holidayPracticeIds().map((practiceId) =>
				$scope.PracticeAPI.queryPracticeLeaveOccurrences(practiceId, start, end)
					.then((resp) => ({ practiceId: practiceId, blocks: resp.data || [] }), () => ({ practiceId: practiceId, blocks: [] }))
			)).then(function (results) {
				if (requestId !== practiceLeaveSequence) {
					return;
				}
				practiceLeaveBlocks = {};
				results.forEach((result) => {
					practiceLeaveBlocks[result.practiceId] = result.blocks;
				});
				renderAppointmentEvents($scope.allAppointments || []);
			});
		}

		/** The practice leave, if any, that a booking at a practice from start (a moment) for duration overlaps. */
		function practiceLeaveAt(practiceId, start, durationMinutes) {
			// An appointment with no length still occupies the minute it starts in.
			const end = start.clone().add(Math.max(durationMinutes || 0, 1), "minutes");
			return (practiceLeaveBlocks[practiceId] || []).find((block) =>
				moment.utc(block.start_date_utc).isBefore(end) && moment.utc(block.end_date_utc).isAfter(start)) || null;
		}

		/** "Lunch (12:30–13:30)" or "Labour Day (all day)", in the practice's own time. */
		function practiceLeaveLabel(block, practiceId) {
			if (block.public_holiday) {
				return `${block.name} (public holiday)`;
			}
			if (block.all_day) {
				return `${block.name} (all day)`;
			}
			const timezone = getPracticeTimezoneNameById(practiceId);
			const from = moment.utc(block.start_date_utc).tz(timezone).format("HH:mm");
			const to = moment.utc(block.end_date_utc).tz(timezone).format("HH:mm");
			return `${block.name} (${from}\u2013${to})`;
		}

		$scope.practiceLeaveLabel = function (block) {
			return block ? practiceLeaveLabel(block, $scope.appointment && $scope.appointment.practice_id) : "";
		};

		/**
		 * The practice leave the booking in the dialog falls in. An existing appointment that has not been moved
		 * is left alone, as the server leaves it: it was booked before the leave was added.
		 */
		$scope.practiceLeaveClash = function () {
			const appointment = $scope.appointment;
			if (!appointment || !appointment.practice_id || !appointment._startDateStr || !appointment.selectedTimeSlot) {
				return null;
			}
			const start = moment.tz(`${convertDateFormat(appointment._startDateStr)}T${appointment.selectedTimeSlot}`,
				getPracticeTimezoneNameById(appointment.practice_id));
			const original = appointment.patient_appointment_id ? $scope.appointment_clone : null;
			if (original
				&& moment.utc(original.start_date_utc).isSame(start)
				&& original.duration_minutes === appointment.duration_minutes
				&& original.practice_id === appointment.practice_id) {
				return null;
			}
			return practiceLeaveAt(appointment.practice_id, start, appointment.duration_minutes);
		};

		$scope.isBlockedByPracticeLeave = function () {
			return !!$scope.practiceLeaveClash() && !$scope.$ctrl.overridePracticeLeave;
		};

		function resetPracticeLeaveState() {
			$scope.$ctrl.overridePracticeLeave = false;
			$scope.$ctrl.saveError = null;
		}

		// A hatched grey band over the hours, so it reads differently from a clinician's red leave, and a bar in
		// the all-day row for a whole day.
		function buildPracticeLeaveEvents() {
			const events = [];
			const everyPractice = $scope.currentPractice.id === -1;
			holidayPracticeIds().forEach((practiceId) => {
				const timezone = getPracticeTimezoneNameById(practiceId);
				const practice = ($scope.practiceSummaryList || []).find((p) => p.id === practiceId);
				(practiceLeaveBlocks[practiceId] || []).forEach((block, index) => {
					const start = moment.utc(block.start_date_utc).tz(timezone);
					const end = moment.utc(block.end_date_utc).tz(timezone);
					const title = everyPractice && practice ? `${block.name} (${practice.name})` : block.name;
					events.push({
						id: `practice-leave-${practiceId}-${index}`,
						title: title,
						tooltip: practiceLeaveLabel(block, practiceId),
						start: start.format("YYYY-MM-DDTHH:mm:ss"),
						end: end.format("YYYY-MM-DDTHH:mm:ss"),
						rendering: "background",
						className: ["practice-leave-bg"],
						practiceLeave: block,
						editable: false,
					});
					// A public holiday already has its own banner across the day.
					if (block.all_day && !block.public_holiday) {
						events.push({
							id: `practice-leave-banner-${practiceId}-${index}`,
							title: title,
							start: start.format("YYYY-MM-DD"),
							allDay: true,
							className: ["practice-leave-banner"],
							practiceLeaveBanner: true,
							editable: false,
						});
					}
				});
			});
			return events;
		}

		function clockOf(minutes) {
			const h = Math.floor(minutes / 60);
			const m = minutes % 60;
			return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}:00`;
		}

		/** The leave, if any, a clinician has across part of the given span (moments in wall time). */
		function awayDuring(clinicianId, start, end) {
			const rows = availabilityRowsFor(clinicianId);
			if (!rows) {
				return undefined;
			}
			const startMin = start.hours() * 60 + start.minutes();
			const endMin = end.isSame(start, "day") ? end.hours() * 60 + end.minutes() : 24 * 60;
			return availabilityOn(rows, start.format("YYYY-MM-DD")).away
				.find((block) => block.startMin < endMin && block.endMin > startMin) || null;
		}

		const _transformUnavailableEvent = (event) => {
			if(!event.week_number_recurrence && event.recurrence_type === 'ONE_OFF') {
				//For v2 of personal calendar, we should use 'ONE_OFF' to replace wrong recurrence_type
				return {
					start: event.start_date_utc ?? event.date_occurrence_utc,
					end: event.end_date_utc,
					custom_availability_name: event.custom_availability_name,
					unavailable: 'true',
					day_recurrence: null,
					recurrence_type: event.recurrence_type,
					availability_id: event.availability_id,
					end_date_utc: event.end_date_utc,
					exception_dates: [],
					start: event.start_time_local,
					end: event.end_time_local,
					ranges: [
						{
							start: moment.utc(event.start_date_utc ?? event.date_occurrence_utc),
							end: moment.utc(event.end_date_utc),
						},
					],
				}
			}else if(event.week_number_recurrence === 0 && event.exception_dates?.length == 0){
				//New API format: NOT recurrence
				return {
					// Pass the UTC ISO string directly to FullCalendar
					start: event.start_date_utc,
					end: event.end_date_utc,
					custom_availability_name: event.custom_availability_name,
					unavailable: 'true',
					availability_id: event.availability_id,
					availability_group_id: event.availability_group_id,
					recurrence_type: 'ONE_OFF',
					end_date_utc: event.end_date_utc,
					exception_dates: [],
					start: event.start_time_local,
					end: event.end_time_local,
					ranges: [
						{
							start: moment.utc(event.start_date_utc),
							end: moment.utc(event.end_date_utc),
						},
					],
				};

			}else if (event.week_number_recurrence === 0 && event.exception_dates && event.exception_dates.length > 0) {
				// NOT recurrence
				return {
					// Pass the UTC ISO string directly to FullCalendar
					start: event.start_date_utc,
					end: event.exception_dates[0].exception_date_utc,
					custom_availability_name: event.custom_availability_name,
					unavailable: 'true',
					recurrence_type: 'ONE_OFF',
					availability_id: event.availability_id,
					availability_group_id: event.availability_group_id,
					exception_dates: event.exception_dates, // should transform exception_dates with latest change
					// Older date-range rows carry their end in exception_dates[0] rather than end_date_utc.
					end_date_utc: event.end_date_utc ?? event.exception_dates[0].exception_date_utc,
					start: event.start_time_local,
					end: event.end_time_local,
					ranges: [
						{
							start: moment.utc(event.start_date_utc),
							end: moment.utc(event.end_date_utc ?? event.exception_dates[0].exception_date_utc),
						},
					],
				};
			} else {
				return {
					availability_id: event.availability_id,
					availability_group_id: event.availability_group_id,
					exception_dates: event.exception_dates,
					end_date_utc: event.end_date_utc,
					dow: [WEEKDAY.indexOf(event.day_recurrence)],
					start: event.start_time_local,
					end: event.end_time_local,
					unavailable: "true",
					custom_availability_name: event.custom_availability_name,
					// rendering: "background",
					recurrence_type: "NUMBERED_WEEK",
					// backgroundColor: queryEventColor(t.custom_availability_name),
					week_number_recurrence: event.week_number_recurrence,
					ranges: [
						{
							start: moment.utc(event.start_date_utc),
							end: event.end_date_utc
								? moment.utc(event.end_date_utc)
								: moment.utc(event.start_date_utc).add(1, "y").endOf("month"),
						},
					],
				};
			}
		};

		function transformBlockEvents(data, surgeon) {
			const events = data.filter((t) => t.user_id === surgeon && t.availability_type === "UNAVAILABLE");

			const result = events
				.filter((m) => m.start_date_utc || m.date_occurrence_utc)
				.map((t) => [
					_transformUnavailableEvent(t),
					// we don't want duplicated unavailable events in personal calendar
					// {
					// 	// This section for all-day events also uses the raw date string
					// 	start: t.start_date_utc.split("T")[0],
					// 	end: t.exception_dates[0].exception_date_utc.split("T")[0],
					// 	custom_availability_name: t.custom_availability_name,
					// 	unavailable: 'true',
					// },
				]);

			return result
				.flat()
				.map((t) => ({
					...t,
					rendering: "background",
					editable: false,
					startEditable: false,
					durationEditable: false,
					resourceEditable: false,
					color: "red",
				}));
		}

		const queryEventColor = (title) => {
			const target = $scope.appointment_categories.find(t=>t.name === title);
			if(!target){
				return '';
			}
			
			return '#'+target.colour
		}

		function transformAvailableEvents(data,surgeon) {
			const events = data.filter(
				(t) => t.user_id === surgeon && t.recurrence_type === "NUMBERED_WEEK" && t.availability_type === "CUSTOM"
			);

			// const join = (date,time) => {
			// 	let _time = time;
			// 	if(time.split(':')[0].length < 2){
			// 		_time = '0'+_time;
			// 	}
			// 	return date.split('T')[0] + 'T' + _time;
			// }

			const numberedWeekEvents = events
				.filter((m) => m.start_date_utc || m.date_occurrence_utc)
				.map((t) => ({
					availability_id: t.availability_id,
					availability_group_id: t.availability_group_id,
					dow: [WEEKDAY.indexOf(t.day_recurrence)],
					start: t.start_time_local,
					end: t.end_time_local,
					unavailable: "false",
					custom_availability_name: t.custom_availability_name,
					rendering: "background",
					recurrence_type: "NUMBERED_WEEK",
					backgroundColor: queryEventColor(t.custom_availability_name),
					week_number_recurrence: t.week_number_recurrence,
					exception_dates: t.exception_dates,
					end_date_utc: t.end_date_utc,
					ranges: [
						{
							start: moment(t.start_date_utc ?? t.date_occurrence_utc),
							end: moment(t.start_date_utc ?? t.date_occurrence_utc)
								.add(1, "y")
								.endOf("month"),
						},
					],
				}));

			const events_one_off = data.filter(
				(t) => t.user_id === surgeon && t.recurrence_type === "ONE_OFF" && !t.week_number_recurrence && t.availability_type === "CUSTOM"
			); 

			const oneOffEvents = events_one_off.map((t) => ({
				availability_id: t.availability_id,
				start: t.start_time_local,
				end: t.end_time_local,
				unavailable: "false",
				day_recurrence: null,
				custom_availability_name: t.custom_availability_name,
				rendering: "background",
				recurrence_type: t.recurrence_type,
				backgroundColor: queryEventColor(t.custom_availability_name),
				end_date_utc: t.end_date_utc,
				exception_dates: [],
				ranges: [
					{
						start: moment(t.start_date_utc ?? t.date_occurrence_utc),
						end: moment(t.end_date_utc ?? t.date_occurrence_utc),
					},
				],
			}));

			return [...numberedWeekEvents,...oneOffEvents]
		}

		// `options.background` runs the fetch without touching AppointmentAPI.isProcessing. That flag is
		// shared: it shows a spinner in the appointment and availability detail modals and disables the
		// Save button on the appointment settings screen. A live update is not something the user asked
		// for, so it must not flash a spinner at them or take their Save button away mid-click.
		let availabilitySequence = 0;
		$scope.fetchCalendarAvailability = (practiceId, options) => {
			const background = !!(options && options.background);
			if (!$scope.calendarAvailabilityEnabled) {
				return;
			}
			// Bumped before any early return too, so a fetch still in flight for the previous
			// selection can't redraw its shading over a view that shows none ("All").
			availabilitySequence++;
			$scope.availableEvents = [];
			$scope.blockEvents = [];
			$scope.availabilityRows = [];
			$scope.availabilityRowsLoaded = false;
			if ($scope.currentSurgeon === 'all') {
				return;
			}

			// Availability belongs to one practice, so there is nothing to ask for when none is selected or
			// when every practice is being shown at once.
			if (practiceId === null || practiceId === undefined || practiceId === -1) {
				return;
			}

			if (!background) {
				$scope.API.isProcessing = true;
			}

			const surgeon = $scope.currentSurgeon ? $scope.currentSurgeon : Session.userId;
			const requestId = ++availabilitySequence;

			$scope.API.getPracticeAvailability(practiceId, surgeon)
				.then(
					function (resp) {
						// A newer fetch (another practice or clinician picked meanwhile) owns the shading now.
						if (requestId !== availabilitySequence) {
							return;
						}
						$scope.availableEvents = transformAvailableEvents(resp.data, surgeon);
						$scope.blockEvents = transformBlockEvents(resp.data, surgeon);
						$scope.availabilityRows = resp.data.filter((t) => String(t.user_id) === String(surgeon));
						$scope.availabilityRowsLoaded = true;
						// The same rows the team view splits up - and newer than its copy.
						practiceAvailability[practiceId] = resp.data || [];
						
						//re-draw calendar for availability
						renderAppointmentEvents($scope.allAppointments);
					},
					function (error) {
						console.error(error && error.status);
					}
				)
				.then(() => {
					if (!background) {
						$scope.API.isProcessing = false;
					}
				});
		}

		$scope.changeDateRange = (start) => {
			// start format example: '2018-05-10'
			withCalendarInDigest((calendar) => calendar.fullCalendar('gotoDate', start));
		}

		/* =================================================================== */
		/* Toolbar
		/* =================================================================== */

		// This dialog's FullCalendar, taken from its first viewRender. Not uiCalendarConfig.calendars.myCalendar:
		// every calendar dialog registers under that one name, and a closing dialog's teardown can land after the
		// next one has opened, leaving the name on the closed dialog's emptied element.
		let ownCalendar = null;

		function withCalendar(fn) {
			// Not once the dialog has closed and ui-calendar has destroyed it.
			if (ownCalendar && ownCalendar.data("fullCalendar")) {
				fn(ownCalendar);
			}
		}

		// For anything that draws FullCalendar's events from outside a digest - a $timeout's function runs
		// before its digest does. ui-calendar runs each FullCalendar callback (eventRender, eventDestroy...)
		// called outside a digest in one of its own, a digest of the whole app per event drawn. Inside one,
		// the whole redraw costs a single digest. Give such a $timeout invokeApply false, as this digests.
		function withCalendarInDigest(fn) {
			withCalendar((calendar) => {
				if ($scope.$root.$$phase) {
					fn(calendar);
				} else {
					$scope.$apply(() => fn(calendar));
				}
			});
		}

		// 'prev', 'next' or 'today'
		$scope.navigate = function (action) {
			withCalendar((calendar) => calendar.fullCalendar(action));
		};

		$scope.goToDate = function (date) {
			withCalendar((calendar) => calendar.fullCalendar("gotoDate", date));
		};

		$scope.setViewMode = function (mode, options) {
			const remember = !options || options.remember !== false;
			const previous = $scope.view.mode;
			$scope.view.mode = mode;
			if (remember) {
				ShareData.setCalendarViewPrefs({ mode: mode });
			}
			// FullCalendar not created yet: have it start in this view. Only then - ui-calendar watches
			// its options and rebuilds the calendar (back on today) whenever they change.
			if (!ownCalendar) {
				$scope.uiConfig.calendar.defaultView = toFullCalendarView(mode);
			}
			withCalendar((calendar) => {
				calendar.fullCalendar("changeView", toFullCalendarView(mode));
				// Day <-> team share agendaDay, so changeView did nothing and viewRender will not run.
				buildTeamModel();
				if (previous === "team" && mode !== "team") {
					// FullCalendar was laid out while hidden behind the team view - measure it again.
					$timeout(() => withCalendarInDigest((shown) => shown.fullCalendar("render")), 0, false);
				}
			});
			// The redraws skipped while the team view covered it.
			if (mode !== "team" && calendarStaleBehindTeam) {
				$scope.refreshCalendars();
			}
		};

		$scope.setColourBy = function (key) {
			$scope.view.colourBy = key;
			ShareData.setCalendarViewPrefs({ colourBy: key });
			renderAppointmentEvents($scope.allAppointments);
		};

		$scope.toggleStatusFilter = function (group) {
			$scope.view.status = $scope.view.status === group ? null : group;
			ShareData.setCalendarViewPrefs({ status: $scope.view.status });
			renderAppointmentEvents($scope.allAppointments);
		};

		$scope.onSearchChange = function () {
			renderAppointmentEvents($scope.allAppointments);
		};

		$scope.clearSearch = function () {
			$scope.view.search = "";
			renderAppointmentEvents($scope.allAppointments);
		};

		$scope.toggleHideEmptyColumns = function () {
			$scope.view.hideEmptyColumns = !$scope.view.hideEmptyColumns;
			ShareData.setCalendarViewPrefs({ hideEmptyColumns: $scope.view.hideEmptyColumns });
			buildTeamModel();
		};

		// Appointments or personal availability. FullCalendar sat hidden while availability was up, so it
		// is measured again on the way back.
		$scope.setCalendarView = function (calendarView) {
			$scope.uiConfig.calendarView = calendarView;
			if (calendarView === "appointment") {
				$timeout(() => withCalendarInDigest((calendar) => calendar.fullCalendar("render")), 0, false);
				$scope.refreshCalendars();
			}
		};

		$scope.dismissCalendarNotice = function () {
			$scope.calendarNotice = null;
			$scope.practiceLeaveMove = null;
		};

		/* =================================================================== */
		/* Clinician rail
		/* Ticking a clinician adds or removes them; clicking a name shows only them.
		/* =================================================================== */

		function rememberClinicianFilter() {
			ShareData.setSavedCalendarClinicians(Session.practice.id, $scope.clinicianFilter.ids, $scope.clinicianFilter.none);
		}

		// Everyone ticks every clinician; clicked again, with everyone already ticked, it unticks them all.
		$scope.toggleEveryone = function () {
			if ($scope.isEveryoneShown()) {
				showNobody();
				return;
			}
			$scope.showEveryone();
		};

		function showNobody() {
			$scope.clinicianFilter.ids = [];
			$scope.clinicianFilter.none = true;
			rememberClinicianFilter();
			if ($scope.currentSurgeon === "all") {
				renderAppointmentEvents($scope.allAppointments);
				return;
			}
			$scope.currentSurgeon = "all";
			$scope.onSurgeonChange();
		}

		$scope.showEveryone = function () {
			$scope.clinicianFilter.ids = [];
			$scope.clinicianFilter.none = false;
			rememberClinicianFilter();
			if ($scope.currentSurgeon === "all") {
				renderAppointmentEvents($scope.allAppointments);
				return;
			}
			$scope.currentSurgeon = "all";
			$scope.onSurgeonChange();
		};

		$scope.showOnlyClinician = function (clinicianId) {
			$scope.clinicianFilter.ids = [];
			$scope.clinicianFilter.none = false;
			rememberClinicianFilter();
			if (String($scope.currentSurgeon) === String(clinicianId)) {
				return;
			}
			$scope.currentSurgeon = clinicianId;
			$scope.onSurgeonChange();
		};

		$scope.toggleClinician = function (clinicianId, $event) {
			if ($event) {
				$event.stopPropagation();
			}
			const allIds = $scope.railClinicians.map((c) => String(c.id));
			let selected;
			if ($scope.currentSurgeon !== "all") {
				selected = [String($scope.currentSurgeon)];
			} else if ($scope.clinicianFilter.none) {
				selected = [];
			} else if ($scope.clinicianFilter.ids.length > 0) {
				selected = $scope.clinicianFilter.ids.map(String);
			} else {
				selected = allIds.slice();
			}

			const id = String(clinicianId);
			selected = selected.includes(id) ? selected.filter((t) => t !== id) : selected.concat(id);

			// Unticking the last one leaves nobody; ticking the last one is everyone. One is that
			// clinician's own calendar.
			if (selected.length === 0) {
				showNobody();
				return;
			}
			if (allIds.every((t) => selected.includes(t))) {
				$scope.showEveryone();
				return;
			}
			if (selected.length === 1) {
				const only = $scope.railClinicians.find((c) => String(c.id) === selected[0]);
				$scope.showOnlyClinician(only ? only.id : selected[0]);
				return;
			}

			$scope.clinicianFilter.none = false;
			$scope.clinicianFilter.ids = selected.map((t) => {
				const match = $scope.railClinicians.find((c) => String(c.id) === t);
				return match ? match.id : t;
			});
			rememberClinicianFilter();
			if ($scope.currentSurgeon !== "all") {
				// Going from one clinician to several - the one-clinician fetch has nobody else's appointments.
				$scope.currentSurgeon = "all";
				$scope.onSurgeonChange();
				return;
			}
			renderAppointmentEvents($scope.allAppointments);
		};

		$scope.isEveryoneShown = function () {
			return $scope.currentSurgeon === "all" && $scope.clinicianFilter.ids.length === 0 && !$scope.clinicianFilter.none;
		};

		$scope.clinicianNameFor = function (clinicianId) {
			const match = ($scope._ophthalmologists || []).concat($scope.ophthalmologists)
				.find((t) => String(t.value) === String(clinicianId));
			return match ? match.name : null;
		};

		/* =================================================================== */
		/* Practice rail
		/* Ticking a practice adds or removes it; clicking a name shows only it. Several ticked is the
		/* "All practices" fetch, narrowed to those ticked.
		/* =================================================================== */

		function rememberPracticeFilter() {
			ShareData.setSavedCalendarPractices(Session.practice.id, $scope.practiceFilter.ids, $scope.practiceFilter.none);
		}

		// Only practices still on offer stay ticked, and only with "All practices" fetched. Down to one or
		// covering them all, the filter is no longer narrowing anything.
		function prunePracticeFilter() {
			const offered = $scope.practiceSummaryList.filter((p) => p.id !== -1).map((p) => String(p.id));
			const isAll = $scope.currentPractice.id === -1;
			let ids = isAll ? $scope.practiceFilter.ids.filter((id) => offered.includes(String(id))) : [];
			if (ids.length <= 1 || offered.every((id) => ids.some((t) => String(t) === id))) {
				ids = [];
			}
			const none = isAll && $scope.practiceFilter.none;
			if (ids.length !== $scope.practiceFilter.ids.length || none !== $scope.practiceFilter.none) {
				$scope.practiceFilter.ids = ids;
				$scope.practiceFilter.none = none;
				rememberPracticeFilter();
			}
		}

		// The practices ticked when the calendar was last closed, if it reopened on "All practices".
		function restorePracticeFilter() {
			const saved = ShareData.savedCalendarFilters.practiceCache[Session.practice.id] || {};
			const isAll = $scope.currentPractice.id === -1;
			$scope.practiceFilter.ids = isAll ? (saved.practiceIds || []).slice() : [];
			$scope.practiceFilter.none = isAll && !!saved.noPractices;
			prunePracticeFilter();
		}

		function setPracticeFilter(ids, none) {
			$scope.practiceFilter.ids = ids;
			$scope.practiceFilter.none = none;
			rememberPracticeFilter();
			if ($scope.currentPractice.id !== -1) {
				// Going from one practice to several (or none) - the one-practice fetch has nobody else's appointments.
				$scope.currentPractice.id = -1;
				$scope.onPracticeChange();
				return;
			}
			renderAppointmentEvents($scope.allAppointments || []);
		}

		$scope.canTickPractices = function () {
			return $scope.practiceSummaryList.some((p) => p.id === -1);
		};

		$scope.isPracticeTicked = function (practiceId) {
			return $scope.currentPractice.id === -1
				? $scope.isPracticeShown(practiceId)
				: String($scope.currentPractice.id) === String(practiceId);
		};

		$scope.isEveryPracticeShown = function () {
			return $scope.currentPractice.id === -1 && $scope.practiceFilter.ids.length === 0 && !$scope.practiceFilter.none;
		};

		// "All practices" ticks every practice; clicked again, with them all already ticked, it unticks them all.
		$scope.toggleAllPractices = function () {
			setPracticeFilter([], $scope.isEveryPracticeShown());
		};

		$scope.togglePractice = function (practiceId, $event) {
			if ($event) {
				$event.stopPropagation();
			}
			const allIds = $scope.practiceSummaryList.filter((p) => p.id !== -1).map((p) => String(p.id));
			let selected = allIds.filter((id) => $scope.isPracticeTicked(id));

			const id = String(practiceId);
			selected = selected.includes(id) ? selected.filter((t) => t !== id) : selected.concat(id);

			// Unticking the last one leaves none; ticking the last one is all of them. One is that
			// practice's own calendar.
			if (selected.length === 0) {
				setPracticeFilter([], true);
				return;
			}
			if (selected.length === 1) {
				const only = $scope.practiceSummaryList.find((p) => String(p.id) === selected[0]);
				$scope.selectPractice(only ? only.id : practiceId);
				return;
			}
			setPracticeFilter(allIds.every((t) => selected.includes(t))
				? []
				: selected.map((t) => $scope.practiceSummaryList.find((p) => String(p.id) === t).id), false);
		};

		$scope.selectPractice = function (practiceId) {
			if ($scope.currentPractice.id === practiceId) {
				return;
			}
			$scope.practiceFilter.ids = [];
			$scope.practiceFilter.none = false;
			rememberPracticeFilter();
			$scope.currentPractice.id = practiceId;
			$scope.onPracticeChange();
		};

		/* =================================================================== */
		/* Mini month (rail)
		/* =================================================================== */

		$scope.miniMonth = { anchor: null, title: "", weeks: [] };

		// Runs on navigation only, so the mini month follows the main calendar without undoing the user's
		// own paging through it in between.
		function syncMiniMonth(viewStart) {
			buildMiniMonth(moment(viewStart).startOf("month"));
		}

		function buildMiniMonth(anchor) {
			const today = moment().tz($scope.resolvePracticeTimezoneName()).format("YYYY-MM-DD");
			const range = $scope.visibleRange || {};
			// Sunday first, as FullCalendar's weeks are.
			const first = anchor.clone().startOf("month").startOf("week");
			const weeks = [];
			let cursor = first.clone();
			// As many weeks as the month spans - five, sometimes four or six.
			while (weeks.length === 0 || cursor.month() === anchor.month()) {
				const week = [];
				for (let d = 0; d < 7; d++) {
					const date = cursor.format("YYYY-MM-DD");
					const holidays = holidaysOn(date);
					week.push({
						date: date,
						day: cursor.date(),
						holiday: holidays.length ? holidays.map((t) => t.label).join("; ") : null,
						inMonth: cursor.month() === anchor.month(),
						isToday: date === today,
						inView: !!range.start && date >= range.start && date < range.end,
					});
					cursor.add(1, "day");
				}
				weeks.push(week);
			}
			$scope.miniMonth = { anchor: anchor.clone(), title: anchor.locale("en").format("MMMM YYYY"), weeks: weeks };
		}

		$scope.shiftMiniMonth = function (months) {
			buildMiniMonth($scope.miniMonth.anchor.clone().add(months, "month"));
		};

		$scope.resolvePracticeTimezoneDisplay = function () {
			// Guard: require moment and moment-timezone
			if (typeof moment === "undefined" || !moment.tz) {
				return "UTC (GMT +0)";
			}

			var ianaZoneName = $scope.resolvePracticeTimezoneName();
			if (!ianaZoneName || !moment.tz.zone(ianaZoneName)) {
				return "UTC (GMT +0)";
			}

			// Use "now" so DST is reflected
			var now = moment();

			// Build a zoned moment safely
			var zonedMoment = now.clone().tz(ianaZoneName);

			// Robust abbreviation retrieval: prefer zone().abbr(ts) over format('z')
			var zoneDefinition = moment.tz.zone(ianaZoneName);
			var abbreviation = zoneDefinition ? zoneDefinition.abbr(zonedMoment.valueOf()) : null;
			if (!abbreviation || typeof abbreviation !== "string") {
				// Fallback to format('z') if abbr not available
				abbreviation = zonedMoment.format("z");
			}

			// Compute GMT offset string like +12 or +12:45
			var offsetMinutes = zonedMoment.utcOffset();
			var sign = offsetMinutes >= 0 ? "+" : "-";
			var absoluteMinutes = Math.abs(offsetMinutes);
			var hoursPart = Math.floor(absoluteMinutes / 60)
				.toString()
				.padStart(2, "0");
			var minutesPart = (absoluteMinutes % 60)
				.toString()
				.padStart(2, "0");
			var formattedOffset = minutesPart === "00" ? (sign + parseInt(hoursPart, 10)) : (sign + hoursPart + ":" + minutesPart);

			// Final user-facing string
			return (abbreviation || "GMT") + " (GMT " + formattedOffset + ")";
		};

		// Resolve a raw practice timezone (either an enum like "PACIFIC_AUCKLAND" or an
		// IANA zone like "Pacific/Auckland") to a valid IANA zone name, or null if it
		// cannot be resolved.
		function resolveTimezoneNameFromRaw(tz) {
			if (!tz) return null;

			// Try to map enum/code (e.g., "PACIFIC_AUCKLAND") → IANA using TIMEZONE_TYPE.
			var candidate = $scope.TIMEZONE_TYPE && $scope.TIMEZONE_TYPE.find(function (z) {
				return z && (z.value === tz || z.name === tz);
			});

			if (candidate) {
				if (candidate.name && moment.tz.zone(candidate.name)) return candidate.name;
				if (candidate.value && moment.tz.zone(candidate.value)) return candidate.value;
			}

			// If it wasn't an enum, check if the raw string is already a valid IANA zone.
			if (moment.tz && moment.tz.zone(tz)) {
				return tz;
			}

			return null;
		}

		$scope.resolvePracticeTimezoneName = function () {
			// Grab the current practice tz, fallback to the Session tz if it's missing.
			var tz = $scope.currentPractice.timezone || ($scope.Session && $scope.Session.practice && $scope.Session.practice.timezone);
			return resolveTimezoneNameFromRaw(tz) || 'UTC';
		};

		// Resolve the IANA timezone for a specific practice id. Used by the appointment
		// modal, where the selected practice can differ from the calendar's current
		// practice (moving an appointment between practices in different timezones).
		function getPracticeTimezoneNameById(practiceId) {
			var sources = [
				($scope.Session && $scope.Session.practiceOptions) || [],
				$scope.practiceSummaryList || [],
			];
			for (var i = 0; i < sources.length; i++) {
				var practiceMeta = sources[i].find(function (p) { return p.id === practiceId; });
				var resolved = practiceMeta && resolveTimezoneNameFromRaw(practiceMeta.timezone);
				if (resolved) return resolved;
			}
			// Fall back to the calendar's current practice timezone if the practice's
			// own timezone is missing/unresolvable.
			return $scope.resolvePracticeTimezoneName();
		}

		function getPracticeTimezoneNameForItem(item) {
			// If we are on the "All" view (-1), prefer a per-appointment practice timezone if the API provides it.
			// Fallback to the currently selected practice timezone, then to resolvePracticeTimezoneName() which already has safe guards.
			if ($scope.currentPractice.id === -1 && item.practice_timezone) {
				// `practice_timezone` should be an IANA tz like "Pacific/Auckland"
				if (moment.tz.zone(item.practice_timezone)) {
					return item.practice_timezone;
				}
			}

			// The API does not send practice_timezone, so in the "All" view look the appointment's own
			// practice up - placing it in the signed-in practice's zone put it hours out for a practice
			// in another one.
			if ($scope.currentPractice.id === -1) {
				return getPracticeTimezoneNameById(item.practice_id);
			}

			// Otherwise use whatever the current practice is set to (and let the existing resolver sanitize it)
			return $scope.resolvePracticeTimezoneName();
		}

		function updateCurrentPracticeMeta(practiceId) {
			// Try to update name/timezone from practiceSummaryList if available
			var practiceMeta = $scope.practiceSummaryList && $scope.practiceSummaryList.find(function (p) { return p.id === practiceId; });

			if (practiceMeta) {
				$scope.currentPractice.name = practiceMeta.name || $scope.currentPractice.name;

				// If your list contains timezone, set it here.
				if (practiceMeta.timezone && moment.tz.zone(practiceMeta.timezone)) {
					$scope.currentPractice.timezone = practiceMeta.timezone;
				}
			}
		}

		function refreshCalendarTimezoneNow() {
			var practiceTimezoneName = $scope.resolvePracticeTimezoneName();

			withCalendar(function (calendar) {
				calendar.fullCalendar('option', 'now', function () {
					return moment().tz(practiceTimezoneName);
				});

				// Re-render the view where it already is. This used to call 'today', which threw
				// away however far the user had paged forward or back every time they switched
				// practice or clinician. 'reinitView' redraws the current view at the same date,
				// so the now-indicator picks up the new timezone and viewRender recomputes
				// calendar_range_start/end for it, without navigating.
				calendar.fullCalendar('reinitView');
				calendar.fullCalendar('render');
			});
		}

		function toUtcIsoFromPracticeWallTime(momentLike, timezoneName) {
			var m = moment(momentLike);
			if (!m.isValid()) {
				return 'Invalid date';
			}
			var practiceTimezoneName = timezoneName || $scope.resolvePracticeTimezoneName();
			var zoned = moment.tz({
				year: m.year(),
				month: m.month(),
				date: m.date(),
				hour: m.hour(),
				minute: m.minute(),
				second: m.second(),
				millisecond: m.millisecond()
			}, practiceTimezoneName);
			return zoned.isValid() ? zoned.utc().toISOString() : 'Invalid date';
		}

		function generateTimeSlots(minTime, maxTime) {
			const slots = [];
			const interval = 5;

			let currentTime = minTime.clone();
			const endTime = maxTime;

			while (currentTime.valueOf() <= endTime.valueOf()) {
				slots.push({
					display: currentTime.locale('en').format('h:mm a'),
					value: currentTime.format('HH:mm')
				});

				currentTime.add(interval, 'minutes');
			}

			$scope.timeSlots = slots;
		}

		// Load the clinician list for the appointment's practice. The currently
		// selected clinician is kept only if they work at that practice, otherwise
		// the selection is cleared so a valid clinician must be re-picked (instead
		// of silently keeping an invalid id that still passes ng-required).
		function loadPracticeClinicians(appointment) {
			const selectedClinicianId = appointment.clinician_id;
			const requestedPracticeId = appointment.practice_id;
			$scope._ophthalmologists = [];
			return $scope.API.getAppointmentUsers(requestedPracticeId).then(
				function (resp) {
					// The practice was changed again (or another appointment opened) while this was in flight.
					if (appointment !== $scope.appointment || appointment.practice_id !== requestedPracticeId) {
						return;
					}
					$scope._ophthalmologists = resp.data
						.map(function (doc) {
							return {
								name: doc.firstName + " " + doc.lastName + `${Number(Session.userId) === doc.id ? " (Me)" : ""}`,
								value: doc.id,
								practiceSummaryList: doc.practiceSummaryList,
							};
						})
						.sort(function (a, b) {
							if (a.name < b.name) {
								return -1;
							}
							if (a.name > b.name) {
								return 1;
							}
							return 0;
						});

					appointment.clinician_id = $scope._ophthalmologists.some((t) => t.value === selectedClinicianId)
						? selectedClinicianId
						: null;
				},
				function (err) {
					console.error(err && err.status);
				},
			);
		}

		// Load (and cache per practice) the appointment-type list for the
		// appointment's practice, as the dialog's own list - the calendar's
		// appointment_categories stays the practice on screen's. The selected type is
		// kept only if it is one of that practice's: each practice has its own types,
		// under ids of their own even where the names are the same.
		//
		// practiceChanged: the user has just picked another practice, so the type is
		// cleared at once rather than when the new list arrives - otherwise the old
		// practice's type could be saved with the new practice in the meantime, or
		// for good if the list never loads.
		function loadPracticeCategories(appointment, practiceChanged) {
			const applyCategories = (categories) => {
				$scope._appointment_categories = categories || [];
				if (!$scope._appointment_categories.some((t) => t.category_id === appointment.category_id)) {
					appointment.category_id = null;
				}
			};

			if (!appointment.practice_id) {
				applyCategories([]);
				return;
			}
			const target = $scope.categoriesGroup.find((t) => t.practice === appointment.practice_id);
			if (target) {
				applyCategories(angular.copy(target.appointment_categories));
				return;
			}
			$scope._appointment_categories = [];
			if (practiceChanged) {
				appointment.category_id = null;
			}
			const requestedPracticeId = appointment.practice_id;
			return $scope.PracticeAPI.queryCalendarSetting(requestedPracticeId).then(
				function (resp) {
					const categories = angular.copy(resp.data.appointment_categories);
					$scope.categoriesGroup.push({
						practice: requestedPracticeId,
						appointment_categories: categories,
					});
					// The practice was changed again (or another appointment opened) while this was in flight.
					if (appointment !== $scope.appointment || appointment.practice_id !== requestedPracticeId) {
						return;
					}
					applyCategories(angular.copy(categories));
				},
				function (error) {
					console.error(error && error.status);
				},
			);
		}

		// USER STORY 1030
		// keepType: the practice was set along with a type chosen for it (a booking set aside while a new patient
		// was registered), rather than picked in the dialog.
		$scope.onAppointmentPracticeChange = function (appointment, keepType) {
			loadPracticeClinicians(appointment);
			loadPracticeCategories(appointment, !keepType);
			if (appointment.practice_id) {
				fetchSetting(appointment.practice_id);
			}
			// Results were labelled against the old practice - search afresh for the new one.
			if ($scope.pickingPatient) {
				$scope.patientSearch = { results: [], searched: false, loading: false };
			}
		};
	}]);